/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

// 
// Generated by @himenon/openapi-typescript-code-generator v1.0.9
// 
// OpenApi : 3.0.0
// 
// 


import { Schemas, Parameters } from "./types";
export interface RequestBody$login {
    "application/json": {
        sessions?: {
            email: string;
            password: string;
        };
    };
}
export interface Response$login$Status$200 {
    "application/json": {
        token: string;
    };
}
export interface Response$login$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$login$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Response$getCsrfToken$Status$200 {
    "application/json": {
        csrfToken: string;
    };
}
export interface Response$resendVerificationMail$Status$200 {
    "application/json": {};
}
export interface Response$fetchCurrentUser$Status$200 {
    "application/json": {
        current_user: Schemas.CurrentUser;
        target_merchant?: Schemas.Merchant;
        paid_features: Schemas.PaidFeature[];
        /** 組織管理者の代理ログイン */
        organization_proxy_signed_in: boolean;
        /** HQからの代理ログイン */
        supervisor_proxy_signed_in: boolean;
        seller?: Schemas.Seller;
        gmo_pg_merchant?: Schemas.GmoPgMerchant;
        preferred_registration_item: "none" | "business_information" | "merchant_public_id";
        current_staff: {
            canonical_id: number | null;
        } | null;
        /** 他サービス遷移時にセッションの整合性を保つために使う、ハッシュ化されたSTORESアカウントのUUID */
        u: string | null;
        features: Schemas.Features;
    };
}
export interface Response$fetchCurrentUser$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$fetchMerchantVouchers {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$fetchMerchantVouchers$Status$200 {
    "application/json": Schemas.Voucher[];
}
export interface Parameter$getVoucherAssigns {
    voucher_public_id: Parameters.voucher_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getVoucherAssigns$Status$200 {
    "application/json": Schemas.VoucherAssignmentCandidate[];
}
export interface Parameter$updateVoucherAssigns {
    voucher_public_id: Parameters.voucher_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateVoucherAssigns {
    "application/json": {
        assign_list: Schemas.VoucherAssignmentCandidate[];
    };
}
export interface Response$updateVoucherAssigns$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getMerchantReservation {
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantReservation$Status$200 {
    "application/json": {
        reservation: Schemas.Reservation;
        permission: Schemas.UserPermissions;
    };
}
export interface Parameter$updateReservation {
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateReservation {
    "application/json": {
        reservation: Schemas.ReservationUpdateParam;
    };
}
export interface Response$updateReservation$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getMerchantReservationOnlineMeeting {
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantReservationOnlineMeeting$Status$200 {
    "application/json": {
        online_meeting?: Schemas.OnlineMeeting;
        deletable: boolean;
        zoom_integration_active: boolean;
        zoom_integration_feature_enabled: boolean;
    };
}
export interface Parameter$getReservationCustomerMemos {
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getReservationCustomerMemos$Status$200 {
    "application/json": {
        customer_memos: Schemas.CustomerMemo[];
    };
}
export interface Parameter$bulkCreateReservationCheckin {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    "reservation_public_ids[]": string[];
}
export interface RequestBody$bulkCreateReservationCheckin {
    "application/json": Schemas.ReservationBulkCheckinCreateParams;
}
export interface Response$bulkCreateReservationCheckin$Status$201 {
    "application/json": Schemas.ReservationBulkCheckin;
}
export interface Response$bulkCreateReservationCheckin$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$merchantCustomersSearch {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    name?: string;
    email?: string;
    phone_number?: string;
    ids?: string;
    global_select_all?: boolean;
    search_params?: {};
    unlimited?: boolean;
}
export interface Response$merchantCustomersSearch$Status$200 {
    "application/json": {
        customers?: Schemas.Customer[];
    };
}
export interface Parameter$dashboardCustomersSearch {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** キーワード(名前・メール・電話番号・メモ) */
    keyword?: string;
    /** 予約関連の絞り込み */
    reservation?: Schemas.ReservationCondition & {
        /** 予約したことのある予約ページ */
        "resource_public_ids]["?: number[];
    };
    /** 予約者アカウント */
    "customer_invitation_status[]"?: ("registered_end_user" | "customer_invited" | "customer_uninvited")[];
    /** LINEユーザーID */
    "has_line_user[]"?: ("has_line_user" | "has_not_line_user")[];
    /** 回数券 */
    ticket_book?: Schemas.TicketBookCondition & {
        /** 有効な回数券 */
        "product_public_ids]["?: number[];
    };
    /** 月謝 */
    subscription?: Schemas.SubscriptionCondition & {
        /** 有効な月謝 */
        "product_public_ids]["?: number[];
    };
    /** 有効な月謝 */
    "subscription_public_ids[]"?: number[];
    /** チェックイン回数 */
    checked_in_count?: {
        gte?: number;
        lt?: number;
        lte?: number;
        eq?: number;
    };
    /** ページネーション */
    page?: number;
    /** 並び替え機能 */
    sort?: {
        field?: "register_date" | "last_reserved_at" | "last_checked_in_at" | "first_checked_in_at" | "first_reserved_at";
        order?: "asc" | "desc";
    };
}
export interface Response$dashboardCustomersSearch$Status$200 {
    "application/json": Schemas.DashboardCustomerSearchResult;
}
export interface Response$dashboardCustomersSearch$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$dashboardCustomersBulkDelete {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** 顧客をグローバル全選択しているか */
    global_select_all?: boolean;
    /** 顧客のpublic_idの配列 */
    "customer_public_ids[]"?: string[];
    /** キーワード(名前・メール・電話番号・メモ) */
    keyword?: string;
    /** 予約関連の絞り込み */
    reservation?: Schemas.ReservationCondition & {
        /** 予約したことのある予約ページ */
        "resource_public_ids]["?: number[];
    };
    /** 予約者アカウント */
    "customer_invitation_status[]"?: ("registered_end_user" | "customer_invited" | "customer_uninvited")[];
    /** LINEユーザーID */
    "has_line_user[]"?: ("has_line_user" | "has_not_line_user")[];
    /** 回数券 */
    ticket_book?: Schemas.TicketBookCondition & {
        /** 有効な回数券 */
        "product_public_ids]["?: number[];
    };
    /** 月謝 */
    subscription?: Schemas.SubscriptionCondition & {
        /** 有効な月謝 */
        "product_public_ids]["?: number[];
    };
    /** 有効な月謝 */
    "subscription_public_ids[]"?: number[];
    /** チェックイン回数 */
    checked_in_count?: {
        gte?: number;
        lt?: number;
        lte?: number;
        eq?: number;
    };
}
export interface Response$dashboardCustomersBulkDelete$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$dashboardCustomersBulkDelete$Status$409 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getCustomerSummaryInfo {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCustomerSummaryInfo$Status$200 {
    "application/json": Schemas.CustomerSummaryInfo;
}
export interface Parameter$getCustomerTicketBooks {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCustomerTicketBooks$Status$200 {
    "application/json": Schemas.TicketBooks;
}
export interface Response$getCustomerTicketBooks$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getCustomerTicketBooks$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getCustomerSubscriptions {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCustomerSubscriptions$Status$200 {
    "application/json": {
        customer_subscriptions: Schemas.CustomerSubscription[];
    };
}
export interface Response$getCustomerSubscriptions$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getCustomerSubscriptions$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getCustomerSummarizedReservations {
    customer_public_id: Parameters.customer_public_id;
    /** page param for pagination */
    page?: Parameters.page;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCustomerSummarizedReservations$Status$200 {
    "application/json": {
        summarized_reservations_and_checkins: Schemas.ReservationAndCheckins[];
        pagination: Schemas.PaginationData;
    };
}
export interface Response$getCustomerSummarizedReservations$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getCustomerSummarizedReservations$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getCustomerCheckinableReservations {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCustomerCheckinableReservations$Status$200 {
    "application/json": Schemas.CustomerCheckinableReservation;
}
export interface Parameter$createCustomerCheckin {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createCustomerCheckin {
    "application/json": Schemas.CustomerCheckinCreateParams;
}
export interface Response$createCustomerCheckin$Status$201 {
    "application/json": Schemas.CustomerCheckin;
}
export interface Response$createCustomerCheckin$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardListCustomerPurchases {
    customer_public_id: Parameters.customer_public_id;
    /** ページ番号 */
    page?: number;
}
export interface Response$apiDashboardListCustomerPurchases$Status$200 {
    "application/json": Schemas.ListCustomerPurchase;
}
export interface Parameter$apiDashboardMergeableCustomers {
    customer_public_id: Parameters.customer_public_id;
    /** 統合元となる顧客のpublic_id */
    "source_customer_public_ids[]": string[];
}
export interface Response$apiDashboardMergeableCustomers$Status$200 {
    "application/json": {} | null;
}
export interface Response$apiDashboardMergeableCustomers$Status$400 {
    "application/json": {
        code: "INVALID" | "NOT_TWO_OR_MORE_PROFILE_MATCH" | "BOTH_HAVE_KANTAN_YOYAKU_ACCOUNTS" | "INCLUDE_LESSON_MEMBERSHIP_CUSTOMER" | "SOURCE_CUSTOMERS_HAVE_KANTAN_YOYAKU_ACCOUNT";
    };
}
export interface Response$apiDashboardMergeableCustomers$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardMergeableCustomers$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createCustomerMerging {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createCustomerMerging {
    "application/json": {
        source_customer_public_ids: number[];
    };
}
export interface Response$createCustomerMerging$Status$200 {
    "application/json": {} | null;
}
export interface Response$createCustomerMerging$Status$400 {
    "application/json": {
        code: "INVALID" | "NOT_TWO_OR_MORE_PROFILE_MATCH" | "BOTH_HAVE_KANTAN_YOYAKU_ACCOUNTS" | "INCLUDE_LESSON_MEMBERSHIP_CUSTOMER" | "BOTH_HAS_SAME_SUBSCRIPTION" | "SOURCE_CUSTOMERS_HAVE_KANTAN_YOYAKU_ACCOUNT";
    };
}
export interface Response$createCustomerMerging$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$createCustomerMerging$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardSuggestDuplicatedCustomers {
    customer_public_id: Parameters.customer_public_id;
}
export interface Response$apiDashboardSuggestDuplicatedCustomers$Status$200 {
    "application/json": {
        /** 重複顧客候補の顧客ID。Customer#created_atが最新の1人のみが返される。将来的には複数候補返す想定なのでarrayにしている。 */
        customer_public_ids?: number[];
    };
}
export interface Parameter$getEventSchemePaymentMethodSetting {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getEventSchemePaymentMethodSetting$Status$200 {
    "application/json": Schemas.EventSchemePaymentMethodSetting;
}
export interface Parameter$updateEventSchemePaymentMethodSetting {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateEventSchemePaymentMethodSetting {
    "application/json": Schemas.EventSchemePaymentMethodSetting;
}
export interface Response$updateEventSchemePaymentMethodSetting$Status$200 {
    "application/json": {};
}
export interface Response$updateEventSchemePaymentMethodSetting$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getEventSchemePaymentMethodList {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    customer_public_id: string;
    reservation_at: string;
}
export interface Response$getEventSchemePaymentMethodList$Status$200 {
    "application/json": Schemas.EventSchemePaymentMethodList;
}
export interface Parameter$getCourseSchemePaymentMethodSetting {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCourseSchemePaymentMethodSetting$Status$200 {
    "application/json": Schemas.CourseSchemePaymentMethodSetting;
}
export interface Parameter$updateCourseSchemePaymentMethodSetting {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateCourseSchemePaymentMethodSetting {
    "application/json": Schemas.CourseSchemePaymentMethodSetting;
}
export interface Response$updateCourseSchemePaymentMethodSetting$Status$200 {
    "application/json": {};
}
export interface Response$updateCourseSchemePaymentMethodSetting$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$GetDatetimeSelectionUiType {
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$GetDatetimeSelectionUiType$Status$200 {
    "application/json": {
        /** M1/M4新予約フローの日程選択UIタイプ */
        datetime_selection_ui_type: "board" | "calendar";
    };
}
export interface Parameter$PatchDatetimeSelectionUiType {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$PatchDatetimeSelectionUiType {
    "application/json": {
        /** M1/M4新予約フローの日程選択UIタイプ */
        datetime_selection_ui_type: "board" | "calendar";
    };
}
export interface Response$PatchDatetimeSelectionUiType$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getPaymentMethodSettingOfCourse {
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getPaymentMethodSettingOfCourse$Status$200 {
    "application/json": Schemas.PaymentMethodSettingOfCourse;
}
export interface Parameter$updatePaymentMethodSettingOfCourse {
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updatePaymentMethodSettingOfCourse {
    "application/json": {
        related_customer_subscriptions: Schemas.RelatedCustomerSubscription[];
        related_ticket_books: Schemas.RelatedTicketBook[];
        /** 基本価格 (現地決済金額) */
        price: number | null;
        /** クレジットカード価格 */
        prepayment_price: number | null;
    };
}
export interface Response$updatePaymentMethodSettingOfCourse$Status$200 {
    "application/json": {};
}
export interface Response$updatePaymentMethodSettingOfCourse$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getPaymentMethodListsOfCourse {
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    customer_public_id: string;
    reservation_at: string;
}
export interface Response$getPaymentMethodListsOfCourse$Status$200 {
    "application/json": Schemas.PaymentMethodListsOfCourse;
}
export interface Parameter$getMerchantEquipmentList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    page?: number;
    size?: number;
}
export interface Response$getMerchantEquipmentList$Status$200 {
    "application/json": Schemas.ListEquipment;
}
export interface Parameter$editMerchantEquipment {
    equipment_id: Parameters.equipment_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$editMerchantEquipment {
    "application/json": {
        name: string;
        quantity: number;
    };
}
export interface Response$editMerchantEquipment$Status$200 {
    "application/json": Schemas.Equipment;
}
export interface Response$editMerchantEquipment$Status$422 {
    "application/json": {};
}
export interface Parameter$getEquipmentReservations {
    equipment_id: Parameters.equipment_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    start: string;
    end: string;
}
export interface Response$getEquipmentReservations$Status$200 {
    "application/json": Schemas.ReservationEvent[];
}
export interface Response$getEquipmentReservations$Status$422 {
    "application/json": {};
}
export interface Parameter$getEquipmentGoogleCalendarSync {
    equipment_id: Parameters.equipment_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getEquipmentGoogleCalendarSync$Status$200 {
    "application/json": Schemas.EquipmentGoogleCalendarSync;
}
export interface Parameter$updateEquipmentGoogleCalendarSync {
    equipment_id: Parameters.equipment_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateEquipmentGoogleCalendarSync {
    "application/json": {
        google_calendar_id: string | null;
    };
}
export interface Response$updateEquipmentGoogleCalendarSync$Status$200 {
    "application/json": Schemas.EquipmentGoogleCalendarSync;
}
export interface Response$updateEquipmentGoogleCalendarSync$Status$400 {
    "application/json": {};
}
export interface Parameter$getMerchantEquipmentAll {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantEquipmentAll$Status$200 {
    "application/json": Schemas.Equipment[];
}
export interface Parameter$getEquipmentBlocks {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getEquipmentBlocks$Status$200 {
    "application/json": {
        data: Schemas.EquipmentBlock[];
    };
}
export interface Response$getProducts$Status$200 {
    "application/json": Schemas.Products;
}
export interface Parameter$getReservations {
    start: string;
    end: string;
    /** csrf-token */
    "X-Csrf-Token": string;
}
export interface Response$getReservations$Status$200 {
    "application/json": Schemas.ReservationEvent[];
}
export interface Parameter$getCalendarStaffNonServiceTimes {
    target_date: string;
}
export interface Response$getCalendarStaffNonServiceTimes$Status$200 {
    "application/json": Schemas.StaffNonServiceTime;
}
export interface Response$getCalendarStaffNonServiceTimes$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getCalendarStaffNonServiceTimes$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getGoogleCalendarsCalendarWithEquipment {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** page param for pagination */
    page?: Parameters.page;
    /** size param for pagination */
    size?: Parameters.size;
}
export interface Response$getGoogleCalendarsCalendarWithEquipment$Status$200 {
    "application/json": Schemas.ListGoogleCalendarWithEquipment;
}
export interface Parameter$createGoogleCalendar {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createGoogleCalendar {
    "application/json": {
        name: string;
    };
}
export interface Response$createGoogleCalendar$Status$200 {
    "application/json": Schemas.GoogleCalendar;
}
export interface Parameter$getResourceDetail {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getResourceDetail$Status$200 {
    "application/json": Schemas.ResourceDetail;
}
export interface Response$getResourceDetail$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getMerchantResourcesCourses {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantResourcesCourses$Status$200 {
    "application/json": Schemas.Course[];
}
export interface Response$getMerchantResourcesCourses$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createCourse {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createCourse {
    "multipart/form-data": Schemas.CourseParams;
}
export interface Response$createCourse$Status$200 {
    "application/json": Schemas.Course;
}
export interface Response$createCourse$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$fetchCourseDetail {
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$fetchCourseDetail$Status$200 {
    "application/json": Schemas.Course;
}
export interface Response$fetchCourseDetail$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateCourse {
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateCourse {
    "multipart/form-data": Schemas.CourseParams;
}
export interface Response$updateCourse$Status$200 {
    "application/json": Schemas.Course;
}
export interface Response$updateCourse$Status$422 {
    "application/json": {};
}
export interface Parameter$getResourceCustomerFields {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getResourceCustomerFields$Status$200 {
    "application/json": Schemas.ResourceCustomerFieldBinder[];
}
export interface Parameter$sortResourcesCustomerFields {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$sortResourcesCustomerFields {
    /** ids of resource-customer-field */
    "application/json": {
        binder_field_ids: number[];
    };
}
export interface Response$sortResourcesCustomerFields$Status$422 {
    "application/json": {};
}
export interface Parameter$updateResourcesCustomerFields {
    /** resource_customer_field_binders.id */
    field_binder_id: Parameters.field_binder_id;
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateResourcesCustomerFields {
    "application/json": Schemas.FieldBinderParam;
}
export interface Response$updateResourcesCustomerFields$Status$200 {
    "application/json": Schemas.ResourceCustomerFieldBinder;
}
export interface Parameter$getMerchantOptionsList {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    is_published?: boolean;
}
export interface Response$getMerchantOptionsList$Status$200 {
    "application/json": (Schemas.Option & Schemas.Deletable)[];
}
export interface Parameter$createOption {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createOption {
    "application/json": {
        name: string;
        description?: string;
        duration_in_minutes?: number;
        price?: number;
    };
    "application/xml": {};
}
export interface Parameter$createOfflineReservation {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createOfflineReservation {
    "application/json": Schemas.CreateOfflineReservationParams;
}
export interface Response$createOfflineReservation$Status$200 {
    "application/json": {};
}
export interface Response$createOfflineReservation$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$createOfflineReservation$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createDuplicationRequest {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createDuplicationRequest {
    "application/json": {
        duplication_request: {
            /** 複製先の予約ページ名 */
            dest_resource_name: string;
        };
    };
}
export interface Response$createDuplicationRequest$Status$201 {
    "application/json": {};
}
export interface Response$createDuplicationRequest$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteResourcesOption {
    resource_public_id: Parameters.resource_public_id;
    option_id: Parameters.option_id;
}
export interface Parameter$updateResourcesOption {
    resource_public_id: Parameters.resource_public_id;
    option_id: Parameters.option_id;
    /** csrf-token */
    "X-Csrf-Token": string;
}
export interface RequestBody$updateResourcesOption {
    "application/json": {
        name?: string;
        description?: string;
        duration_in_minutes?: number;
        price?: number;
    };
}
export interface Response$updateResourcesOption$Status$200 {
    "application/json": Schemas.Option;
}
export interface Parameter$getTimeSlotResources {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** page param for pagination */
    page?: Parameters.page;
    /** size param for pagination */
    size?: Parameters.size;
    /** resource publish status */
    publish_status?: "published" | "unpublished" | "unpublished_all";
    /** specify the resource name to be searched */
    name?: string;
}
export interface Response$getTimeSlotResources$Status$200 {
    "application/json": Schemas.TimeSlotResources;
}
export interface Parameter$getCourseResources {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** page param for pagination */
    page?: Parameters.page;
    /** size param for pagination */
    size?: Parameters.size;
    /** resource publish status */
    publish_status?: "published" | "unpublished" | "unpublished_all";
    /** specify the resource name to be searched */
    name?: string;
}
export interface Response$getCourseResources$Status$200 {
    "application/json": Schemas.CourseResources;
}
export interface Parameter$getCourseResourceTimeUnit {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCourseResourceTimeUnit$Status$200 {
    "application/json": Schemas.CourseResourceTimeUnit;
}
export interface Parameter$updateCourseResourceTimeUnit {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateCourseResourceTimeUnit {
    "application/json": Schemas.CourseResourceTimeUnit;
}
export interface Response$updateCourseResourceTimeUnit$Status$200 {
    "application/json": {};
}
export interface Response$updateCourseResourceTimeUnit$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$listCourseOption {
    course_public_id: Parameters.course_public_id;
}
export interface Response$listCourseOption$Status$200 {
    "application/json": Schemas.Option[];
}
export interface Parameter$getMonthlyAvailabilities {
    course_public_id: Parameters.course_public_id;
    staff_canonical_id?: number;
    option_ids?: number[];
    month?: string;
    extra_availability?: boolean;
}
export interface Response$getMonthlyAvailabilities$Status$200 {
    "application/json": Schemas.MonthlyAvailabilities;
}
export interface Parameter$sendAccessLog {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$sendAccessLog {
    "application/json": {
        path: string;
    };
}
export interface Parameter$getMerchantRepresentative {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantRepresentative$Status$200 {
    "application/json": {
        /** corporation or individual */
        business_form?: string | null;
        corporation_name?: string | null;
        legal_form_id?: number | null;
        first_name?: string | null;
        last_name?: string | null;
        first_name_kana?: string | null;
        last_name_kana?: string | null;
        /** yyyy-mm-dd */
        birthday?: string | null;
        corporation_full_name?: string | null;
    } | null;
}
export interface Parameter$patchMMerchantRepresentatives {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$patchMMerchantRepresentatives {
    "application/json": Schemas.MerchantRepresentative;
}
export interface Parameter$getTimeSlots {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    start_at: string;
    end_at: string;
    filter_type?: "no_reservation";
    resource_public_ids?: string;
    with_waiting_list?: boolean;
    with_assigned_staff_members?: boolean;
    includes_school_scheme_slots?: boolean;
}
export interface Response$getTimeSlots$Status$200 {
    "application/json": Schemas.TimeSlot[];
}
export interface Parameter$getReservationsPerTimeSlot {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** time_slotsテーブルのprimarykey */
    time_slot_id: Parameters.time_slot_id;
    proto: string;
    page?: number;
}
export interface Response$getReservationsPerTimeSlot$Status$200 {
    "application/json": {
        reservations: {
            reservation: Schemas.Reservation;
            permission: Schemas.UserPermissions;
        }[];
        pagination: Schemas.PaginationData;
    };
}
export interface Parameter$getMerchantResourcesScheduledPriceSettings {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantResourcesScheduledPriceSettings$Status$200 {
    "application/json": Schemas.ScheduledPriceSettingsResponse[];
}
export interface Response$getMerchantResourcesScheduledPriceSettings$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$postMerchantResourcesScheduledPriceSettings {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$postMerchantResourcesScheduledPriceSettings {
    "application/json": {
        settings?: Schemas.ScheduledPriceSettingBulkParams[];
    };
}
export interface Response$postMerchantResourcesScheduledPriceSettings$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservablePeriod {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getReservablePeriod$Status$200 {
    "application/json": Schemas.ReservablePeriod;
}
export interface Parameter$patchReservablePeriod {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$patchReservablePeriod {
    "application/json": {
        start_period?: Schemas.ReservablePeriodStart;
        end_period?: Schemas.ReservablePeriodEnd;
    };
}
export interface Response$patchReservablePeriod$Status$200 {
    "application/json": Schemas.ReservablePeriod;
}
export interface Response$patchReservablePeriod$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$patchReservablePeriod$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteTimeSlot {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    time_slot_id: number;
}
export interface Parameter$fetchSellerDetail {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$fetchSellerDetail$Status$200 {
    "application/json": {
        name: string | null;
        business_form: string;
        /** 事業者情報で申請するかどうか */
        apply_with_maja_business_entity_detail: boolean;
        plans: Schemas.Plan[];
        /** クレジットカード連携済みかどうか */
        is_identified: boolean;
        /** 事業者情報,口座情報の表示/非表示 */
        is_secret_info_visible: boolean;
        /** 事業者情報,口座情報が表示の時に返す情報 */
        seller_secret_info: {} | null;
    };
}
export interface Response$fetchSellerDetail$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateSellerDetail {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateSellerDetail {
    "multipart/form-data": {
        account?: Schemas.SellerUpdateParams;
    };
}
export interface Response$updateSellerDetail$Status$200 {
    "application/json": {};
}
export interface Response$updateSellerDetail$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getLineMiniAppStatus {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getLineMiniAppStatus$Status$200 {
    "application/json": {
        status: ("not_reviewed" | "reviewing" | "approved" | "rejected" | "paused") | null;
        line_mini_app_url: string | null;
        is_credit_card_registered: boolean;
        applied_at: string | null;
        premium_plan_payment_method: "invoice" | "credit_card" | "not_paid";
        merchant_name: string | null;
        merchant_address: string | null;
    };
}
export interface Parameter$submitLineMiniAppExamination {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$submitLineMiniAppExamination {
    "multipart/form-data": {
        webSiteUrl: string;
        applicantFirstName: string;
        applicantLastName: string;
        applicantEmail: string;
        applicantPhoneNumber: string;
        companyOrStoreName: string;
        postalCode: string;
        address: string;
        iconImage: string;
        lineMiniAppNameJa: string;
        lineMiniAppNameEn: string;
        descriptionJa: string;
        descriptionEn: string;
        lineMiniAppContactEmail: string;
        taxId?: string;
        businessCertificateImage?: string;
        identityDocumentFront?: string;
        identityDocumentBack?: string;
    };
}
export interface Response$submitLineMiniAppExamination$Status$200 {
    "application/json": {};
}
export interface Response$submitLineMiniAppExamination$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getEndUserReservationLimit {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getEndUserReservationLimit$Status$200 {
    "application/json": Schemas.EndUserReservationLimit;
}
export interface Parameter$updateEndUserReservationLimitation {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateEndUserReservationLimitation {
    "application/json": {
        limited: boolean;
        upcoming_reservation_count_limit: number;
    };
}
export interface Response$updateEndUserReservationLimitation$Status$200 {
    "application/json": {};
}
export interface Response$updateEndUserReservationLimitation$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$transferSchedule {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$transferSchedule$Status$200 {
    "application/json": Schemas.TransferSchedule;
}
export interface Response$transferSchedule$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$payoutSchedule {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$payoutSchedule$Status$200 {
    "application/json": Schemas.PayoutSchedule;
}
export interface Response$payoutSchedule$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$payoutList {
    /** page param for pagination */
    page?: Parameters.page;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$payoutList$Status$200 {
    "application/json": Schemas.PayoutList;
}
export interface Response$payoutList$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$expectedPayoutList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$expectedPayoutList$Status$200 {
    "application/json": Schemas.ExpectedPayoutList;
}
export interface Response$expectedPayoutList$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$downloadPayout {
    stripe_payout_id: Parameters.stripe_payout_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$downloadPayout {
    "application/json": {
        type: "reservations" | "products";
        encoding: "sjis" | "utf-8";
    };
}
export interface Response$downloadPayout$Status$200 {
    "application/json": {};
}
export interface Response$downloadPayout$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$downloadExpectedPayout {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$downloadExpectedPayout {
    "application/json": {
        expected_payout_date?: string;
        type: "reservations" | "products";
        encoding: "sjis" | "utf-8";
    };
}
export interface Response$downloadExpectedPayout$Status$200 {
    "application/json": {};
}
export interface Response$downloadExpectedPayout$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getDashboardCalendarSetting$Status$200 {
    "application/json": Schemas.DashboardCalendarSetting;
}
export interface Parameter$updateDashboardCalendarSetting {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateDashboardCalendarSetting {
    "application/json": Schemas.DashboardCalendarSetting;
}
export interface Response$updateDashboardCalendarSetting$Status$200 {
    "application/json": {};
}
export interface Response$updateDashboardCalendarSetting$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getGoogleAnalyticsFour {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getGoogleAnalyticsFour$Status$200 {
    "application/json": Schemas.GoogleAnalyticsFour;
}
export interface Response$getGoogleAnalyticsFour$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteGoogleAnalyticsFour {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$deleteGoogleAnalyticsFour$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateGoogleAnalyticsFour {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateGoogleAnalyticsFour {
    "application/json": Schemas.GoogleAnalyticsFour;
}
export interface Response$updateGoogleAnalyticsFour$Status$200 {
    "application/json": Schemas.GoogleAnalyticsFour;
}
export interface Response$updateGoogleAnalyticsFour$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$updateGoogleAnalyticsFour$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    with_deleted?: boolean;
}
export interface Response$getStaffList$Status$200 {
    "application/json": Schemas.Staff[];
}
export interface Parameter$createNewStaff {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    with_deleted?: boolean;
}
export interface RequestBody$createNewStaff {
    "application/json": {
        staff?: Schemas.StaffUpdateParams;
    };
}
export interface Response$createNewStaff$Status$200 {
    "application/json": {};
}
export interface Response$createNewStaff$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffManagementLimitReached {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getStaffManagementLimitReached$Status$200 {
    "application/json": {
        is_staff_management_limit_reached: boolean;
    };
}
export interface Parameter$bulkDeleteStaff {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$bulkDeleteStaff {
    "application/json": Schemas.BulkDeleteStaffParams;
}
export interface Response$bulkDeleteStaff$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffDailySchedulesList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    /** ページネーション */
    page?: number;
    /** 対象年 */
    year?: number;
    /** 対象月 */
    month?: number;
    /** 絞り込み対象スタッフID */
    "staff_canonical_id[]"?: number[];
    /** かんざし連携中のスタッフのみ */
    kanzashi_synced_staff?: boolean;
}
export interface Response$getStaffDailySchedulesList$Status$200 {
    "application/json": Schemas.MerchantStaffDailyScheduleList;
}
export interface Response$getStaffDailySchedulesList$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$bulkUpdateStaffDailySchedule {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    staff_canonical_id: Parameters.staff_canonical_id;
}
export interface RequestBody$bulkUpdateStaffDailySchedule {
    "application/json": Schemas.BulkUpdateStaffDailySchedule;
}
export interface Response$bulkUpdateStaffDailySchedule$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$bulkUpdateStaffDailySchedule$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffMonthlySchedules {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    staff_canonical_id: Parameters.staff_canonical_id;
    /** 対象年(yyyy) */
    year: string;
    /** 対象月(mm) */
    month: string;
}
export interface Response$getStaffMonthlySchedules$Status$200 {
    "application/json": Schemas.MerchantStaffMonthlySchedules;
}
export interface Response$getStaffMonthlySchedules$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffWorkingHour {
    staff_canonical_id: Parameters.staff_canonical_id;
}
export interface Response$getStaffWorkingHour$Status$200 {
    "application/json": Schemas.StaffWorkingHour;
}
export interface Response$getStaffWorkingHour$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getStaffWorkingHour$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffListForStaffDailySchedule {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getStaffListForStaffDailySchedule$Status$200 {
    "application/json": Schemas.StaffList;
}
export interface Parameter$getStaffDailyScheduleHintDisplayHistoryCreatability {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    staff_canonical_id: Parameters.staff_canonical_id;
}
export interface Response$getStaffDailyScheduleHintDisplayHistoryCreatability$Status$200 {
    "application/json": Schemas.StaffDailyScheduleHintDisplayHistoryCreatability;
}
export interface Parameter$createStaffDailyScheduleHintDisplayHistory {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    staff_canonical_id: Parameters.staff_canonical_id;
}
export interface Response$createStaffDailyScheduleHintDisplayHistory$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$createStaffDailyScheduleHintDisplayHistory$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStaffCourseAssignersList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    staff_canonical_id: Parameters.staff_canonical_id;
}
export interface Response$getStaffCourseAssignersList$Status$200 {
    "application/json": Schemas.StaffCourseAssigners;
}
export interface Response$getStaffCourseAssignersList$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getQrSelfCheckinImage {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getQrSelfCheckinImage$Status$200 {
    "image/png": string;
}
export interface Parameter$createEventDefaultStaffAssignment {
    resource_public_id: Parameters.resource_public_id;
    staff_canonical_id: Parameters.staff_canonical_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$createEventDefaultStaffAssignment$Status$201 {
    "application/json": {};
}
export interface Response$createEventDefaultStaffAssignment$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteEventDefaultStaffAssignment {
    resource_public_id: Parameters.resource_public_id;
    staff_canonical_id: Parameters.staff_canonical_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$deleteEventDefaultStaffAssignment$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getEventDefaultStaffAssignments {
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getEventDefaultStaffAssignments$Status$200 {
    "application/json": {
        staff_canonical_id: number;
    }[];
}
export interface Parameter$getAllCourseStaffAssignments {
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getAllCourseStaffAssignments$Status$200 {
    "application/json": {
        staff: {
            id?: number;
            canonical_id?: number;
            name: string;
        }[];
    };
}
export interface Response$getAllCourseStaffAssignments$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getAllCourseStaffAssignments$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$putResourceOnboardingTodo {
    resource_public_id: Parameters.resource_public_id;
}
export interface RequestBody$putResourceOnboardingTodo {
    "application/json": Schemas.PutResourceOnboardingTodoParams;
}
export interface Response$putResourceOnboardingTodo$Status$200 {
    "application/json": {};
}
export interface Response$putResourceOnboardingTodo$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$putResourceOnboardingTodo$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$putResourceRecommendedSettingVisibility {
    resource_public_id: Parameters.resource_public_id;
}
export interface RequestBody$putResourceRecommendedSettingVisibility {
    "application/json": Schemas.PutResourceRecommendedSettingParams;
}
export interface Response$putResourceRecommendedSettingVisibility$Status$200 {
    "application/json": {};
}
export interface Response$putResourceRecommendedSettingVisibility$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$putResourceRecommendedSettingVisibility$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$patchResourceArchive {
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$patchResourceArchive$Status$200 {
    "application/json": {};
}
export interface Response$patchResourceArchive$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getMerchantSetting {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantSetting$Status$200 {
    "application/json": {
        current_auto_checkin: boolean;
    };
}
export interface Parameter$updateMerchantSetting {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateMerchantSetting {
    "application/json": {
        auto_checkin_enabled: boolean;
    };
}
export interface Response$updateMerchantSetting$Status$200 {
    "application/json": {};
}
export interface Response$updateMerchantSetting$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateMerchantSiteVisibility {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateMerchantSiteVisibility {
    "application/json": {
        status: "published" | "unpublished";
    };
}
export interface Response$updateMerchantSiteVisibility$Status$200 {
    "application/json": {};
}
export interface Response$updateMerchantSiteVisibility$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getSiteDetail {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getSiteDetail$Status$200 {
    "application/json": Schemas.Site;
}
export interface Parameter$updateSiteDetail {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateSiteDetail {
    "application/json": Schemas.SiteUpdateParams;
}
export interface Response$updateSiteDetail$Status$200 {
    "application/json": Schemas.Site;
}
export interface Response$updateSiteDetail$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$updateSiteDetail$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$putSitePublicId {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$putSitePublicId {
    "application/json": {
        site_public_id: {
            public_id: string;
        };
    };
}
export interface Response$putSitePublicId$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$uploadImage {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$uploadImage {
    "multipart/form-data": {
        /** 画像ファイル */
        image: string;
    };
}
export interface Response$uploadImage$Status$200 {
    "application/json": {
        /** uploadした画像のIDを署名したもの */
        signed_tmp_image_id: string;
    };
}
export interface Response$uploadImage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$uploadImage$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Response$uploadImage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getCategories {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCategories$Status$200 {
    "application/json": Schemas.Category[];
}
export interface Parameter$getTemporaryDates {
    type: Schemas.TemporaryDateType;
    start_date?: string;
    end_date?: string;
}
export interface Response$getTemporaryDates$Status$200 {
    "application/json": {
        temporary_dates: Schemas.TemporaryDate[];
    };
}
export interface Parameter$createTemporaryDate {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createTemporaryDate {
    "application/json": Schemas.TemporaryDate;
}
export interface Response$createTemporaryDate$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getTemporaryDate {
    temporary_date_id: Parameters.temporary_date_id;
}
export interface Response$getTemporaryDate$Status$200 {
    "application/json": {
        temporary_date: Schemas.TemporaryDate;
    };
}
export interface Parameter$deleteTemporaryDate {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    temporary_date_id: Parameters.temporary_date_id;
}
export interface Response$deleteTemporaryDate$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$editTemporaryDate {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    temporary_date_id: Parameters.temporary_date_id;
}
export interface RequestBody$editTemporaryDate {
    "application/json": Schemas.TemporaryDate;
}
export interface Response$editTemporaryDate$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$duplicationStatus {
    /** resource scheme */
    scheme?: "time_slot" | "course";
}
export interface Response$duplicationStatus$Status$200 {
    "application/json": Schemas.ResourceDuplicationStatus;
}
export interface Response$duplicationStatus$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getPublishedResourcesCount$Status$200 {
    "application/json": Schemas.PublishedResourcesCount;
}
export interface Response$getOnboardingTodo$Status$200 {
    "application/json": Schemas.OnboardingTodo;
}
export interface RequestBody$putOnboardingTodo {
    "application/json": Schemas.PutOnboardingTodoParams;
}
export interface Response$putOnboardingTodo$Status$200 {
    "application/json": {};
}
export interface Response$putOnboardingTodo$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$putOnboardingTodo$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getGoogleConnect$Status$200 {
    "application/json": Schemas.GoogleConnect;
}
export interface Response$getInquiryFormAutoFill$Status$200 {
    "application/json": Schemas.InquiryFormAutoFill;
}
export interface Response$getUpgrades$Status$200 {
    "application/json": {
        /** セルフUGが可能かどうか */
        can_upgrade_by_self: boolean;
    };
}
export interface Parameter$putUsageTips {
    usage_tips_type: Parameters.usage_tips_type;
}
export interface Response$putUsageTips$Status$200 {
    "application/json": {};
}
export interface Response$getCustomerAttributeDefinitions$Status$200 {
    "application/json": {
        attribute_definitions: Schemas.CustomerAttributeDefinition[];
    };
}
export interface Parameter$createCustomer {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createCustomer {
    "application/json": {
        customer: {
            email: string | null;
            phone_number: string | null;
            memo: string | null;
            name: string;
            name_kana?: string | null;
        };
        invite: boolean;
    };
}
export interface Response$createCustomer$Status$200 {
    "application/json": {
        public_id: number;
    };
}
export interface Response$createCustomer$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$triggerCsvExport {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$triggerCsvExport {
    "application/json": Schemas.CustomerCsvExportRequest;
}
export interface Response$triggerCsvExport$Status$200 {
    "application/json": {};
}
export interface Response$triggerCsvExport$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$customersCsvImportRequest {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$customersCsvImportRequest {
    "application/json": Schemas.CustomerCsvImportRequest;
}
export interface Response$customersCsvImportRequest$Status$200 {
    "application/json": {};
}
export interface Response$customersCsvImportRequest$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getTicketBookProducts$Status$200 {
    "application/json": Schemas.TicketBookProducts;
}
export interface Response$getSubscriptionProducts$Status$200 {
    "application/json": Schemas.SubscriptionProducts;
}
export interface Parameter$dashboardCustomerInvitation {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$dashboardCustomerInvitation {
    "application/json": Schemas.CustomerInvitationRequest;
}
export interface Response$dashboardCustomerInvitation$Status$200 {
    "application/json": {};
}
export interface Response$dashboardCustomerInvitation$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createCustomerMemo {
    customer_public_id: Parameters.customer_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createCustomerMemo {
    "application/json": Schemas.CustomerMemoCreateParams;
}
export interface Response$createCustomerMemo$Status$201 {
    "application/json": Schemas.CustomerMemo;
}
export interface Response$createCustomerMemo$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getCustomerMemo {
    customer_public_id: Parameters.customer_public_id;
    customer_memo_id: Parameters.customer_memo_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getCustomerMemo$Status$200 {
    "application/json": Schemas.CustomerMemo;
}
export interface Parameter$deleteCustomerMemos {
    customer_public_id: Parameters.customer_public_id;
    customer_memo_id: Parameters.customer_memo_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Parameter$updateCustomerMemo {
    customer_public_id: Parameters.customer_public_id;
    customer_memo_id: Parameters.customer_memo_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateCustomerMemo {
    "application/json": Schemas.CustomerMemoUpdateParams;
}
export interface Response$updateCustomerMemo$Status$200 {
    "application/json": Schemas.CustomerMemo;
}
export interface Response$updateCustomerMemo$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getMerchantDashboardAnalyticsQuery {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    id: string;
    start_on: string;
    end_on: string;
    "resource_public_ids[]"?: string[];
    "ticket_book_public_ids[]"?: string[];
    "subscription_public_ids[]"?: string[];
    "payment_methods[]"?: ("事前クレジットカード決済" | "現地払い" | "クーポン")[];
    "payment_statuses[]"?: ("決済済み" | "返金")[];
}
export interface Response$getMerchantDashboardAnalyticsQuery$Status$200 {
    "application/json": Schemas.AnalyticsQuery;
}
export interface Parameter$downloadMerchantDashboardAnalyticsQuerySjisCsv {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    id: string;
    start_on: string;
    end_on: string;
    "resource_public_ids[]"?: string[];
    "ticket_book_public_ids[]"?: string[];
    "subscription_public_ids[]"?: string[];
    "payment_methods[]"?: ("事前クレジットカード決済" | "現地払い" | "クーポン")[];
    "payment_statuses[]"?: ("決済済み" | "返金")[];
}
export interface Response$downloadMerchantDashboardAnalyticsQuerySjisCsv$Status$200 {
}
export interface Response$getMerchantDashboardBusinessInformation$Status$200 {
    "application/json": Schemas.BusinessInformation;
}
export interface Parameter$updateMerchantDashboardBusinessInformation {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateMerchantDashboardBusinessInformation {
    "application/json": {
        representative: {
            type: "corporation";
            legal_form_id: number;
            corporation_name: string;
            contact_name: string;
        } | {
            type: "individual";
            last_name: string;
            last_name_kana: string;
            first_name: string;
            first_name_kana: string;
            birthday: string;
            business_name: string;
            /** プラットフォーム連携後は個人の場合も入力を求めるようになった、プラットフォーム連携時の登録ではrequired */
            contact_name?: string;
        };
        admin_phone_number: string;
        merchant_category_id: number;
        merchant_subcategory_id?: number | null;
        monthly_reservation_count?: number | null;
        store_count: "not_opened" | "one" | "from_2_to_4" | "from_5_to_9" | "more_than_10" | "no_store";
        staff_count?: number | null;
    };
}
export interface Response$updateMerchantDashboardBusinessInformation$Status$200 {
    "application/json": Schemas.BusinessInformation;
}
export interface Response$updateMerchantDashboardBusinessInformation$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getMerchantDashboardDefaultBusinessInformation {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getMerchantDashboardDefaultBusinessInformation$Status$200 {
    "application/json": Schemas.DefaultBusinessInformation;
}
export interface Parameter$patchMerchantPublicId {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$patchMerchantPublicId {
    "application/json": {
        public_id: string;
    };
}
export interface Response$patchMerchantPublicId$Status$409 {
    "application/json": Schemas.APIError;
}
export interface Response$patchMerchantPublicId$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getBillings {
    target_date: string;
}
export interface Response$getBillings$Status$200 {
    "application/json": {
        billings: Schemas.Billing[];
    };
}
export interface Parameter$getOfflineReservationResourceTimeSlots {
    resource_public_id: Parameters.resource_public_id;
    /** 日程を取得したい月の日付 */
    date?: string;
    /** 最も近い予約可能枠をもつ月の日程を取得するかどうか */
    nearest_available_time_slots_required?: string;
}
export interface Response$getOfflineReservationResourceTimeSlots$Status$200 {
    "application/json": Schemas.OfflineReservationResourceTimeSlotList;
}
export interface Response$getOfflineReservationResourceTimeSlots$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$getKanzashiIntegrationProgress$Status$200 {
    "application/json": Schemas.KanzashiIntegrationProgress;
}
export interface Parameter$updateKanzashiIntegrationProgress {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateKanzashiIntegrationProgress {
    "application/json": Schemas.KanzashiIntegrationProgressUpdateParams;
}
export interface Response$updateKanzashiIntegrationProgress$Status$200 {
    "application/json": Schemas.KanzashiIntegrationProgress;
}
export interface Response$updateKanzashiIntegrationProgress$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$updateKanzashiIntegrationProgress$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getKanzashiBusinessInformationRequest$Status$200 {
    "application/json": Schemas.BusinessInformationRequest;
}
export interface Response$getKanzashiBusinessInformationRequest$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createKanzashiBusinessInformationRequest {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createKanzashiBusinessInformationRequest {
    "application/json": Schemas.BusinessInformationRequestParams;
}
export interface Response$createKanzashiBusinessInformationRequest$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createKanzashiIntegrationResourceRequest {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createKanzashiIntegrationResourceRequest {
    "application/json": Schemas.KanzashiIntegrationResourceRequest;
}
export interface Response$createKanzashiIntegrationResourceRequest$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$createKanzashiIntegrationResourceRequest$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getKanzashiHmacForSignIn$Status$200 {
    "application/json": {
        salon_id: number;
        until_time: string;
        hmac: string;
        sign_in_url: string;
        integration_type: "hair" | "kirei";
    };
}
export interface Response$getKanzashiHmacForSignIn$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getKanzashiAcceptableCountSetting$Status$200 {
    "application/json": Schemas.KanzashiAcceptableCountSetting;
}
export interface Parameter$updateKanzashiAcceptableCountSetting {
    /** csrf-token */
    "X-Csrf-Token": string;
}
export interface RequestBody$updateKanzashiAcceptableCountSetting {
    "application/json": Schemas.KanzashiAcceptableCountSetting;
}
export interface Response$updateKanzashiAcceptableCountSetting$Status$200 {
    "application/json": Schemas.KanzashiAcceptableCountSetting;
}
export interface Response$updateKanzashiAcceptableCountSetting$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getKanzashiExcludeStaffMembers$Status$200 {
    "application/json": Schemas.KanzashiSyncableStaffMember;
}
export interface Parameter$bulkCreateKanzashiSyncableStaffMembers {
    /** csrf-token */
    "X-Csrf-Token": string;
}
export interface RequestBody$bulkCreateKanzashiSyncableStaffMembers {
    "application/json": Schemas.KanzashiSyncableStaffMemberParams;
}
export interface Response$bulkCreateKanzashiSyncableStaffMembers$Status$201 {
    "application/json": Schemas.KanzashiSyncableStaffMember;
}
export interface Response$bulkCreateKanzashiSyncableStaffMembers$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$bulkCreateKanzashiSyncableStaffMembers$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$bulkDeleteKanzashiSyncableStaffMembers {
    /** csrf-token */
    "X-Csrf-Token": string;
}
export interface RequestBody$bulkDeleteKanzashiSyncableStaffMembers {
    "application/json": Schemas.KanzashiSyncableStaffMemberParams;
}
export interface Response$bulkDeleteKanzashiSyncableStaffMembers$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$merchantDashboardSettingGetNotification$Status$200 {
    "application/json": Schemas.MerchantNotification;
}
export interface Parameter$merchantDashboardSettingUpdateNotification {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$merchantDashboardSettingUpdateNotification {
    "application/json": {
        /** STORES 予約 からのメールマガジンを受け取るか */
        newsletter_subscription: boolean;
    };
}
export interface Response$merchantDashboardSettingUpdateNotification$Status$200 {
    "application/json": Schemas.MerchantNotification;
}
export interface Parameter$merchantBulkMesssageBundleQuota {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$merchantBulkMesssageBundleQuota$Status$200 {
    "application/json": Schemas.BulkMessageQuota;
}
export interface Parameter$fetchMerchantsInfoAboutSubscriptionProduct {
    subscription_product_id: Parameters.subscription_product_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$fetchMerchantsInfoAboutSubscriptionProduct$Status$200 {
    "application/json": {
        product: {
            name: string;
        };
        merchants_related_to_organization_product: Schemas.MerchantRelatedToOrganizationProduct[];
    };
}
export interface Parameter$fetchMerchantsInfoAboutTicketBookProduct {
    ticket_book_product_id: Parameters.ticket_book_product_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$fetchMerchantsInfoAboutTicketBookProduct$Status$200 {
    "application/json": {
        product: {
            name: string;
        };
        merchants_related_to_organization_product: Schemas.MerchantRelatedToOrganizationProduct[];
    };
}
export interface Parameter$publishSubscriptionProduct {
    subscription_product_id: Parameters.subscription_product_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$publishSubscriptionProduct {
    "application/json": Schemas.MerchantPublishParam;
}
export interface Response$publishSubscriptionProduct$Status$200 {
    "application/json": {};
}
export interface Response$publishSubscriptionProduct$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$publishTicketBookProduct {
    ticket_book_product_id: Parameters.ticket_book_product_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$publishTicketBookProduct {
    "application/json": Schemas.MerchantPublishParam;
}
export interface Response$publishTicketBookProduct$Status$200 {
    "application/json": {};
}
export interface Response$publishTicketBookProduct$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getOrganizationDashboardAnalyticsQuery {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    id: string;
    start_on: string;
    end_on: string;
    "target_merchant_public_ids[]"?: string[];
    "resource_public_ids[]"?: string[];
    "ticket_book_public_ids[]"?: string[];
    "subscription_public_ids[]"?: string[];
    "payment_methods[]"?: ("事前クレジットカード決済" | "現地払い" | "クーポン")[];
    "payment_statuses[]"?: ("決済済み" | "返金")[];
}
export interface Response$getOrganizationDashboardAnalyticsQuery$Status$200 {
    "application/json": Schemas.AnalyticsQuery;
}
export interface Parameter$downloadOrganizationDashboardAnalyticsQuerySjisCsv {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    id: string;
    start_on: string;
    end_on: string;
    "target_merchant_public_ids[]"?: string[];
    "resource_public_ids[]"?: string[];
    "ticket_book_public_ids[]"?: string[];
    "subscription_public_ids[]"?: string[];
    "payment_methods[]"?: ("事前クレジットカード決済" | "現地払い" | "クーポン")[];
    "payment_statuses[]"?: ("決済済み" | "返金")[];
}
export interface Response$downloadOrganizationDashboardAnalyticsQuerySjisCsv$Status$200 {
}
export interface Parameter$getOrganizationDashboardMerchants {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    enabled_feature?: "analytics";
}
export interface Response$getOrganizationDashboardMerchants$Status$200 {
    "application/json": {
        data: Schemas.OrganizationMerchant[];
    };
}
export interface Parameter$getOrganizationDashboardResourceSelectors {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    include_unpublished?: boolean;
}
export interface Response$getOrganizationDashboardResourceSelectors$Status$200 {
    "application/json": {
        resource_selectors: Schemas.ResourceSelector[];
    };
}
export interface Parameter$getOrganizationDashboardProducts {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getOrganizationDashboardProducts$Status$200 {
    "application/json": Schemas.Products;
}
export interface Response$fetchCurrentEndUser$Status$200 {
    "application/json": {
        current_end_user: Schemas.CurrentEndUser;
    };
}
export interface Response$fetchCurrentEndUser$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$postUserCheckin {
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$postUserCheckin$Status$200 {
    "application/json": {};
}
export interface Response$postUserCheckin$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$fetchUserReservations {
    merchant_public_id: string;
    start_at?: string;
    end_at?: string;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$fetchUserReservations$Status$200 {
    "application/json": Schemas.UserReservation[];
}
export interface Parameter$createPaymentMethod {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createPaymentMethod {
    "application/json": {
        seti_code?: string;
        mulpay_token?: string;
        /** クレジットカードの登録を行うクライアントの種別 */
        client_type?: "merchant_web" | "user_dashboard";
    };
}
export interface Response$createPaymentMethod$Status$201 {
    "application/json": {
        /** GmoPgでのクレジット登録での3DS認証を行うためのredirect url */
        gmo_pg_redirect_url: string | null;
        /** GmoPgから発行されるアクセスID。認証後のカード登録確定時に利用する */
        gmo_pg_access_id: string | null;
    };
}
export interface Parameter$setupPaymentMethod {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$setupPaymentMethod$Status$200 {
    "application/json": {
        client_secret?: string;
    };
}
export interface Parameter$confirmPaymentMethod {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$confirmPaymentMethod {
    "application/json": {
        gmo_pg_access_id: string;
    };
}
export interface RequestBody$updateUsersMeLocale {
    "application/json": {
        locale: "ja" | "en" | "ko";
    };
}
export interface Parameter$getMerchantDetail {
    merchant_public_id: Parameters.merchant_public_id;
}
export interface Response$getMerchantDetail$Status$200 {
    "application/json": Schemas.MerchantEntity;
}
export interface Response$getMerchantDetail$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationStats {
    email?: string;
    merchant_public_id: string;
}
export interface Response$getReservationStats$Status$200 {
    "application/json": Schemas.ReservationStatsEntity;
}
export interface Parameter$getBookingPageDetail {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getBookingPageDetail$Status$200 {
    "application/json": Schemas.BookingPageEntity;
}
export interface Parameter$getBookingCalendarMeta {
    merchant_public_id: Parameters.merchant_public_id;
}
export interface Response$getBookingCalendarMeta$Status$200 {
    "application/json": Schemas.BookingCalendarMetaEntity;
}
export interface Parameter$getVoucherList {
    merchant_public_id: Parameters.merchant_public_id;
}
export interface Response$getVoucherList$Status$200 {
    "application/json": Schemas.VouchersEntity;
}
export interface Parameter$getVoucherDetail {
    merchant_public_id: Parameters.merchant_public_id;
    voucher_public_id: Parameters.voucher_public_id;
}
export interface Response$getVoucherDetail$Status$200 {
    "application/json": Schemas.PublicVoucherWithAssignedContentEntity;
}
export interface Parameter$getMerchantProduct {
    merchant_public_id: string;
    product_public_id: string;
}
export interface Response$getMerchantProduct$Status$200 {
    "application/json": Schemas.Product;
}
export interface Parameter$getMerchantProductFirstCharge {
    merchant_public_id: string;
    product_public_id: string;
}
export interface Response$getMerchantProductFirstCharge$Status$200 {
    "application/json": Schemas.ProductFirstCharge;
}
export interface Parameter$getLineMiniAppMeta {
    merchant_public_id: Parameters.merchant_public_id;
}
export interface Response$getLineMiniAppMeta$Status$200 {
    "application/json": Schemas.LineMiniAppMeta;
}
export interface Response$getLineMiniAppMeta$Status$404 {
    "application/json": {};
}
export interface Response$getReservationFlowMe$Status$200 {
    "application/json": Schemas.ReservationFlowMe;
}
export interface Parameter$verifyReservationFlowResource {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$verifyReservationFlowResource {
    "application/json": {
        password: string;
    };
}
export interface Parameter$getReservationFlowMerchantOptIn {
    merchant_public_id: Parameters.merchant_public_id;
}
export interface Response$getReservationFlowMerchantOptIn$Status$200 {
    "application/json": {
        gmo_pg_order_enabled: boolean;
    };
}
export interface Parameter$getReservationFlowMerchantReservationStats {
    merchant_public_id: Parameters.merchant_public_id;
    email?: string;
}
export interface Response$getReservationFlowMerchantReservationStats$Status$200 {
    "application/json": {
        is_first_time_reservation: boolean;
    };
}
export interface Parameter$getReservationFlowEventSchemeTimeSlots {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    year?: number;
    month?: number;
}
export interface Response$getReservationFlowEventSchemeTimeSlots$Status$200 {
    "application/json": {
        time_slots: Schemas.ReservationFlowEventSchemeTimeSlot[];
        is_all: boolean;
        waiting_list_time_slot_ids: number[];
        unavailability_reason_for_reservation_and_waiting_list: ("all_time_slots_full" | "no_time_slots") | null;
    };
}
export interface Parameter$getReservationFlowEventSchemeTimeSlot {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    /** time_slotsテーブルのprimarykey */
    time_slot_id: Parameters.time_slot_id;
}
export interface Response$getReservationFlowEventSchemeTimeSlot$Status$200 {
    "application/json": (Schemas.ReservationFlowEventSchemeTimeSlot) | null;
}
export interface Response$getReservationFlowEventSchemeTimeSlot$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationFlowEventSchemeResource {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowEventSchemeResource$Status$200 {
    "application/json": Schemas.EventSchemeResource;
}
export interface Parameter$getReservationFlowCustomFields {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowCustomFields$Status$200 {
    "application/json": {
        customer_fields: Schemas.ReservationFlowEventSchemeCustomerFieldItem[];
        questionnaire_fields: Schemas.ReservationFlowEventSchemeQuestionnaireFieldItem[];
    };
}
export interface Parameter$getReservationFlowVersion {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowVersion$Status$200 {
    "application/json": {
        reservation_flow_version: "v1" | "v2";
    };
}
export interface Parameter$getReservationFlowMetaInfo {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowMetaInfo$Status$200 {
    "application/json": {
        resource_name: string;
        resource_description_text: string;
        thumbnail_url: string | null;
        favicon_image_url: string | null;
        available_google_analytics_four_tracking_id: string | null;
    };
}
export interface Parameter$getReservationFlowEventSchemePaymentMethodList {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    email?: string;
}
export interface Response$getReservationFlowEventSchemePaymentMethodList$Status$200 {
    "application/json": Schemas.ReservationFlowPaymentMethodList;
}
export interface Parameter$validateReservationFlowEventSchemeReservationFormData {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$validateReservationFlowEventSchemeReservationFormData {
    "application/json": {
        resource_public_id: number;
        selected_time_slot_ids: number[];
        num_attendees: number;
        customer_field_values: {
            key: string;
            value: string | number;
        }[];
        questionnaire_field_values: {
            id: number;
            value: string | number | string[];
        }[];
        payment_method: (Schemas.ReservationFlowPaymentMethodSubscriptionParam | Schemas.ReservationFlowPaymentMethodTicketBookParam | Schemas.ReservationFlowPaymentMethodOnsiteParam | Schemas.ReservationFlowPaymentMethodCreditCardParam | Schemas.ReservationFlowPaymentMethodFirstTimeFreeVoucherParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithStripeParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithGmoPgParam | Schemas.ReservationFlowPaymentMethodOnfilePrepaymentWithGmoPgParam) | null;
    };
}
export interface Response$validateReservationFlowEventSchemeReservationFormData$Status$200 {
    "application/json": {};
}
export interface Response$validateReservationFlowEventSchemeReservationFormData$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$finalizeReservationFlowEventSchemeReservationWithFormData {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$finalizeReservationFlowEventSchemeReservationWithFormData {
    "application/json": {
        resource_public_id: number;
        selected_time_slot_ids: number[];
        num_attendees: number;
        customer_field_values: {
            key: string;
            value: string | number;
        }[];
        questionnaire_field_values: {
            id: number;
            value: string | number | string[];
        }[];
        payment_method: (Schemas.ReservationFlowPaymentMethodSubscriptionParam | Schemas.ReservationFlowPaymentMethodTicketBookParam | Schemas.ReservationFlowPaymentMethodOnsiteParam | Schemas.ReservationFlowPaymentMethodCreditCardParam | Schemas.ReservationFlowPaymentMethodFirstTimeFreeVoucherParam) | null;
        line_access_token: string | null;
        line_id_token?: string | null;
        booked_from: string | null;
    };
}
export interface Response$finalizeReservationFlowEventSchemeReservationWithFormData$Status$200 {
    "application/json": {
        reservation_public_id: number;
        customer_public_id: number;
        reservation_token: string;
        google_calendar_template_url: string;
    };
}
export interface Response$finalizeReservationFlowEventSchemeReservationWithFormData$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$holdReservationFlowEventSchemeReservationWithFormData {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$holdReservationFlowEventSchemeReservationWithFormData {
    "application/json": {
        resource_public_id: number;
        selected_time_slot_ids: number[];
        num_attendees: number;
        customer_field_values: {
            key: string;
            value: string | number;
        }[];
        questionnaire_field_values: {
            id: number;
            value: string | number | string[];
        }[];
        payment_method: Schemas.ReservationFlowPaymentMethodPrepaymentWithStripeParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithGmoPgParam | Schemas.ReservationFlowPaymentMethodOnfilePrepaymentWithGmoPgParam;
        line_access_token: string | null;
        line_id_token?: string | null;
        booked_from: string | null;
    };
}
export interface Response$holdReservationFlowEventSchemeReservationWithFormData$Status$200 {
    "application/json": {
        reservation_public_id: number;
        customer_public_id: number;
        reservation_token: string;
        /** 支払い方法がStripeによる事前決済の場合、Payment Intentのクライアントシークレット */
        stripe_client_secret: string | null;
        /** 支払い方法がGMO PGによる事前決済の場合に利用する3DS認証先のURL */
        gmo_pg_redirect_url: string | null;
    };
}
export interface Response$holdReservationFlowEventSchemeReservationWithFormData$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$holdReservationFlowEventSchemeReservationWithFormData$Status$429 {
    "application/json": Schemas.APIError;
}
export interface Response$holdReservationFlowEventSchemeReservationWithFormData$Status$502 {
    "application/json": Schemas.APIError;
}
export interface Parameter$notifyConfirmedPrepaymentForReservationFlowEventScheme {
    merchant_public_id: Parameters.merchant_public_id;
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$notifyConfirmedPrepaymentForReservationFlowEventScheme {
    "application/json": {
        /** 最後に使用したカードとして保存するかどうか。Stripeの場合は値は利用されず、必ずfalse扱いになります */
        save_as_last_used?: boolean;
    };
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$200 {
    "application/json": {
        reservation_public_id: number;
        customer_public_id: number;
        reservation_token: string;
        google_calendar_template_url: string;
    };
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$429 {
    "application/json": Schemas.APIError;
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$502 {
    "application/json": Schemas.APIError;
}
export interface Parameter$validateReservationFlowCourseSchemeReservationFormData {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$validateReservationFlowCourseSchemeReservationFormData {
    "application/json": {
        resource_public_id: number;
        customer_field_values: {
            key: string;
            value: string | number;
        }[];
        questionnaire_field_values: {
            id: number;
            value: string | number | string[];
        }[];
        selected_date: string;
        selected_course_public_id: number;
        selected_option_ids: number[];
        selected_staff_public_id: number | null;
        payment_method: (Schemas.ReservationFlowPaymentMethodSubscriptionParam | Schemas.ReservationFlowPaymentMethodTicketBookParam | Schemas.ReservationFlowPaymentMethodOnsiteParam | Schemas.ReservationFlowPaymentMethodCreditCardParam | Schemas.ReservationFlowPaymentMethodFirstTimeFreeVoucherParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithStripeParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithGmoPgParam | Schemas.ReservationFlowPaymentMethodOnfilePrepaymentWithGmoPgParam) | null;
    };
}
export interface Response$validateReservationFlowCourseSchemeReservationFormData$Status$200 {
    "application/json": {};
}
export interface Response$validateReservationFlowCourseSchemeReservationFormData$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$validateReservationFlowCourseSchemeReservationFormData$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationFlowCourseSchemeCourses {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowCourseSchemeCourses$Status$200 {
    "application/json": {
        courses: Schemas.ReservationFlowCourseSchemeCourse[];
    };
}
export interface Parameter$getReservationFlowCourseSchemeStaffMembers {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowCourseSchemeStaffMembers$Status$200 {
    "application/json": {
        staff_members: Schemas.ReservationFlowStaffMember[];
    };
}
export interface Parameter$finalizeReservationFlowCourseSchemeReservationFormData {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$finalizeReservationFlowCourseSchemeReservationFormData {
    "application/json": {
        resource_public_id: number;
        customer_field_values: {
            key: string;
            value: string | number;
        }[];
        questionnaire_field_values: {
            id: number;
            value: string | number | string[];
        }[];
        selected_date: string;
        selected_course_public_id: number;
        selected_option_ids: number[];
        selected_staff_public_id: number | null;
        payment_method: (Schemas.ReservationFlowPaymentMethodSubscriptionParam | Schemas.ReservationFlowPaymentMethodTicketBookParam | Schemas.ReservationFlowPaymentMethodOnsiteParam | Schemas.ReservationFlowPaymentMethodCreditCardParam | Schemas.ReservationFlowPaymentMethodFirstTimeFreeVoucherParam) | null;
        line_access_token: string | null;
        line_id_token?: string | null;
        booked_from: string | null;
    };
}
export interface Response$finalizeReservationFlowCourseSchemeReservationFormData$Status$200 {
    "application/json": {
        reservation_public_id: number;
        customer_public_id: number;
        reservation_token: string;
        google_calendar_template_url: string;
    };
}
export interface Response$finalizeReservationFlowCourseSchemeReservationFormData$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$holdReservationFlowCourseSchemeReservationFormData {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$holdReservationFlowCourseSchemeReservationFormData {
    "application/json": {
        resource_public_id: number;
        customer_field_values: {
            key: string;
            value: string | number;
        }[];
        questionnaire_field_values: {
            id: number;
            value: string | number | string[];
        }[];
        selected_date: string;
        selected_course_public_id: number;
        selected_option_ids: number[];
        selected_staff_public_id: number | null;
        payment_method: Schemas.ReservationFlowPaymentMethodPrepaymentWithStripeParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithGmoPgParam | Schemas.ReservationFlowPaymentMethodOnfilePrepaymentWithGmoPgParam;
        line_access_token: string | null;
        line_id_token?: string | null;
        booked_from: string | null;
    };
}
export interface Response$holdReservationFlowCourseSchemeReservationFormData$Status$200 {
    "application/json": {
        reservation_public_id: number;
        customer_public_id: number;
        reservation_token: string;
        /** 支払い方法がStripeによる事前決済の場合、Payment Intentのクライアントシークレット */
        stripe_client_secret: string | null;
        /** 支払い方法がGMO PGによる事前決済の場合に利用する3DS認証先のURL */
        gmo_pg_redirect_url: string | null;
    };
}
export interface Response$holdReservationFlowCourseSchemeReservationFormData$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$holdReservationFlowCourseSchemeReservationFormData$Status$429 {
    "application/json": Schemas.APIError;
}
export interface Response$holdReservationFlowCourseSchemeReservationFormData$Status$502 {
    "application/json": Schemas.APIError;
}
export interface Parameter$notifyConfirmedPrepaymentForReservationFlowCourseScheme {
    merchant_public_id: Parameters.merchant_public_id;
    reservation_public_id: Parameters.reservation_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$notifyConfirmedPrepaymentForReservationFlowCourseScheme {
    "application/json": {
        /** 最後に使用したカードとして保存するかどうか。Stripeの場合は値は利用されず、必ずfalse扱いになります */
        save_as_last_used?: boolean;
    };
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$200 {
    "application/json": {
        reservation_public_id: number;
        customer_public_id: number;
        reservation_token: string;
        google_calendar_template_url: string;
    };
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$429 {
    "application/json": Schemas.APIError;
}
export interface Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$502 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationFlowCourseSchemePaymentMethodList {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    email?: string;
    option_ids?: string[];
}
export interface Response$getReservationFlowCourseSchemePaymentMethodList$Status$200 {
    "application/json": Schemas.ReservationFlowPaymentMethodList;
}
export interface Response$getReservationFlowCourseSchemePaymentMethodList$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getReservationFlowCourseSchemePaymentMethodList$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationFlowCourseSchemeResource {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
}
export interface Response$getReservationFlowCourseSchemeResource$Status$200 {
    "application/json": Schemas.CourseSchemeResource;
}
export interface Parameter$getReservationFlowCourseSchemeAvailabilityBoard {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    selected_date?: string;
    staff_id?: number;
    option_ids?: string[];
    without_staff_appointment?: boolean;
}
export interface Response$getReservationFlowCourseSchemeAvailabilityBoard$Status$200 {
    "application/json": {
        dates: Schemas.CourseSchemeAvailabilityBoardDate[];
        time_unit: number;
    };
}
export interface Parameter$getReservationFlowCourseSchemeAvailabilityCalendarIndex {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    selected_date?: string;
    /** M4の時のみ有効 */
    staff_id?: number;
    option_ids?: string[];
    /** M4の時のみ有効、staff_idと排他 */
    without_staff_appointment?: boolean;
}
export interface Response$getReservationFlowCourseSchemeAvailabilityCalendarIndex$Status$200 {
    "application/json": {
        dates: {
            start_at: string;
        }[];
    };
}
export interface Parameter$getReservationFlowCourseSchemeAvailabilityCalendarTimes {
    merchant_public_id: Parameters.merchant_public_id;
    resource_public_id: Parameters.resource_public_id;
    course_public_id: Parameters.course_public_id;
    selected_date: string;
    /** M4の時のみ有効 */
    staff_id?: number;
    option_ids?: string[];
    /** M4の時のみ有効、staff_idと排他 */
    without_staff_appointment?: boolean;
}
export interface Response$getReservationFlowCourseSchemeAvailabilityCalendarTimes$Status$200 {
    "application/json": {
        times: {
            start_at: string;
        }[];
    };
}
export interface Parameter$showReservationDetailForReservationFlowEventScheme {
    reservation_public_id: Parameters.reservation_public_id;
}
export interface Response$showReservationDetailForReservationFlowEventScheme$Status$200 {
    "application/json": {
        /** 支払い方法が設定されていない場合はnull */
        payment_method: (Schemas.ReservationFlowPaymentMethodDetail) | null;
        time_slot_id: number;
        number_of_attendees: number;
        customer_email: string;
    };
}
export interface Response$showReservationDetailForReservationFlowEventScheme$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$showReservationDetailForReservationFlowCourseScheme {
    reservation_public_id: Parameters.reservation_public_id;
}
export interface Response$showReservationDetailForReservationFlowCourseScheme$Status$200 {
    "application/json": {
        /** 予約の際に選択されたコースのID */
        course_canonical_id: number;
        /** 支払い方法が設定されていない場合はnull */
        payment_method: (Schemas.ReservationFlowPaymentMethodDetail) | null;
        date_time: string;
        customer_email: string;
        /** 予約に加えられたオプション (オプションなしの場合は空配列) */
        option_ids: number[];
        /** 担当スタッフがいればそのスタッフのcanonicalID。いなければnullになる */
        staff_canonical_id: number | null;
    };
}
export interface Response$showReservationDetailForReservationFlowCourseScheme$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$userReservationGuestSessions {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$userReservationGuestSessions {
    "application/json": {
        reservation_public_id: number;
        email: string;
        reservation_token: string;
    };
}
export interface Parameter$userTimeSlotWaitingGuestSessions {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$userTimeSlotWaitingGuestSessions {
    "application/json": {
        email: string;
        time_slot_waiting_fingerprint: string;
    };
}
export interface Response$userTimeSlotWaitingGuestSessions$Status$201 {
    "application/json": {};
}
export interface Response$userTimeSlotWaitingGuestSessions$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$userReservationTokenVerifications {
    reservation_token: Parameters.reservation_token;
}
export interface Response$userReservationTokenVerifications$Status$200 {
    "application/json": {
        is_valid_token: boolean;
        is_registered_as_coubic_user: boolean;
    };
}
export interface Parameter$userTimeSlotWaitingFingerprintVerifications {
    fingerprint: Parameters.fingerprint;
}
export interface Response$userTimeSlotWaitingFingerprintVerifications$Status$200 {
    "application/json": {
        is_valid_fingerprint: boolean;
        is_registered_as_coubic_user: boolean;
    };
}
export interface Parameter$purchaseReservationFlowSubscription {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$purchaseReservationFlowSubscription {
    "application/json": {
        product_public_id: number;
        payment_method: {
            type: "credit_card" | "stripe_payment_method";
            stripe_credit_card_token: string | null;
            is_restore_credit_card: boolean;
        };
        customer_fields: {
            id: number;
            value: string | number;
        }[];
    };
}
export interface Response$purchaseReservationFlowSubscription$Status$200 {
    "application/json": Schemas.ReservationFlowCustomerSubscriptionDetail;
}
export interface Response$purchaseReservationFlowSubscription$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$startReservationFlowSubscriptionPurchase {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$startReservationFlowSubscriptionPurchase {
    "application/json": {
        product_public_id: number;
        customer_fields: {
            id: number;
            value: string | number;
        }[];
        payment_method: Schemas.ReservationFlowPaymentMethodPrepaymentWithStripeParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithGmoPgParam | Schemas.ReservationFlowPaymentMethodOnfilePrepaymentWithGmoPgParam;
    };
}
export interface Response$startReservationFlowSubscriptionPurchase$Status$200 {
    "application/json": {
        stripe_client_secret: string;
        product_issuance_id: string;
        /** 支払い方法がGMO PGによる決済の場合に利用する3DS認証先のURL */
        gmo_pg_redirect_url: string | null;
    };
}
export interface Response$startReservationFlowSubscriptionPurchase$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$notifyConfirmedReservationFlowSubscription {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$notifyConfirmedReservationFlowSubscription {
    "application/json": {
        product_issuance_id: string;
        save_as_last_used?: boolean;
    };
}
export interface Response$notifyConfirmedReservationFlowSubscription$Status$200 {
    "application/json": Schemas.ReservationFlowCustomerSubscriptionDetail;
}
export interface Response$notifyConfirmedReservationFlowSubscription$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationFlowCustomerSubscriptionReservationAvailableCount {
    merchant_public_id: Parameters.merchant_public_id;
    customer_subscription_public_id: Parameters.customer_subscription_public_id;
    checkin: string;
}
export interface Response$getReservationFlowCustomerSubscriptionReservationAvailableCount$Status$200 {
    "application/json": {
        /** 制限を設定していない時はnull */
        monthly: number | null;
        /** 制限を設定していない時はnull */
        weekly: number | null;
        /** 制限を設定していない時はnull */
        daily: number | null;
        /** 制限を設定していない時はnull */
        upcoming: number | null;
        details: Schemas.CustomerSubscriptionAvailableCount[];
    };
}
export interface Parameter$startTicketBookPurchase {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$startTicketBookPurchase {
    "application/json": {
        product_public_id: number;
        customer_fields: {
            id: number;
            value: string | number;
        }[];
        payment_method: Schemas.ReservationFlowPaymentMethodPrepaymentWithStripeParam | Schemas.ReservationFlowPaymentMethodPrepaymentWithGmoPgParam | Schemas.ReservationFlowPaymentMethodOnfilePrepaymentWithGmoPgParam;
    };
}
export interface Response$startTicketBookPurchase$Status$200 {
    "application/json": {
        stripe_client_secret: string;
        product_issuance_id: string;
        /** 支払い方法がGMO PGによる決済の場合に利用する3DS認証先のURL */
        gmo_pg_redirect_url: string | null;
    };
}
export interface Response$startTicketBookPurchase$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$notifyConfirmedTicketBookPurchase {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$notifyConfirmedTicketBookPurchase {
    "application/json": {
        product_issuance_id: string;
        save_as_last_used?: boolean;
    };
}
export interface Response$notifyConfirmedTicketBookPurchase$Status$200 {
    "application/json": Schemas.ReservationFlowTicketBookDetail;
}
export interface Response$notifyConfirmedTicketBookPurchase$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getReservationFlowTicketBookReservationAvailableCount {
    merchant_public_id: Parameters.merchant_public_id;
    ticket_book_public_id: Parameters.ticket_book_public_id;
    checkin: string;
}
export interface Response$getReservationFlowTicketBookReservationAvailableCount$Status$200 {
    "application/json": {
        /** 制限を設定していない時はnull */
        weekly: number | null;
        /** 制限を設定していない時はnull */
        daily: number | null;
        /** 制限を設定していない時はnull */
        upcoming: number | null;
    };
}
export interface Parameter$getReservationFlowProduct {
    merchant_public_id: Parameters.merchant_public_id;
    product_public_id: Parameters.product_public_id;
}
export interface Response$getReservationFlowProduct$Status$200 {
    "application/json": Schemas.ReservationFlowProductDetail;
}
export interface Parameter$postReservationFlowProductVerify {
    merchant_public_id: Parameters.merchant_public_id;
    product_public_id: Parameters.product_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$postReservationFlowProductVerify {
    "application/json": {
        password: string;
    };
}
export interface Response$postReservationFlowProductVerify$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$postReservationFlowMerchantThrottle {
    merchant_public_id: Parameters.merchant_public_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Parameter$apiDashboardCreateBillingRequest {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$apiDashboardCreateBillingRequest {
    "application/json": {
        bill_request_form: Schemas.BillingRequest;
        /** プラン名 */
        plan_name: string;
        /** キャンペーンコード(ex. business_10off_cii) */
        campaign_code?: string | null;
    };
}
export interface Response$apiDashboardCreateBillingRequest$Status$200 {
    "application/json": {};
}
export interface Response$apiDashboardCreateBillingRequest$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardCreateBillingRequest$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardCreateBillingRequest$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getBlockByOtherMerchantsReservations {
    start_at: string;
    end_at: string;
}
export interface Response$getBlockByOtherMerchantsReservations$Status$200 {
    "application/json": {
        blocks: Schemas.BlockByOtherMerchantReservation[];
    };
}
export interface Response$getLineMessageUsage$Status$200 {
    "application/json": Schemas.LineMessageUsage;
}
export interface Response$getLineMessageUsage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageUsage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageUsage$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$getMessageUsage$Status$200 {
    "application/json": Schemas.MessageUsage;
}
export interface Response$getMessageUsage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getMessageUsage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getMessageUsage$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$uploadLineMessageImage {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$uploadLineMessageImage {
    "multipart/form-data": {
        /** 個別uploadする画像 */
        image: string;
    };
}
export interface Response$uploadLineMessageImage$Status$201 {
    "application/json": {
        uuid: string;
    };
}
export interface Response$uploadLineMessageImage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$uploadLineMessageImage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$uploadLineMessageImage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getLineMessages {
    page?: number;
    status?: string;
}
export interface Response$getLineMessages$Status$200 {
    "application/json": {
        messages: Schemas.LineMessageListItem[];
        pagination: Schemas.PaginationData;
    };
}
export interface Response$getLineMessages$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessages$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessages$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createLineMessage {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createLineMessage {
    "application/json": Schemas.LineMessageCreateParams;
}
export interface Response$createLineMessage$Status$200 {
    "application/json": {
        /** line_messageのid */
        line_message_id: number;
    };
}
export interface Response$createLineMessage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$createLineMessage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$createLineMessage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deliverLineMessage {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    line_message_id: Parameters.line_message_id;
}
export interface RequestBody$deliverLineMessage {
    "application/json": Schemas.LineMessageDeliverParams;
}
export interface Response$deliverLineMessage$Status$200 {
    "application/json": {};
}
export interface Response$deliverLineMessage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$deliverLineMessage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$deliverLineMessage$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$deliverLineMessage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getLineMessage {
    line_message_id: Parameters.line_message_id;
}
export interface Response$getLineMessage$Status$200 {
    "application/json": Schemas.LineMessageDetail;
}
export interface Response$getLineMessage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessage$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteDraftLineMessage {
    line_message_id: Parameters.line_message_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$deleteDraftLineMessage$Status$200 {
    /** 削除されたline_message */
    "application/json": {
        /** line_messageのid */
        id: number;
        /** line_messageのタイトル */
        title: string;
    };
}
export interface Response$deleteDraftLineMessage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$deleteDraftLineMessage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$deleteDraftLineMessage$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$deleteDraftLineMessage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateDraftLineMessage {
    line_message_id: Parameters.line_message_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateDraftLineMessage {
    "application/json": Schemas.LineMessageDraftParams;
}
export interface Response$updateDraftLineMessage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$updateDraftLineMessage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$updateDraftLineMessage$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$updateDraftLineMessage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getLineMessageRecipientCandidates {
    line_message_id: Parameters.line_message_id;
}
export interface Response$getLineMessageRecipientCandidates$Status$200 {
    "application/json": Schemas.LineMessageRecipientCandidate[];
}
export interface Response$getLineMessageRecipientCandidates$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageRecipientCandidates$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageRecipientCandidates$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getLineMessageRecipients {
    line_message_id: Parameters.line_message_id;
    page?: number;
}
export interface Response$getLineMessageRecipients$Status$200 {
    "application/json": Schemas.LineMessageRecipientList;
}
export interface Response$getLineMessageRecipients$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageRecipients$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageRecipients$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$lineMessagingAPIChannelSecretVerification {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$lineMessagingAPIChannelSecretVerification {
    "application/json": {
        /** LINE Messaging APIのチャンネルシークレット */
        channel_secret: string;
        /** LINE Messaging APIのチャンネルID */
        channel_id: string;
    };
}
export interface Response$lineMessagingAPIChannelSecretVerification$Status$200 {
    "application/json": {
        /** LINE Messaging APIのチャンネルシークレットが有効かどうか */
        is_valid: boolean;
        /** LINE Messaging APIのチャンネル名 */
        channel_display_name?: string;
        /** ボットのBasic ID */
        basic_id?: string;
    };
}
export interface Response$lineMessagingAPIChannelSecretVerification$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageChannelSecret$Status$200 {
    "application/json": {
        /** LINE Messaging APIのチャンネルシークレット */
        channel_secret: string | null;
        /** LINE Messaging APIのチャンネルID */
        channel_id: string | null;
    };
}
export interface Response$getLineMessageChannelSecret$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessageChannelSecret$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteLineMessageChannelSecret {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$deleteLineMessageChannelSecret$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$lineMessagingAPIChannelSecretRegistration {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$lineMessagingAPIChannelSecretRegistration {
    "application/json": {
        /** LINE Messaging APIのチャンネルシークレット */
        channel_secret: string;
        /** LINE Messaging APIのチャンネルID */
        channel_id: string;
    };
}
export interface Response$lineMessagingAPIChannelSecretRegistration$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$lineMessagingAPIChannelSecretRegistration$Status$422 {
    "application/json": Schemas.APIError;
}
export interface RequestBody$createOrUpdateTester {
    "application/json": {
        /** テスターとして登録するLINEのユーザーID */
        line_user_id: string;
    };
}
export interface Response$createOrUpdateTester$Status$200 {
    "application/json": {};
}
export interface Response$createOrUpdateTester$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$createOrUpdateTester$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessagingApiAvailability$Status$200 {
    "application/json": Schemas.LineMessagingApiAvailability;
}
export interface Response$getLineMessagingApiAvailability$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessagingApiAvailability$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessagingApiIntegrationStatus$Status$200 {
    "application/json": Schemas.LineMessagingApiIntegrationStatus;
}
export interface Response$getLineMessagingApiIntegrationStatus$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessagingApiChannelInfo$Status$200 {
    "application/json": Schemas.LineMessagingApiChannelInfo;
}
export interface Response$getLineMessagingApiChannelInfo$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getLineMessagingApiChannelInfo$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardListOperableShops {
    /** page param for pagination */
    page?: Parameters.page;
    /** size param for pagination */
    size?: Parameters.size;
}
export interface Response$apiDashboardListOperableShops$Status$200 {
    "application/json": Schemas.OperableShopList;
}
export interface Parameter$apiDashboardListShops {
    /** page param for pagination */
    page?: Parameters.page;
    /** size param for pagination */
    size?: Parameters.size;
    /** 予約事業を始めたかどうかに基づいて店舗を絞り込む際に指定する */
    started?: boolean;
    /** 特定の事業者の店舗のみに絞り込む際に指定する */
    business_entity_platform_id?: string;
}
export interface Response$apiDashboardListShops$Status$200 {
    "application/json": Schemas.ShopList;
}
export interface Parameter$apiDashboardDashboardAccessibilities {
    /** 特定の事業者の店舗のみに絞り込む際に指定する */
    business_entity_platform_id?: string;
}
export interface Response$apiDashboardDashboardAccessibilities$Status$200 {
    "application/json": Schemas.ShopWithDashboardAccessibilities;
}
export interface Parameter$apiDashboardGetShop {
    shop_platform_id: Parameters.shop_platform_id;
}
export interface Response$apiDashboardGetShop$Status$200 {
    "application/json": Schemas.Shop;
}
export interface Parameter$apiDashboardSelectShop {
    shop_platform_id: Parameters.shop_platform_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Parameter$apiDashboardListEmployees {
    /** first param for cursor pagination */
    first?: Parameters.first;
    /** after param for cursor pagination */
    after?: Parameters.after;
    /**
     * このパラメータを指定すると、店舗にスタッフ登録されているかどうかによる従業員の絞り込みを行う。
     * true=スタッフ登録済み, false=スタッフ未登録
     */
    staff_registered?: boolean;
}
export interface Response$apiDashboardListEmployees$Status$200 {
    "application/json": Schemas.ListEmployee;
}
export interface Response$apiDashboardListBusinessEntities$Status$200 {
    "application/json": Schemas.BusinessEntity[];
}
export interface Parameter$apiDashboardGetBusinessEntity {
    business_entity_platform_id: Parameters.business_entity_platform_id;
}
export interface Response$apiDashboardGetBusinessEntity$Status$200 {
    "application/json": Schemas.BusinessEntity;
}
export interface Parameter$apiDashboardSelectBusinessEntity {
    business_entity_platform_id: Parameters.business_entity_platform_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$apiDashboardSelectBusinessEntity$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardListAssignSchemeResources$Status$200 {
    "application/json": Schemas.ResourceList;
}
export interface Parameter$apiDashboardCreateGoogleReserveRequest {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$apiDashboardCreateGoogleReserveRequest$Status$201 {
    "application/json": {};
}
export interface Response$apiDashboardCreateGoogleReserveRequest$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardListKanzashiIntegratedResources$Status$200 {
    "application/json": Schemas.KanzashiIntegratedResource;
}
export interface Response$apiDashboardListKanzashiIntegratedResources$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardGetPlanUpgrades {
    plan_name: Parameters.plan_name;
    /** キャンペーンコード(ex. business_10off_cii) */
    campaign_code?: string;
}
export interface Response$apiDashboardGetPlanUpgrades$Status$200 {
    "application/json": Schemas.UpgradePlanInfo;
}
export interface Response$apiDashboardGetPlanUpgrades$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardGetPlanUpgrades$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardListSmartLists$Status$200 {
    "application/json": Schemas.ListSmartList;
}
export interface Response$apiDashboardListSmartLists$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardCreateSmartList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$apiDashboardCreateSmartList {
    "application/json": {
        smart_list?: Schemas.SmartListCreateRequest;
    };
}
export interface Response$apiDashboardCreateSmartList$Status$200 {
    "application/json": Schemas.SmartList;
}
export interface Response$apiDashboardCreateSmartList$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardCreateSmartList$Status$403 {
    "application/json": {};
}
export interface Response$apiDashboardCreateSmartList$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardDeleteSmartList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    smart_list_id: Parameters.smart_list_id;
}
export interface Response$apiDashboardDeleteSmartList$Status$403 {
    "application/json": {};
}
export interface Response$apiDashboardDeleteSmartList$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardDeleteSmartList$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardUpdateSmartList {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    smart_list_id: Parameters.smart_list_id;
}
export interface RequestBody$apiDashboardUpdateSmartList {
    "application/json": {
        smart_list?: Schemas.SmartListUpdateRequest;
    };
}
export interface Response$apiDashboardUpdateSmartList$Status$200 {
    "application/json": Schemas.SmartList;
}
export interface Response$apiDashboardUpdateSmartList$Status$403 {
    "application/json": {};
}
export interface Response$apiDashboardUpdateSmartList$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardUpdateSmartList$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest {
    "application/json": {
        email: string;
    };
}
export interface Parameter$apiDashboardMerchantsGetApiKeyCredential {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$apiDashboardMerchantsGetApiKeyCredential$Status$200 {
    "text/plain": string;
}
export interface Response$getStaffManagement$Status$200 {
    "application/json": {
        /** スタッフ管理数の上限値。-1の場合は無制限。 */
        limit_count: number;
        /** スタッフの数が管理数の上限に達しているか */
        is_limit_exceeded: boolean;
        /** 現在ログインしているアカウントが、現在選択中の組織に対して、majaで従業員の追加ができるかどうか */
        can_add_employee: boolean;
    };
}
export interface Parameter$apiDashboardMerchantsBulkCreateStaff {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$apiDashboardMerchantsBulkCreateStaff {
    "application/json": {
        /** スタッフとして登録したいプラットフォームの従業員の`platform_id`の配列 */
        employee_platform_ids: string[];
    };
}
export interface Response$apiDashboardMerchantsBulkCreateStaff$Status$204 {
}
export interface Response$apiDashboardMerchantsLegalNoticeShow$Status$200 {
    "application/json": Schemas.MerchantLegalNotice;
}
export interface Parameter$apiDashboardMerchantsLegalNoticePatch {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$apiDashboardMerchantsLegalNoticePatch {
    "application/json": Schemas.MerchantLegalNotice;
}
export interface Response$apiDashboardMerchantsLegalNoticePatch$Status$200 {
    "application/json": Schemas.MerchantLegalNotice;
}
export interface Parameter$getSmartListMessageAutomations {
    type?: string;
}
export interface Response$getSmartListMessageAutomations$Status$200 {
    "application/json": Schemas.SmartListMessageAutomationList;
}
export interface Response$getSmartListMessageAutomations$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$createSmartListMessageAutomation {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createSmartListMessageAutomation {
    "application/json": Schemas.LineSmartListMessageAutomationRequest;
}
export interface Response$createSmartListMessageAutomation$Status$201 {
    "application/json": {
        id: number;
    };
}
export interface Response$createSmartListMessageAutomation$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$createSmartListMessageAutomation$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getSmartListMessageAutomation {
    smart_list_message_automation_id: Parameters.smart_list_message_automation_id;
}
export interface Response$getSmartListMessageAutomation$Status$200 {
    "application/json": Schemas.LineSmartListMessageAutomation;
}
export interface Response$getSmartListMessageAutomation$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getSmartListMessageAutomation$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$deleteSmartListMessageAutomation {
    smart_list_message_automation_id: Parameters.smart_list_message_automation_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$deleteSmartListMessageAutomation$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$deleteSmartListMessageAutomation$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateSmartListMessageAutomation {
    smart_list_message_automation_id: Parameters.smart_list_message_automation_id;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateSmartListMessageAutomation {
    "application/json": Schemas.LineSmartListMessageAutomationRequest;
}
export interface Response$updateSmartListMessageAutomation$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$updateSmartListMessageAutomation$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$updateSmartListMessageAutomation$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$uploadSmartListMessageAutomationImage {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
    type: "line_imagemap";
}
export interface RequestBody$uploadSmartListMessageAutomationImage {
    "multipart/form-data": {
        /** 個別uploadする画像 */
        image: string;
    };
}
export interface Response$uploadSmartListMessageAutomationImage$Status$201 {
    "application/json": {
        uuid: string;
    };
}
export interface Response$uploadSmartListMessageAutomationImage$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$uploadSmartListMessageAutomationImage$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$uploadSmartListMessageAutomationImage$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Response$getSmartListMessageAutomationStatus$Status$200 {
    "application/json": Schemas.SmartListMessageAutomationStatus;
}
export interface Response$getSmartListMessageAutomationStatus$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getAvailabilities {
    resource_public_id: string;
    date: string;
    course_id: string;
    "option_ids[]"?: string[];
    reservation_id?: string;
    staff_id?: string;
    via?: string;
    state?: string;
}
export interface Response$getAvailabilities$Status$200 {
    "application/json": Schemas.Availabilities;
}
export interface Response$getAvailabilities$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getAvailabilities$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getResourceSlideSetting {
    resource_public_id: string;
}
export interface Response$getResourceSlideSetting$Status$200 {
    "application/json": Schemas.ResourceSlideSetting;
}
export interface Response$getResourceSlideSetting$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getResourceSlideSetting$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateResourceSlideSetting {
    resource_public_id: string;
    /** csrf-token */
    "X-Csrf-Token": string;
}
export interface RequestBody$updateResourceSlideSetting {
    "application/json": {
        slide_time_unit_in_minutes: number;
        apply_slide_to_without_staff_appointment: boolean;
    };
}
export interface Response$updateResourceSlideSetting$Status$200 {
    "application/json": Schemas.ResourceSlideSetting;
}
export interface Response$updateResourceSlideSetting$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$updateResourceSlideSetting$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$updateResourceSlideSetting$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$apiBusinessEntitySystemUpgrade$Status$200 {
    "application/json": Schemas.BusinessEntitySystemUpgrade;
}
export interface Parameter$postBusinessEntitySystemUpgrade {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$postBusinessEntitySystemUpgrade {
    "application/json": {
        shop_platform_id: string;
    };
}
export interface Parameter$getSubscription {
    product_public_id: string;
}
export interface Response$getSubscription$Status$200 {
    "application/json": Schemas.SubscriptionProduct;
}
export interface Response$getSubscription$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$getSubscription$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$getSubscription$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$getSubscription$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$updateSubscription {
    product_public_id: string;
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$updateSubscription {
    "application/json": Schemas.SubscriptionProductUpdateParams;
}
export interface Response$updateSubscription$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$updateSubscription$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$updateSubscription$Status$404 {
    "application/json": Schemas.APIError;
}
export interface Response$updateSubscription$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$patchFranchiseeBusinessProfiles {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$patchFranchiseeBusinessProfiles {
    "application/json": Schemas.FranchiseeBusinessProfile;
}
export interface Response$patchFranchiseeBusinessProfiles$Status$200 {
    "application/json": {};
}
export interface Response$patchFranchiseeBusinessProfiles$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$apiDashboardBusinessEntitySystemUpgradeCheck$Status$200 {
    "application/json": {
        /** maja移行が必要かどうか */
        upgrade_required?: boolean;
    };
}
export interface Parameter$createReservationsCSV {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface RequestBody$createReservationsCSV {
    "application/json": {
        reservation_ids: number[];
        encoding: "utf-8" | "sjis";
    };
}
export interface Response$createReservationsCSV$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$createReservationsCSV$Status$403 {
    "application/json": Schemas.APIError;
}
export interface Response$createReservationsCSV$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getFeatureToggle {
    /** stoggle に登録されている feature name */
    feature_name: string;
    /** stoggle target */
    target?: string;
}
export interface Response$getFeatureToggle$Status$200 {
    "application/json": {
        /** Whether the feature is enabled or not */
        toggle: boolean;
    };
}
export interface Parameter$ExpectedTransfers {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$ExpectedTransfers$Status$200 {
    "application/json": Schemas.ExpectedTransferList;
}
export interface Response$ExpectedTransfers$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$CompletedTransfers {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$CompletedTransfers$Status$200 {
    "application/json": Schemas.CompletedTransferList;
}
export interface Response$CompletedTransfers$Status$401 {
    "application/json": Schemas.APIError;
}
export interface Parameter$getStoresIdTemporaryIdentity {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$getStoresIdTemporaryIdentity$Status$200 {
    "application/json": Schemas.StoresIdTemporaryIdentity;
}
export interface Parameter$createStoresIdReserveAccount {
    /** csrf-token */
    "X-Csrf-Token": Parameters.csrf$token;
}
export interface Response$createStoresIdReserveAccount$Status$400 {
    "application/json": Schemas.APIError;
}
export interface Response$createStoresIdReserveAccount$Status$422 {
    "application/json": Schemas.APIError;
}
export interface Parameter$webDashboardMerchantsApplyPrimaryEmailUpdateRequest {
    /** メールアドレスの変更申請を特定するトークン */
    token: string;
}
export interface Parameter$webDashboardCustomersPurchaseCsv {
    customer_public_id: Parameters.customer_public_id;
    /** 出力されるCSVの文字コード */
    encoding: "sjis" | "utf-8";
}
export interface Response$webDashboardCustomersPurchaseCsv$Status$200 {
}
export interface Parameter$applyWebviewToken {
    /** セッション発行完了後の遷移先 */
    to: string;
    /** 予約web用の短期間のセッションを発行するためのtoken */
    "X-Webview-Token": string;
}
export type RequestContentType$login = keyof RequestBody$login;
export type ResponseContentType$login = keyof Response$login$Status$200;
export interface Params$login {
    requestBody: RequestBody$login["application/json"];
}
export type ResponseContentType$getCsrfToken = keyof Response$getCsrfToken$Status$200;
export type ResponseContentType$resendVerificationMail = keyof Response$resendVerificationMail$Status$200;
export type ResponseContentType$fetchCurrentUser = keyof Response$fetchCurrentUser$Status$200;
export type ResponseContentType$fetchMerchantVouchers = keyof Response$fetchMerchantVouchers$Status$200;
export interface Params$fetchMerchantVouchers {
    parameter: Parameter$fetchMerchantVouchers;
}
export type ResponseContentType$getVoucherAssigns = keyof Response$getVoucherAssigns$Status$200;
export interface Params$getVoucherAssigns {
    parameter: Parameter$getVoucherAssigns;
}
export type RequestContentType$updateVoucherAssigns = keyof RequestBody$updateVoucherAssigns;
export interface Params$updateVoucherAssigns {
    parameter: Parameter$updateVoucherAssigns;
    requestBody: RequestBody$updateVoucherAssigns["application/json"];
}
export type ResponseContentType$getMerchantReservation = keyof Response$getMerchantReservation$Status$200;
export interface Params$getMerchantReservation {
    parameter: Parameter$getMerchantReservation;
}
export type RequestContentType$updateReservation = keyof RequestBody$updateReservation;
export interface Params$updateReservation {
    parameter: Parameter$updateReservation;
    requestBody: RequestBody$updateReservation["application/json"];
}
export type ResponseContentType$getMerchantReservationOnlineMeeting = keyof Response$getMerchantReservationOnlineMeeting$Status$200;
export interface Params$getMerchantReservationOnlineMeeting {
    parameter: Parameter$getMerchantReservationOnlineMeeting;
}
export type ResponseContentType$getReservationCustomerMemos = keyof Response$getReservationCustomerMemos$Status$200;
export interface Params$getReservationCustomerMemos {
    parameter: Parameter$getReservationCustomerMemos;
}
export type RequestContentType$bulkCreateReservationCheckin = keyof RequestBody$bulkCreateReservationCheckin;
export type ResponseContentType$bulkCreateReservationCheckin = keyof Response$bulkCreateReservationCheckin$Status$201;
export interface Params$bulkCreateReservationCheckin {
    parameter: Parameter$bulkCreateReservationCheckin;
    requestBody: RequestBody$bulkCreateReservationCheckin["application/json"];
}
export type ResponseContentType$merchantCustomersSearch = keyof Response$merchantCustomersSearch$Status$200;
export interface Params$merchantCustomersSearch {
    parameter: Parameter$merchantCustomersSearch;
}
export type ResponseContentType$dashboardCustomersSearch = keyof Response$dashboardCustomersSearch$Status$200;
export interface Params$dashboardCustomersSearch {
    parameter: Parameter$dashboardCustomersSearch;
}
export interface Params$dashboardCustomersBulkDelete {
    parameter: Parameter$dashboardCustomersBulkDelete;
}
export type ResponseContentType$getCustomerSummaryInfo = keyof Response$getCustomerSummaryInfo$Status$200;
export interface Params$getCustomerSummaryInfo {
    parameter: Parameter$getCustomerSummaryInfo;
}
export type ResponseContentType$getCustomerTicketBooks = keyof Response$getCustomerTicketBooks$Status$200;
export interface Params$getCustomerTicketBooks {
    parameter: Parameter$getCustomerTicketBooks;
}
export type ResponseContentType$getCustomerSubscriptions = keyof Response$getCustomerSubscriptions$Status$200;
export interface Params$getCustomerSubscriptions {
    parameter: Parameter$getCustomerSubscriptions;
}
export type ResponseContentType$getCustomerSummarizedReservations = keyof Response$getCustomerSummarizedReservations$Status$200;
export interface Params$getCustomerSummarizedReservations {
    parameter: Parameter$getCustomerSummarizedReservations;
}
export type ResponseContentType$getCustomerCheckinableReservations = keyof Response$getCustomerCheckinableReservations$Status$200;
export interface Params$getCustomerCheckinableReservations {
    parameter: Parameter$getCustomerCheckinableReservations;
}
export type RequestContentType$createCustomerCheckin = keyof RequestBody$createCustomerCheckin;
export type ResponseContentType$createCustomerCheckin = keyof Response$createCustomerCheckin$Status$201;
export interface Params$createCustomerCheckin {
    parameter: Parameter$createCustomerCheckin;
    requestBody: RequestBody$createCustomerCheckin["application/json"];
}
export type ResponseContentType$apiDashboardListCustomerPurchases = keyof Response$apiDashboardListCustomerPurchases$Status$200;
export interface Params$apiDashboardListCustomerPurchases {
    parameter: Parameter$apiDashboardListCustomerPurchases;
}
export type ResponseContentType$apiDashboardMergeableCustomers = keyof Response$apiDashboardMergeableCustomers$Status$200;
export interface Params$apiDashboardMergeableCustomers {
    parameter: Parameter$apiDashboardMergeableCustomers;
}
export type RequestContentType$createCustomerMerging = keyof RequestBody$createCustomerMerging;
export type ResponseContentType$createCustomerMerging = keyof Response$createCustomerMerging$Status$200;
export interface Params$createCustomerMerging {
    parameter: Parameter$createCustomerMerging;
    requestBody: RequestBody$createCustomerMerging["application/json"];
}
export type ResponseContentType$apiDashboardSuggestDuplicatedCustomers = keyof Response$apiDashboardSuggestDuplicatedCustomers$Status$200;
export interface Params$apiDashboardSuggestDuplicatedCustomers {
    parameter: Parameter$apiDashboardSuggestDuplicatedCustomers;
}
export type ResponseContentType$getEventSchemePaymentMethodSetting = keyof Response$getEventSchemePaymentMethodSetting$Status$200;
export interface Params$getEventSchemePaymentMethodSetting {
    parameter: Parameter$getEventSchemePaymentMethodSetting;
}
export type RequestContentType$updateEventSchemePaymentMethodSetting = keyof RequestBody$updateEventSchemePaymentMethodSetting;
export type ResponseContentType$updateEventSchemePaymentMethodSetting = keyof Response$updateEventSchemePaymentMethodSetting$Status$200;
export interface Params$updateEventSchemePaymentMethodSetting {
    parameter: Parameter$updateEventSchemePaymentMethodSetting;
    requestBody: RequestBody$updateEventSchemePaymentMethodSetting["application/json"];
}
export type ResponseContentType$getEventSchemePaymentMethodList = keyof Response$getEventSchemePaymentMethodList$Status$200;
export interface Params$getEventSchemePaymentMethodList {
    parameter: Parameter$getEventSchemePaymentMethodList;
}
export type ResponseContentType$getCourseSchemePaymentMethodSetting = keyof Response$getCourseSchemePaymentMethodSetting$Status$200;
export interface Params$getCourseSchemePaymentMethodSetting {
    parameter: Parameter$getCourseSchemePaymentMethodSetting;
}
export type RequestContentType$updateCourseSchemePaymentMethodSetting = keyof RequestBody$updateCourseSchemePaymentMethodSetting;
export type ResponseContentType$updateCourseSchemePaymentMethodSetting = keyof Response$updateCourseSchemePaymentMethodSetting$Status$200;
export interface Params$updateCourseSchemePaymentMethodSetting {
    parameter: Parameter$updateCourseSchemePaymentMethodSetting;
    requestBody: RequestBody$updateCourseSchemePaymentMethodSetting["application/json"];
}
export type ResponseContentType$GetDatetimeSelectionUiType = keyof Response$GetDatetimeSelectionUiType$Status$200;
export interface Params$GetDatetimeSelectionUiType {
    parameter: Parameter$GetDatetimeSelectionUiType;
}
export type RequestContentType$PatchDatetimeSelectionUiType = keyof RequestBody$PatchDatetimeSelectionUiType;
export interface Params$PatchDatetimeSelectionUiType {
    parameter: Parameter$PatchDatetimeSelectionUiType;
    requestBody: RequestBody$PatchDatetimeSelectionUiType["application/json"];
}
export type ResponseContentType$getPaymentMethodSettingOfCourse = keyof Response$getPaymentMethodSettingOfCourse$Status$200;
export interface Params$getPaymentMethodSettingOfCourse {
    parameter: Parameter$getPaymentMethodSettingOfCourse;
}
export type RequestContentType$updatePaymentMethodSettingOfCourse = keyof RequestBody$updatePaymentMethodSettingOfCourse;
export type ResponseContentType$updatePaymentMethodSettingOfCourse = keyof Response$updatePaymentMethodSettingOfCourse$Status$200;
export interface Params$updatePaymentMethodSettingOfCourse {
    parameter: Parameter$updatePaymentMethodSettingOfCourse;
    requestBody: RequestBody$updatePaymentMethodSettingOfCourse["application/json"];
}
export type ResponseContentType$getPaymentMethodListsOfCourse = keyof Response$getPaymentMethodListsOfCourse$Status$200;
export interface Params$getPaymentMethodListsOfCourse {
    parameter: Parameter$getPaymentMethodListsOfCourse;
}
export type ResponseContentType$getMerchantEquipmentList = keyof Response$getMerchantEquipmentList$Status$200;
export interface Params$getMerchantEquipmentList {
    parameter: Parameter$getMerchantEquipmentList;
}
export type RequestContentType$editMerchantEquipment = keyof RequestBody$editMerchantEquipment;
export type ResponseContentType$editMerchantEquipment = keyof Response$editMerchantEquipment$Status$200;
export interface Params$editMerchantEquipment {
    parameter: Parameter$editMerchantEquipment;
    requestBody: RequestBody$editMerchantEquipment["application/json"];
}
export type ResponseContentType$getEquipmentReservations = keyof Response$getEquipmentReservations$Status$200;
export interface Params$getEquipmentReservations {
    parameter: Parameter$getEquipmentReservations;
}
export type ResponseContentType$getEquipmentGoogleCalendarSync = keyof Response$getEquipmentGoogleCalendarSync$Status$200;
export interface Params$getEquipmentGoogleCalendarSync {
    parameter: Parameter$getEquipmentGoogleCalendarSync;
}
export type RequestContentType$updateEquipmentGoogleCalendarSync = keyof RequestBody$updateEquipmentGoogleCalendarSync;
export type ResponseContentType$updateEquipmentGoogleCalendarSync = keyof Response$updateEquipmentGoogleCalendarSync$Status$200;
export interface Params$updateEquipmentGoogleCalendarSync {
    parameter: Parameter$updateEquipmentGoogleCalendarSync;
    requestBody: RequestBody$updateEquipmentGoogleCalendarSync["application/json"];
}
export type ResponseContentType$getMerchantEquipmentAll = keyof Response$getMerchantEquipmentAll$Status$200;
export interface Params$getMerchantEquipmentAll {
    parameter: Parameter$getMerchantEquipmentAll;
}
export type ResponseContentType$getEquipmentBlocks = keyof Response$getEquipmentBlocks$Status$200;
export interface Params$getEquipmentBlocks {
    parameter: Parameter$getEquipmentBlocks;
}
export type ResponseContentType$getProducts = keyof Response$getProducts$Status$200;
export type ResponseContentType$getReservations = keyof Response$getReservations$Status$200;
export interface Params$getReservations {
    parameter: Parameter$getReservations;
}
export type ResponseContentType$getCalendarStaffNonServiceTimes = keyof Response$getCalendarStaffNonServiceTimes$Status$200;
export interface Params$getCalendarStaffNonServiceTimes {
    parameter: Parameter$getCalendarStaffNonServiceTimes;
}
export type ResponseContentType$getGoogleCalendarsCalendarWithEquipment = keyof Response$getGoogleCalendarsCalendarWithEquipment$Status$200;
export interface Params$getGoogleCalendarsCalendarWithEquipment {
    parameter: Parameter$getGoogleCalendarsCalendarWithEquipment;
}
export type RequestContentType$createGoogleCalendar = keyof RequestBody$createGoogleCalendar;
export type ResponseContentType$createGoogleCalendar = keyof Response$createGoogleCalendar$Status$200;
export interface Params$createGoogleCalendar {
    parameter: Parameter$createGoogleCalendar;
    requestBody: RequestBody$createGoogleCalendar["application/json"];
}
export type ResponseContentType$getResourceDetail = keyof Response$getResourceDetail$Status$200;
export interface Params$getResourceDetail {
    parameter: Parameter$getResourceDetail;
}
export type ResponseContentType$getMerchantResourcesCourses = keyof Response$getMerchantResourcesCourses$Status$200;
export interface Params$getMerchantResourcesCourses {
    parameter: Parameter$getMerchantResourcesCourses;
}
export type RequestContentType$createCourse = keyof RequestBody$createCourse;
export type ResponseContentType$createCourse = keyof Response$createCourse$Status$200;
export interface Params$createCourse {
    parameter: Parameter$createCourse;
    requestBody: RequestBody$createCourse["multipart/form-data"];
}
export type ResponseContentType$fetchCourseDetail = keyof Response$fetchCourseDetail$Status$200;
export interface Params$fetchCourseDetail {
    parameter: Parameter$fetchCourseDetail;
}
export type RequestContentType$updateCourse = keyof RequestBody$updateCourse;
export type ResponseContentType$updateCourse = keyof Response$updateCourse$Status$200;
export interface Params$updateCourse {
    parameter: Parameter$updateCourse;
    requestBody: RequestBody$updateCourse["multipart/form-data"];
}
export type ResponseContentType$getResourceCustomerFields = keyof Response$getResourceCustomerFields$Status$200;
export interface Params$getResourceCustomerFields {
    parameter: Parameter$getResourceCustomerFields;
}
export type RequestContentType$sortResourcesCustomerFields = keyof RequestBody$sortResourcesCustomerFields;
export interface Params$sortResourcesCustomerFields {
    parameter: Parameter$sortResourcesCustomerFields;
    requestBody: RequestBody$sortResourcesCustomerFields["application/json"];
}
export type RequestContentType$updateResourcesCustomerFields = keyof RequestBody$updateResourcesCustomerFields;
export type ResponseContentType$updateResourcesCustomerFields = keyof Response$updateResourcesCustomerFields$Status$200;
export interface Params$updateResourcesCustomerFields {
    parameter: Parameter$updateResourcesCustomerFields;
    requestBody: RequestBody$updateResourcesCustomerFields["application/json"];
}
export type ResponseContentType$getMerchantOptionsList = keyof Response$getMerchantOptionsList$Status$200;
export interface Params$getMerchantOptionsList {
    parameter: Parameter$getMerchantOptionsList;
}
export type RequestContentType$createOption = keyof RequestBody$createOption;
export interface Params$createOption<T extends RequestContentType$createOption> {
    headers: {
        "Content-Type": T;
    };
    parameter: Parameter$createOption;
    requestBody: RequestBody$createOption[T];
}
export type RequestContentType$createOfflineReservation = keyof RequestBody$createOfflineReservation;
export type ResponseContentType$createOfflineReservation = keyof Response$createOfflineReservation$Status$200;
export interface Params$createOfflineReservation {
    parameter: Parameter$createOfflineReservation;
    requestBody: RequestBody$createOfflineReservation["application/json"];
}
export type RequestContentType$createDuplicationRequest = keyof RequestBody$createDuplicationRequest;
export type ResponseContentType$createDuplicationRequest = keyof Response$createDuplicationRequest$Status$201;
export interface Params$createDuplicationRequest {
    parameter: Parameter$createDuplicationRequest;
    requestBody: RequestBody$createDuplicationRequest["application/json"];
}
export interface Params$deleteResourcesOption {
    parameter: Parameter$deleteResourcesOption;
}
export type RequestContentType$updateResourcesOption = keyof RequestBody$updateResourcesOption;
export type ResponseContentType$updateResourcesOption = keyof Response$updateResourcesOption$Status$200;
export interface Params$updateResourcesOption {
    parameter: Parameter$updateResourcesOption;
    requestBody: RequestBody$updateResourcesOption["application/json"];
}
export type ResponseContentType$getTimeSlotResources = keyof Response$getTimeSlotResources$Status$200;
export interface Params$getTimeSlotResources {
    parameter: Parameter$getTimeSlotResources;
}
export type ResponseContentType$getCourseResources = keyof Response$getCourseResources$Status$200;
export interface Params$getCourseResources {
    parameter: Parameter$getCourseResources;
}
export type ResponseContentType$getCourseResourceTimeUnit = keyof Response$getCourseResourceTimeUnit$Status$200;
export interface Params$getCourseResourceTimeUnit {
    parameter: Parameter$getCourseResourceTimeUnit;
}
export type RequestContentType$updateCourseResourceTimeUnit = keyof RequestBody$updateCourseResourceTimeUnit;
export type ResponseContentType$updateCourseResourceTimeUnit = keyof Response$updateCourseResourceTimeUnit$Status$200;
export interface Params$updateCourseResourceTimeUnit {
    parameter: Parameter$updateCourseResourceTimeUnit;
    requestBody: RequestBody$updateCourseResourceTimeUnit["application/json"];
}
export type ResponseContentType$listCourseOption = keyof Response$listCourseOption$Status$200;
export interface Params$listCourseOption {
    parameter: Parameter$listCourseOption;
}
export type ResponseContentType$getMonthlyAvailabilities = keyof Response$getMonthlyAvailabilities$Status$200;
export interface Params$getMonthlyAvailabilities {
    parameter: Parameter$getMonthlyAvailabilities;
}
export type RequestContentType$sendAccessLog = keyof RequestBody$sendAccessLog;
export interface Params$sendAccessLog {
    parameter: Parameter$sendAccessLog;
    requestBody: RequestBody$sendAccessLog["application/json"];
}
export type ResponseContentType$getMerchantRepresentative = keyof Response$getMerchantRepresentative$Status$200;
export interface Params$getMerchantRepresentative {
    parameter: Parameter$getMerchantRepresentative;
}
export type RequestContentType$patchMMerchantRepresentatives = keyof RequestBody$patchMMerchantRepresentatives;
export interface Params$patchMMerchantRepresentatives {
    parameter: Parameter$patchMMerchantRepresentatives;
    requestBody: RequestBody$patchMMerchantRepresentatives["application/json"];
}
export type ResponseContentType$getTimeSlots = keyof Response$getTimeSlots$Status$200;
export interface Params$getTimeSlots {
    parameter: Parameter$getTimeSlots;
}
export type ResponseContentType$getReservationsPerTimeSlot = keyof Response$getReservationsPerTimeSlot$Status$200;
export interface Params$getReservationsPerTimeSlot {
    parameter: Parameter$getReservationsPerTimeSlot;
}
export type ResponseContentType$getMerchantResourcesScheduledPriceSettings = keyof Response$getMerchantResourcesScheduledPriceSettings$Status$200;
export interface Params$getMerchantResourcesScheduledPriceSettings {
    parameter: Parameter$getMerchantResourcesScheduledPriceSettings;
}
export type RequestContentType$postMerchantResourcesScheduledPriceSettings = keyof RequestBody$postMerchantResourcesScheduledPriceSettings;
export interface Params$postMerchantResourcesScheduledPriceSettings {
    parameter: Parameter$postMerchantResourcesScheduledPriceSettings;
    requestBody: RequestBody$postMerchantResourcesScheduledPriceSettings["application/json"];
}
export type ResponseContentType$getReservablePeriod = keyof Response$getReservablePeriod$Status$200;
export interface Params$getReservablePeriod {
    parameter: Parameter$getReservablePeriod;
}
export type RequestContentType$patchReservablePeriod = keyof RequestBody$patchReservablePeriod;
export type ResponseContentType$patchReservablePeriod = keyof Response$patchReservablePeriod$Status$200;
export interface Params$patchReservablePeriod {
    parameter: Parameter$patchReservablePeriod;
    requestBody: RequestBody$patchReservablePeriod["application/json"];
}
export interface Params$deleteTimeSlot {
    parameter: Parameter$deleteTimeSlot;
}
export type ResponseContentType$fetchSellerDetail = keyof Response$fetchSellerDetail$Status$200;
export interface Params$fetchSellerDetail {
    parameter: Parameter$fetchSellerDetail;
}
export type RequestContentType$updateSellerDetail = keyof RequestBody$updateSellerDetail;
export type ResponseContentType$updateSellerDetail = keyof Response$updateSellerDetail$Status$200;
export interface Params$updateSellerDetail {
    parameter: Parameter$updateSellerDetail;
    requestBody: RequestBody$updateSellerDetail["multipart/form-data"];
}
export type ResponseContentType$getLineMiniAppStatus = keyof Response$getLineMiniAppStatus$Status$200;
export interface Params$getLineMiniAppStatus {
    parameter: Parameter$getLineMiniAppStatus;
}
export type RequestContentType$submitLineMiniAppExamination = keyof RequestBody$submitLineMiniAppExamination;
export type ResponseContentType$submitLineMiniAppExamination = keyof Response$submitLineMiniAppExamination$Status$200;
export interface Params$submitLineMiniAppExamination {
    parameter: Parameter$submitLineMiniAppExamination;
    requestBody: RequestBody$submitLineMiniAppExamination["multipart/form-data"];
}
export type ResponseContentType$getEndUserReservationLimit = keyof Response$getEndUserReservationLimit$Status$200;
export interface Params$getEndUserReservationLimit {
    parameter: Parameter$getEndUserReservationLimit;
}
export type RequestContentType$updateEndUserReservationLimitation = keyof RequestBody$updateEndUserReservationLimitation;
export type ResponseContentType$updateEndUserReservationLimitation = keyof Response$updateEndUserReservationLimitation$Status$200;
export interface Params$updateEndUserReservationLimitation {
    parameter: Parameter$updateEndUserReservationLimitation;
    requestBody: RequestBody$updateEndUserReservationLimitation["application/json"];
}
export type ResponseContentType$transferSchedule = keyof Response$transferSchedule$Status$200;
export interface Params$transferSchedule {
    parameter: Parameter$transferSchedule;
}
export type ResponseContentType$payoutSchedule = keyof Response$payoutSchedule$Status$200;
export interface Params$payoutSchedule {
    parameter: Parameter$payoutSchedule;
}
export type ResponseContentType$payoutList = keyof Response$payoutList$Status$200;
export interface Params$payoutList {
    parameter: Parameter$payoutList;
}
export type ResponseContentType$expectedPayoutList = keyof Response$expectedPayoutList$Status$200;
export interface Params$expectedPayoutList {
    parameter: Parameter$expectedPayoutList;
}
export type RequestContentType$downloadPayout = keyof RequestBody$downloadPayout;
export type ResponseContentType$downloadPayout = keyof Response$downloadPayout$Status$200;
export interface Params$downloadPayout {
    parameter: Parameter$downloadPayout;
    requestBody: RequestBody$downloadPayout["application/json"];
}
export type RequestContentType$downloadExpectedPayout = keyof RequestBody$downloadExpectedPayout;
export type ResponseContentType$downloadExpectedPayout = keyof Response$downloadExpectedPayout$Status$200;
export interface Params$downloadExpectedPayout {
    parameter: Parameter$downloadExpectedPayout;
    requestBody: RequestBody$downloadExpectedPayout["application/json"];
}
export type ResponseContentType$getDashboardCalendarSetting = keyof Response$getDashboardCalendarSetting$Status$200;
export type RequestContentType$updateDashboardCalendarSetting = keyof RequestBody$updateDashboardCalendarSetting;
export type ResponseContentType$updateDashboardCalendarSetting = keyof Response$updateDashboardCalendarSetting$Status$200;
export interface Params$updateDashboardCalendarSetting {
    parameter: Parameter$updateDashboardCalendarSetting;
    requestBody: RequestBody$updateDashboardCalendarSetting["application/json"];
}
export type ResponseContentType$getGoogleAnalyticsFour = keyof Response$getGoogleAnalyticsFour$Status$200;
export interface Params$getGoogleAnalyticsFour {
    parameter: Parameter$getGoogleAnalyticsFour;
}
export interface Params$deleteGoogleAnalyticsFour {
    parameter: Parameter$deleteGoogleAnalyticsFour;
}
export type RequestContentType$updateGoogleAnalyticsFour = keyof RequestBody$updateGoogleAnalyticsFour;
export type ResponseContentType$updateGoogleAnalyticsFour = keyof Response$updateGoogleAnalyticsFour$Status$200;
export interface Params$updateGoogleAnalyticsFour {
    parameter: Parameter$updateGoogleAnalyticsFour;
    requestBody: RequestBody$updateGoogleAnalyticsFour["application/json"];
}
export type ResponseContentType$getStaffList = keyof Response$getStaffList$Status$200;
export interface Params$getStaffList {
    parameter: Parameter$getStaffList;
}
export type RequestContentType$createNewStaff = keyof RequestBody$createNewStaff;
export type ResponseContentType$createNewStaff = keyof Response$createNewStaff$Status$200;
export interface Params$createNewStaff {
    parameter: Parameter$createNewStaff;
    requestBody: RequestBody$createNewStaff["application/json"];
}
export type ResponseContentType$getStaffManagementLimitReached = keyof Response$getStaffManagementLimitReached$Status$200;
export interface Params$getStaffManagementLimitReached {
    parameter: Parameter$getStaffManagementLimitReached;
}
export type RequestContentType$bulkDeleteStaff = keyof RequestBody$bulkDeleteStaff;
export interface Params$bulkDeleteStaff {
    parameter: Parameter$bulkDeleteStaff;
    requestBody: RequestBody$bulkDeleteStaff["application/json"];
}
export type ResponseContentType$getStaffDailySchedulesList = keyof Response$getStaffDailySchedulesList$Status$200;
export interface Params$getStaffDailySchedulesList {
    parameter: Parameter$getStaffDailySchedulesList;
}
export type RequestContentType$bulkUpdateStaffDailySchedule = keyof RequestBody$bulkUpdateStaffDailySchedule;
export interface Params$bulkUpdateStaffDailySchedule {
    parameter: Parameter$bulkUpdateStaffDailySchedule;
    requestBody: RequestBody$bulkUpdateStaffDailySchedule["application/json"];
}
export type ResponseContentType$getStaffMonthlySchedules = keyof Response$getStaffMonthlySchedules$Status$200;
export interface Params$getStaffMonthlySchedules {
    parameter: Parameter$getStaffMonthlySchedules;
}
export type ResponseContentType$getStaffWorkingHour = keyof Response$getStaffWorkingHour$Status$200;
export interface Params$getStaffWorkingHour {
    parameter: Parameter$getStaffWorkingHour;
}
export type ResponseContentType$getStaffListForStaffDailySchedule = keyof Response$getStaffListForStaffDailySchedule$Status$200;
export interface Params$getStaffListForStaffDailySchedule {
    parameter: Parameter$getStaffListForStaffDailySchedule;
}
export type ResponseContentType$getStaffDailyScheduleHintDisplayHistoryCreatability = keyof Response$getStaffDailyScheduleHintDisplayHistoryCreatability$Status$200;
export interface Params$getStaffDailyScheduleHintDisplayHistoryCreatability {
    parameter: Parameter$getStaffDailyScheduleHintDisplayHistoryCreatability;
}
export interface Params$createStaffDailyScheduleHintDisplayHistory {
    parameter: Parameter$createStaffDailyScheduleHintDisplayHistory;
}
export type ResponseContentType$getStaffCourseAssignersList = keyof Response$getStaffCourseAssignersList$Status$200;
export interface Params$getStaffCourseAssignersList {
    parameter: Parameter$getStaffCourseAssignersList;
}
export type ResponseContentType$getQrSelfCheckinImage = keyof Response$getQrSelfCheckinImage$Status$200;
export interface Params$getQrSelfCheckinImage {
    parameter: Parameter$getQrSelfCheckinImage;
}
export type ResponseContentType$createEventDefaultStaffAssignment = keyof Response$createEventDefaultStaffAssignment$Status$201;
export interface Params$createEventDefaultStaffAssignment {
    parameter: Parameter$createEventDefaultStaffAssignment;
}
export interface Params$deleteEventDefaultStaffAssignment {
    parameter: Parameter$deleteEventDefaultStaffAssignment;
}
export type ResponseContentType$getEventDefaultStaffAssignments = keyof Response$getEventDefaultStaffAssignments$Status$200;
export interface Params$getEventDefaultStaffAssignments {
    parameter: Parameter$getEventDefaultStaffAssignments;
}
export type ResponseContentType$getAllCourseStaffAssignments = keyof Response$getAllCourseStaffAssignments$Status$200;
export interface Params$getAllCourseStaffAssignments {
    parameter: Parameter$getAllCourseStaffAssignments;
}
export type RequestContentType$putResourceOnboardingTodo = keyof RequestBody$putResourceOnboardingTodo;
export type ResponseContentType$putResourceOnboardingTodo = keyof Response$putResourceOnboardingTodo$Status$200;
export interface Params$putResourceOnboardingTodo {
    parameter: Parameter$putResourceOnboardingTodo;
    requestBody: RequestBody$putResourceOnboardingTodo["application/json"];
}
export type RequestContentType$putResourceRecommendedSettingVisibility = keyof RequestBody$putResourceRecommendedSettingVisibility;
export type ResponseContentType$putResourceRecommendedSettingVisibility = keyof Response$putResourceRecommendedSettingVisibility$Status$200;
export interface Params$putResourceRecommendedSettingVisibility {
    parameter: Parameter$putResourceRecommendedSettingVisibility;
    requestBody: RequestBody$putResourceRecommendedSettingVisibility["application/json"];
}
export type ResponseContentType$patchResourceArchive = keyof Response$patchResourceArchive$Status$200;
export interface Params$patchResourceArchive {
    parameter: Parameter$patchResourceArchive;
}
export type ResponseContentType$getMerchantSetting = keyof Response$getMerchantSetting$Status$200;
export interface Params$getMerchantSetting {
    parameter: Parameter$getMerchantSetting;
}
export type RequestContentType$updateMerchantSetting = keyof RequestBody$updateMerchantSetting;
export type ResponseContentType$updateMerchantSetting = keyof Response$updateMerchantSetting$Status$200;
export interface Params$updateMerchantSetting {
    parameter: Parameter$updateMerchantSetting;
    requestBody: RequestBody$updateMerchantSetting["application/json"];
}
export type RequestContentType$updateMerchantSiteVisibility = keyof RequestBody$updateMerchantSiteVisibility;
export type ResponseContentType$updateMerchantSiteVisibility = keyof Response$updateMerchantSiteVisibility$Status$200;
export interface Params$updateMerchantSiteVisibility {
    parameter: Parameter$updateMerchantSiteVisibility;
    requestBody: RequestBody$updateMerchantSiteVisibility["application/json"];
}
export type ResponseContentType$getSiteDetail = keyof Response$getSiteDetail$Status$200;
export interface Params$getSiteDetail {
    parameter: Parameter$getSiteDetail;
}
export type RequestContentType$updateSiteDetail = keyof RequestBody$updateSiteDetail;
export type ResponseContentType$updateSiteDetail = keyof Response$updateSiteDetail$Status$200;
export interface Params$updateSiteDetail {
    parameter: Parameter$updateSiteDetail;
    requestBody: RequestBody$updateSiteDetail["application/json"];
}
export type RequestContentType$putSitePublicId = keyof RequestBody$putSitePublicId;
export interface Params$putSitePublicId {
    parameter: Parameter$putSitePublicId;
    requestBody: RequestBody$putSitePublicId["application/json"];
}
export type RequestContentType$uploadImage = keyof RequestBody$uploadImage;
export type ResponseContentType$uploadImage = keyof Response$uploadImage$Status$200;
export interface Params$uploadImage {
    parameter: Parameter$uploadImage;
    requestBody: RequestBody$uploadImage["multipart/form-data"];
}
export type ResponseContentType$getCategories = keyof Response$getCategories$Status$200;
export interface Params$getCategories {
    parameter: Parameter$getCategories;
}
export type ResponseContentType$getTemporaryDates = keyof Response$getTemporaryDates$Status$200;
export interface Params$getTemporaryDates {
    parameter: Parameter$getTemporaryDates;
}
export type RequestContentType$createTemporaryDate = keyof RequestBody$createTemporaryDate;
export interface Params$createTemporaryDate {
    parameter: Parameter$createTemporaryDate;
    requestBody: RequestBody$createTemporaryDate["application/json"];
}
export type ResponseContentType$getTemporaryDate = keyof Response$getTemporaryDate$Status$200;
export interface Params$getTemporaryDate {
    parameter: Parameter$getTemporaryDate;
}
export interface Params$deleteTemporaryDate {
    parameter: Parameter$deleteTemporaryDate;
}
export type RequestContentType$editTemporaryDate = keyof RequestBody$editTemporaryDate;
export interface Params$editTemporaryDate {
    parameter: Parameter$editTemporaryDate;
    requestBody: RequestBody$editTemporaryDate["application/json"];
}
export type ResponseContentType$duplicationStatus = keyof Response$duplicationStatus$Status$200;
export interface Params$duplicationStatus {
    parameter: Parameter$duplicationStatus;
}
export type ResponseContentType$getPublishedResourcesCount = keyof Response$getPublishedResourcesCount$Status$200;
export type ResponseContentType$getOnboardingTodo = keyof Response$getOnboardingTodo$Status$200;
export type RequestContentType$putOnboardingTodo = keyof RequestBody$putOnboardingTodo;
export type ResponseContentType$putOnboardingTodo = keyof Response$putOnboardingTodo$Status$200;
export interface Params$putOnboardingTodo {
    requestBody: RequestBody$putOnboardingTodo["application/json"];
}
export type ResponseContentType$getGoogleConnect = keyof Response$getGoogleConnect$Status$200;
export type ResponseContentType$getInquiryFormAutoFill = keyof Response$getInquiryFormAutoFill$Status$200;
export type ResponseContentType$getUpgrades = keyof Response$getUpgrades$Status$200;
export type ResponseContentType$putUsageTips = keyof Response$putUsageTips$Status$200;
export interface Params$putUsageTips {
    parameter: Parameter$putUsageTips;
}
export type ResponseContentType$getCustomerAttributeDefinitions = keyof Response$getCustomerAttributeDefinitions$Status$200;
export type RequestContentType$createCustomer = keyof RequestBody$createCustomer;
export type ResponseContentType$createCustomer = keyof Response$createCustomer$Status$200;
export interface Params$createCustomer {
    parameter: Parameter$createCustomer;
    requestBody: RequestBody$createCustomer["application/json"];
}
export type RequestContentType$triggerCsvExport = keyof RequestBody$triggerCsvExport;
export type ResponseContentType$triggerCsvExport = keyof Response$triggerCsvExport$Status$200;
export interface Params$triggerCsvExport {
    parameter: Parameter$triggerCsvExport;
    requestBody: RequestBody$triggerCsvExport["application/json"];
}
export type RequestContentType$customersCsvImportRequest = keyof RequestBody$customersCsvImportRequest;
export type ResponseContentType$customersCsvImportRequest = keyof Response$customersCsvImportRequest$Status$200;
export interface Params$customersCsvImportRequest {
    parameter: Parameter$customersCsvImportRequest;
    requestBody: RequestBody$customersCsvImportRequest["application/json"];
}
export type ResponseContentType$getTicketBookProducts = keyof Response$getTicketBookProducts$Status$200;
export type ResponseContentType$getSubscriptionProducts = keyof Response$getSubscriptionProducts$Status$200;
export type RequestContentType$dashboardCustomerInvitation = keyof RequestBody$dashboardCustomerInvitation;
export type ResponseContentType$dashboardCustomerInvitation = keyof Response$dashboardCustomerInvitation$Status$200;
export interface Params$dashboardCustomerInvitation {
    parameter: Parameter$dashboardCustomerInvitation;
    requestBody: RequestBody$dashboardCustomerInvitation["application/json"];
}
export type RequestContentType$createCustomerMemo = keyof RequestBody$createCustomerMemo;
export type ResponseContentType$createCustomerMemo = keyof Response$createCustomerMemo$Status$201;
export interface Params$createCustomerMemo {
    parameter: Parameter$createCustomerMemo;
    requestBody: RequestBody$createCustomerMemo["application/json"];
}
export type ResponseContentType$getCustomerMemo = keyof Response$getCustomerMemo$Status$200;
export interface Params$getCustomerMemo {
    parameter: Parameter$getCustomerMemo;
}
export interface Params$deleteCustomerMemos {
    parameter: Parameter$deleteCustomerMemos;
}
export type RequestContentType$updateCustomerMemo = keyof RequestBody$updateCustomerMemo;
export type ResponseContentType$updateCustomerMemo = keyof Response$updateCustomerMemo$Status$200;
export interface Params$updateCustomerMemo {
    parameter: Parameter$updateCustomerMemo;
    requestBody: RequestBody$updateCustomerMemo["application/json"];
}
export type ResponseContentType$getMerchantDashboardAnalyticsQuery = keyof Response$getMerchantDashboardAnalyticsQuery$Status$200;
export interface Params$getMerchantDashboardAnalyticsQuery {
    parameter: Parameter$getMerchantDashboardAnalyticsQuery;
}
export interface Params$downloadMerchantDashboardAnalyticsQuerySjisCsv {
    parameter: Parameter$downloadMerchantDashboardAnalyticsQuerySjisCsv;
}
export type ResponseContentType$getMerchantDashboardBusinessInformation = keyof Response$getMerchantDashboardBusinessInformation$Status$200;
export type RequestContentType$updateMerchantDashboardBusinessInformation = keyof RequestBody$updateMerchantDashboardBusinessInformation;
export type ResponseContentType$updateMerchantDashboardBusinessInformation = keyof Response$updateMerchantDashboardBusinessInformation$Status$200;
export interface Params$updateMerchantDashboardBusinessInformation {
    parameter: Parameter$updateMerchantDashboardBusinessInformation;
    requestBody: RequestBody$updateMerchantDashboardBusinessInformation["application/json"];
}
export type ResponseContentType$getMerchantDashboardDefaultBusinessInformation = keyof Response$getMerchantDashboardDefaultBusinessInformation$Status$200;
export interface Params$getMerchantDashboardDefaultBusinessInformation {
    parameter: Parameter$getMerchantDashboardDefaultBusinessInformation;
}
export type RequestContentType$patchMerchantPublicId = keyof RequestBody$patchMerchantPublicId;
export interface Params$patchMerchantPublicId {
    parameter: Parameter$patchMerchantPublicId;
    requestBody: RequestBody$patchMerchantPublicId["application/json"];
}
export type ResponseContentType$getBillings = keyof Response$getBillings$Status$200;
export interface Params$getBillings {
    parameter: Parameter$getBillings;
}
export type ResponseContentType$getOfflineReservationResourceTimeSlots = keyof Response$getOfflineReservationResourceTimeSlots$Status$200;
export interface Params$getOfflineReservationResourceTimeSlots {
    parameter: Parameter$getOfflineReservationResourceTimeSlots;
}
export type ResponseContentType$getKanzashiIntegrationProgress = keyof Response$getKanzashiIntegrationProgress$Status$200;
export type RequestContentType$updateKanzashiIntegrationProgress = keyof RequestBody$updateKanzashiIntegrationProgress;
export type ResponseContentType$updateKanzashiIntegrationProgress = keyof Response$updateKanzashiIntegrationProgress$Status$200;
export interface Params$updateKanzashiIntegrationProgress {
    parameter: Parameter$updateKanzashiIntegrationProgress;
    requestBody: RequestBody$updateKanzashiIntegrationProgress["application/json"];
}
export type ResponseContentType$getKanzashiBusinessInformationRequest = keyof Response$getKanzashiBusinessInformationRequest$Status$200;
export type RequestContentType$createKanzashiBusinessInformationRequest = keyof RequestBody$createKanzashiBusinessInformationRequest;
export interface Params$createKanzashiBusinessInformationRequest {
    parameter: Parameter$createKanzashiBusinessInformationRequest;
    requestBody: RequestBody$createKanzashiBusinessInformationRequest["application/json"];
}
export type RequestContentType$createKanzashiIntegrationResourceRequest = keyof RequestBody$createKanzashiIntegrationResourceRequest;
export interface Params$createKanzashiIntegrationResourceRequest {
    parameter: Parameter$createKanzashiIntegrationResourceRequest;
    requestBody: RequestBody$createKanzashiIntegrationResourceRequest["application/json"];
}
export type ResponseContentType$getKanzashiHmacForSignIn = keyof Response$getKanzashiHmacForSignIn$Status$200;
export type ResponseContentType$getKanzashiAcceptableCountSetting = keyof Response$getKanzashiAcceptableCountSetting$Status$200;
export type RequestContentType$updateKanzashiAcceptableCountSetting = keyof RequestBody$updateKanzashiAcceptableCountSetting;
export type ResponseContentType$updateKanzashiAcceptableCountSetting = keyof Response$updateKanzashiAcceptableCountSetting$Status$200;
export interface Params$updateKanzashiAcceptableCountSetting {
    parameter: Parameter$updateKanzashiAcceptableCountSetting;
    requestBody: RequestBody$updateKanzashiAcceptableCountSetting["application/json"];
}
export type ResponseContentType$getKanzashiExcludeStaffMembers = keyof Response$getKanzashiExcludeStaffMembers$Status$200;
export type RequestContentType$bulkCreateKanzashiSyncableStaffMembers = keyof RequestBody$bulkCreateKanzashiSyncableStaffMembers;
export type ResponseContentType$bulkCreateKanzashiSyncableStaffMembers = keyof Response$bulkCreateKanzashiSyncableStaffMembers$Status$201;
export interface Params$bulkCreateKanzashiSyncableStaffMembers {
    parameter: Parameter$bulkCreateKanzashiSyncableStaffMembers;
    requestBody: RequestBody$bulkCreateKanzashiSyncableStaffMembers["application/json"];
}
export type RequestContentType$bulkDeleteKanzashiSyncableStaffMembers = keyof RequestBody$bulkDeleteKanzashiSyncableStaffMembers;
export interface Params$bulkDeleteKanzashiSyncableStaffMembers {
    parameter: Parameter$bulkDeleteKanzashiSyncableStaffMembers;
    requestBody: RequestBody$bulkDeleteKanzashiSyncableStaffMembers["application/json"];
}
export type ResponseContentType$merchantDashboardSettingGetNotification = keyof Response$merchantDashboardSettingGetNotification$Status$200;
export type RequestContentType$merchantDashboardSettingUpdateNotification = keyof RequestBody$merchantDashboardSettingUpdateNotification;
export type ResponseContentType$merchantDashboardSettingUpdateNotification = keyof Response$merchantDashboardSettingUpdateNotification$Status$200;
export interface Params$merchantDashboardSettingUpdateNotification {
    parameter: Parameter$merchantDashboardSettingUpdateNotification;
    requestBody: RequestBody$merchantDashboardSettingUpdateNotification["application/json"];
}
export type ResponseContentType$merchantBulkMesssageBundleQuota = keyof Response$merchantBulkMesssageBundleQuota$Status$200;
export interface Params$merchantBulkMesssageBundleQuota {
    parameter: Parameter$merchantBulkMesssageBundleQuota;
}
export type ResponseContentType$fetchMerchantsInfoAboutSubscriptionProduct = keyof Response$fetchMerchantsInfoAboutSubscriptionProduct$Status$200;
export interface Params$fetchMerchantsInfoAboutSubscriptionProduct {
    parameter: Parameter$fetchMerchantsInfoAboutSubscriptionProduct;
}
export type ResponseContentType$fetchMerchantsInfoAboutTicketBookProduct = keyof Response$fetchMerchantsInfoAboutTicketBookProduct$Status$200;
export interface Params$fetchMerchantsInfoAboutTicketBookProduct {
    parameter: Parameter$fetchMerchantsInfoAboutTicketBookProduct;
}
export type RequestContentType$publishSubscriptionProduct = keyof RequestBody$publishSubscriptionProduct;
export type ResponseContentType$publishSubscriptionProduct = keyof Response$publishSubscriptionProduct$Status$200;
export interface Params$publishSubscriptionProduct {
    parameter: Parameter$publishSubscriptionProduct;
    requestBody: RequestBody$publishSubscriptionProduct["application/json"];
}
export type RequestContentType$publishTicketBookProduct = keyof RequestBody$publishTicketBookProduct;
export type ResponseContentType$publishTicketBookProduct = keyof Response$publishTicketBookProduct$Status$200;
export interface Params$publishTicketBookProduct {
    parameter: Parameter$publishTicketBookProduct;
    requestBody: RequestBody$publishTicketBookProduct["application/json"];
}
export type ResponseContentType$getOrganizationDashboardAnalyticsQuery = keyof Response$getOrganizationDashboardAnalyticsQuery$Status$200;
export interface Params$getOrganizationDashboardAnalyticsQuery {
    parameter: Parameter$getOrganizationDashboardAnalyticsQuery;
}
export interface Params$downloadOrganizationDashboardAnalyticsQuerySjisCsv {
    parameter: Parameter$downloadOrganizationDashboardAnalyticsQuerySjisCsv;
}
export type ResponseContentType$getOrganizationDashboardMerchants = keyof Response$getOrganizationDashboardMerchants$Status$200;
export interface Params$getOrganizationDashboardMerchants {
    parameter: Parameter$getOrganizationDashboardMerchants;
}
export type ResponseContentType$getOrganizationDashboardResourceSelectors = keyof Response$getOrganizationDashboardResourceSelectors$Status$200;
export interface Params$getOrganizationDashboardResourceSelectors {
    parameter: Parameter$getOrganizationDashboardResourceSelectors;
}
export type ResponseContentType$getOrganizationDashboardProducts = keyof Response$getOrganizationDashboardProducts$Status$200;
export interface Params$getOrganizationDashboardProducts {
    parameter: Parameter$getOrganizationDashboardProducts;
}
export type ResponseContentType$fetchCurrentEndUser = keyof Response$fetchCurrentEndUser$Status$200;
export type ResponseContentType$postUserCheckin = keyof Response$postUserCheckin$Status$200;
export interface Params$postUserCheckin {
    parameter: Parameter$postUserCheckin;
}
export type ResponseContentType$fetchUserReservations = keyof Response$fetchUserReservations$Status$200;
export interface Params$fetchUserReservations {
    parameter: Parameter$fetchUserReservations;
}
export type RequestContentType$createPaymentMethod = keyof RequestBody$createPaymentMethod;
export type ResponseContentType$createPaymentMethod = keyof Response$createPaymentMethod$Status$201;
export interface Params$createPaymentMethod {
    parameter: Parameter$createPaymentMethod;
    requestBody: RequestBody$createPaymentMethod["application/json"];
}
export type ResponseContentType$setupPaymentMethod = keyof Response$setupPaymentMethod$Status$200;
export interface Params$setupPaymentMethod {
    parameter: Parameter$setupPaymentMethod;
}
export type RequestContentType$confirmPaymentMethod = keyof RequestBody$confirmPaymentMethod;
export interface Params$confirmPaymentMethod {
    parameter: Parameter$confirmPaymentMethod;
    requestBody: RequestBody$confirmPaymentMethod["application/json"];
}
export type RequestContentType$updateUsersMeLocale = keyof RequestBody$updateUsersMeLocale;
export interface Params$updateUsersMeLocale {
    requestBody: RequestBody$updateUsersMeLocale["application/json"];
}
export type ResponseContentType$getMerchantDetail = keyof Response$getMerchantDetail$Status$200;
export interface Params$getMerchantDetail {
    parameter: Parameter$getMerchantDetail;
}
export type ResponseContentType$getReservationStats = keyof Response$getReservationStats$Status$200;
export interface Params$getReservationStats {
    parameter: Parameter$getReservationStats;
}
export type ResponseContentType$getBookingPageDetail = keyof Response$getBookingPageDetail$Status$200;
export interface Params$getBookingPageDetail {
    parameter: Parameter$getBookingPageDetail;
}
export type ResponseContentType$getBookingCalendarMeta = keyof Response$getBookingCalendarMeta$Status$200;
export interface Params$getBookingCalendarMeta {
    parameter: Parameter$getBookingCalendarMeta;
}
export type ResponseContentType$getVoucherList = keyof Response$getVoucherList$Status$200;
export interface Params$getVoucherList {
    parameter: Parameter$getVoucherList;
}
export type ResponseContentType$getVoucherDetail = keyof Response$getVoucherDetail$Status$200;
export interface Params$getVoucherDetail {
    parameter: Parameter$getVoucherDetail;
}
export type ResponseContentType$getMerchantProduct = keyof Response$getMerchantProduct$Status$200;
export interface Params$getMerchantProduct {
    parameter: Parameter$getMerchantProduct;
}
export type ResponseContentType$getMerchantProductFirstCharge = keyof Response$getMerchantProductFirstCharge$Status$200;
export interface Params$getMerchantProductFirstCharge {
    parameter: Parameter$getMerchantProductFirstCharge;
}
export type ResponseContentType$getLineMiniAppMeta = keyof Response$getLineMiniAppMeta$Status$200;
export interface Params$getLineMiniAppMeta {
    parameter: Parameter$getLineMiniAppMeta;
}
export type ResponseContentType$getReservationFlowMe = keyof Response$getReservationFlowMe$Status$200;
export type RequestContentType$verifyReservationFlowResource = keyof RequestBody$verifyReservationFlowResource;
export interface Params$verifyReservationFlowResource {
    parameter: Parameter$verifyReservationFlowResource;
    requestBody: RequestBody$verifyReservationFlowResource["application/json"];
}
export type ResponseContentType$getReservationFlowMerchantOptIn = keyof Response$getReservationFlowMerchantOptIn$Status$200;
export interface Params$getReservationFlowMerchantOptIn {
    parameter: Parameter$getReservationFlowMerchantOptIn;
}
export type ResponseContentType$getReservationFlowMerchantReservationStats = keyof Response$getReservationFlowMerchantReservationStats$Status$200;
export interface Params$getReservationFlowMerchantReservationStats {
    parameter: Parameter$getReservationFlowMerchantReservationStats;
}
export type ResponseContentType$getReservationFlowEventSchemeTimeSlots = keyof Response$getReservationFlowEventSchemeTimeSlots$Status$200;
export interface Params$getReservationFlowEventSchemeTimeSlots {
    parameter: Parameter$getReservationFlowEventSchemeTimeSlots;
}
export type ResponseContentType$getReservationFlowEventSchemeTimeSlot = keyof Response$getReservationFlowEventSchemeTimeSlot$Status$200;
export interface Params$getReservationFlowEventSchemeTimeSlot {
    parameter: Parameter$getReservationFlowEventSchemeTimeSlot;
}
export type ResponseContentType$getReservationFlowEventSchemeResource = keyof Response$getReservationFlowEventSchemeResource$Status$200;
export interface Params$getReservationFlowEventSchemeResource {
    parameter: Parameter$getReservationFlowEventSchemeResource;
}
export type ResponseContentType$getReservationFlowCustomFields = keyof Response$getReservationFlowCustomFields$Status$200;
export interface Params$getReservationFlowCustomFields {
    parameter: Parameter$getReservationFlowCustomFields;
}
export type ResponseContentType$getReservationFlowVersion = keyof Response$getReservationFlowVersion$Status$200;
export interface Params$getReservationFlowVersion {
    parameter: Parameter$getReservationFlowVersion;
}
export type ResponseContentType$getReservationFlowMetaInfo = keyof Response$getReservationFlowMetaInfo$Status$200;
export interface Params$getReservationFlowMetaInfo {
    parameter: Parameter$getReservationFlowMetaInfo;
}
export type ResponseContentType$getReservationFlowEventSchemePaymentMethodList = keyof Response$getReservationFlowEventSchemePaymentMethodList$Status$200;
export interface Params$getReservationFlowEventSchemePaymentMethodList {
    parameter: Parameter$getReservationFlowEventSchemePaymentMethodList;
}
export type RequestContentType$validateReservationFlowEventSchemeReservationFormData = keyof RequestBody$validateReservationFlowEventSchemeReservationFormData;
export type ResponseContentType$validateReservationFlowEventSchemeReservationFormData = keyof Response$validateReservationFlowEventSchemeReservationFormData$Status$200;
export interface Params$validateReservationFlowEventSchemeReservationFormData {
    parameter: Parameter$validateReservationFlowEventSchemeReservationFormData;
    requestBody: RequestBody$validateReservationFlowEventSchemeReservationFormData["application/json"];
}
export type RequestContentType$finalizeReservationFlowEventSchemeReservationWithFormData = keyof RequestBody$finalizeReservationFlowEventSchemeReservationWithFormData;
export type ResponseContentType$finalizeReservationFlowEventSchemeReservationWithFormData = keyof Response$finalizeReservationFlowEventSchemeReservationWithFormData$Status$200;
export interface Params$finalizeReservationFlowEventSchemeReservationWithFormData {
    parameter: Parameter$finalizeReservationFlowEventSchemeReservationWithFormData;
    requestBody: RequestBody$finalizeReservationFlowEventSchemeReservationWithFormData["application/json"];
}
export type RequestContentType$holdReservationFlowEventSchemeReservationWithFormData = keyof RequestBody$holdReservationFlowEventSchemeReservationWithFormData;
export type ResponseContentType$holdReservationFlowEventSchemeReservationWithFormData = keyof Response$holdReservationFlowEventSchemeReservationWithFormData$Status$200;
export interface Params$holdReservationFlowEventSchemeReservationWithFormData {
    parameter: Parameter$holdReservationFlowEventSchemeReservationWithFormData;
    requestBody: RequestBody$holdReservationFlowEventSchemeReservationWithFormData["application/json"];
}
export type RequestContentType$notifyConfirmedPrepaymentForReservationFlowEventScheme = keyof RequestBody$notifyConfirmedPrepaymentForReservationFlowEventScheme;
export type ResponseContentType$notifyConfirmedPrepaymentForReservationFlowEventScheme = keyof Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$200;
export interface Params$notifyConfirmedPrepaymentForReservationFlowEventScheme {
    parameter: Parameter$notifyConfirmedPrepaymentForReservationFlowEventScheme;
    requestBody: RequestBody$notifyConfirmedPrepaymentForReservationFlowEventScheme["application/json"];
}
export type RequestContentType$validateReservationFlowCourseSchemeReservationFormData = keyof RequestBody$validateReservationFlowCourseSchemeReservationFormData;
export type ResponseContentType$validateReservationFlowCourseSchemeReservationFormData = keyof Response$validateReservationFlowCourseSchemeReservationFormData$Status$200;
export interface Params$validateReservationFlowCourseSchemeReservationFormData {
    parameter: Parameter$validateReservationFlowCourseSchemeReservationFormData;
    requestBody: RequestBody$validateReservationFlowCourseSchemeReservationFormData["application/json"];
}
export type ResponseContentType$getReservationFlowCourseSchemeCourses = keyof Response$getReservationFlowCourseSchemeCourses$Status$200;
export interface Params$getReservationFlowCourseSchemeCourses {
    parameter: Parameter$getReservationFlowCourseSchemeCourses;
}
export type ResponseContentType$getReservationFlowCourseSchemeStaffMembers = keyof Response$getReservationFlowCourseSchemeStaffMembers$Status$200;
export interface Params$getReservationFlowCourseSchemeStaffMembers {
    parameter: Parameter$getReservationFlowCourseSchemeStaffMembers;
}
export type RequestContentType$finalizeReservationFlowCourseSchemeReservationFormData = keyof RequestBody$finalizeReservationFlowCourseSchemeReservationFormData;
export type ResponseContentType$finalizeReservationFlowCourseSchemeReservationFormData = keyof Response$finalizeReservationFlowCourseSchemeReservationFormData$Status$200;
export interface Params$finalizeReservationFlowCourseSchemeReservationFormData {
    parameter: Parameter$finalizeReservationFlowCourseSchemeReservationFormData;
    requestBody: RequestBody$finalizeReservationFlowCourseSchemeReservationFormData["application/json"];
}
export type RequestContentType$holdReservationFlowCourseSchemeReservationFormData = keyof RequestBody$holdReservationFlowCourseSchemeReservationFormData;
export type ResponseContentType$holdReservationFlowCourseSchemeReservationFormData = keyof Response$holdReservationFlowCourseSchemeReservationFormData$Status$200;
export interface Params$holdReservationFlowCourseSchemeReservationFormData {
    parameter: Parameter$holdReservationFlowCourseSchemeReservationFormData;
    requestBody: RequestBody$holdReservationFlowCourseSchemeReservationFormData["application/json"];
}
export type RequestContentType$notifyConfirmedPrepaymentForReservationFlowCourseScheme = keyof RequestBody$notifyConfirmedPrepaymentForReservationFlowCourseScheme;
export type ResponseContentType$notifyConfirmedPrepaymentForReservationFlowCourseScheme = keyof Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$200;
export interface Params$notifyConfirmedPrepaymentForReservationFlowCourseScheme {
    parameter: Parameter$notifyConfirmedPrepaymentForReservationFlowCourseScheme;
    requestBody: RequestBody$notifyConfirmedPrepaymentForReservationFlowCourseScheme["application/json"];
}
export type ResponseContentType$getReservationFlowCourseSchemePaymentMethodList = keyof Response$getReservationFlowCourseSchemePaymentMethodList$Status$200;
export interface Params$getReservationFlowCourseSchemePaymentMethodList {
    parameter: Parameter$getReservationFlowCourseSchemePaymentMethodList;
}
export type ResponseContentType$getReservationFlowCourseSchemeResource = keyof Response$getReservationFlowCourseSchemeResource$Status$200;
export interface Params$getReservationFlowCourseSchemeResource {
    parameter: Parameter$getReservationFlowCourseSchemeResource;
}
export type ResponseContentType$getReservationFlowCourseSchemeAvailabilityBoard = keyof Response$getReservationFlowCourseSchemeAvailabilityBoard$Status$200;
export interface Params$getReservationFlowCourseSchemeAvailabilityBoard {
    parameter: Parameter$getReservationFlowCourseSchemeAvailabilityBoard;
}
export type ResponseContentType$getReservationFlowCourseSchemeAvailabilityCalendarIndex = keyof Response$getReservationFlowCourseSchemeAvailabilityCalendarIndex$Status$200;
export interface Params$getReservationFlowCourseSchemeAvailabilityCalendarIndex {
    parameter: Parameter$getReservationFlowCourseSchemeAvailabilityCalendarIndex;
}
export type ResponseContentType$getReservationFlowCourseSchemeAvailabilityCalendarTimes = keyof Response$getReservationFlowCourseSchemeAvailabilityCalendarTimes$Status$200;
export interface Params$getReservationFlowCourseSchemeAvailabilityCalendarTimes {
    parameter: Parameter$getReservationFlowCourseSchemeAvailabilityCalendarTimes;
}
export type ResponseContentType$showReservationDetailForReservationFlowEventScheme = keyof Response$showReservationDetailForReservationFlowEventScheme$Status$200;
export interface Params$showReservationDetailForReservationFlowEventScheme {
    parameter: Parameter$showReservationDetailForReservationFlowEventScheme;
}
export type ResponseContentType$showReservationDetailForReservationFlowCourseScheme = keyof Response$showReservationDetailForReservationFlowCourseScheme$Status$200;
export interface Params$showReservationDetailForReservationFlowCourseScheme {
    parameter: Parameter$showReservationDetailForReservationFlowCourseScheme;
}
export type RequestContentType$userReservationGuestSessions = keyof RequestBody$userReservationGuestSessions;
export interface Params$userReservationGuestSessions {
    parameter: Parameter$userReservationGuestSessions;
    requestBody: RequestBody$userReservationGuestSessions["application/json"];
}
export type RequestContentType$userTimeSlotWaitingGuestSessions = keyof RequestBody$userTimeSlotWaitingGuestSessions;
export type ResponseContentType$userTimeSlotWaitingGuestSessions = keyof Response$userTimeSlotWaitingGuestSessions$Status$201;
export interface Params$userTimeSlotWaitingGuestSessions {
    parameter: Parameter$userTimeSlotWaitingGuestSessions;
    requestBody: RequestBody$userTimeSlotWaitingGuestSessions["application/json"];
}
export type ResponseContentType$userReservationTokenVerifications = keyof Response$userReservationTokenVerifications$Status$200;
export interface Params$userReservationTokenVerifications {
    parameter: Parameter$userReservationTokenVerifications;
}
export type ResponseContentType$userTimeSlotWaitingFingerprintVerifications = keyof Response$userTimeSlotWaitingFingerprintVerifications$Status$200;
export interface Params$userTimeSlotWaitingFingerprintVerifications {
    parameter: Parameter$userTimeSlotWaitingFingerprintVerifications;
}
export type RequestContentType$purchaseReservationFlowSubscription = keyof RequestBody$purchaseReservationFlowSubscription;
export type ResponseContentType$purchaseReservationFlowSubscription = keyof Response$purchaseReservationFlowSubscription$Status$200;
export interface Params$purchaseReservationFlowSubscription {
    parameter: Parameter$purchaseReservationFlowSubscription;
    requestBody: RequestBody$purchaseReservationFlowSubscription["application/json"];
}
export type RequestContentType$startReservationFlowSubscriptionPurchase = keyof RequestBody$startReservationFlowSubscriptionPurchase;
export type ResponseContentType$startReservationFlowSubscriptionPurchase = keyof Response$startReservationFlowSubscriptionPurchase$Status$200;
export interface Params$startReservationFlowSubscriptionPurchase {
    parameter: Parameter$startReservationFlowSubscriptionPurchase;
    requestBody: RequestBody$startReservationFlowSubscriptionPurchase["application/json"];
}
export type RequestContentType$notifyConfirmedReservationFlowSubscription = keyof RequestBody$notifyConfirmedReservationFlowSubscription;
export type ResponseContentType$notifyConfirmedReservationFlowSubscription = keyof Response$notifyConfirmedReservationFlowSubscription$Status$200;
export interface Params$notifyConfirmedReservationFlowSubscription {
    parameter: Parameter$notifyConfirmedReservationFlowSubscription;
    requestBody: RequestBody$notifyConfirmedReservationFlowSubscription["application/json"];
}
export type ResponseContentType$getReservationFlowCustomerSubscriptionReservationAvailableCount = keyof Response$getReservationFlowCustomerSubscriptionReservationAvailableCount$Status$200;
export interface Params$getReservationFlowCustomerSubscriptionReservationAvailableCount {
    parameter: Parameter$getReservationFlowCustomerSubscriptionReservationAvailableCount;
}
export type RequestContentType$startTicketBookPurchase = keyof RequestBody$startTicketBookPurchase;
export type ResponseContentType$startTicketBookPurchase = keyof Response$startTicketBookPurchase$Status$200;
export interface Params$startTicketBookPurchase {
    parameter: Parameter$startTicketBookPurchase;
    requestBody: RequestBody$startTicketBookPurchase["application/json"];
}
export type RequestContentType$notifyConfirmedTicketBookPurchase = keyof RequestBody$notifyConfirmedTicketBookPurchase;
export type ResponseContentType$notifyConfirmedTicketBookPurchase = keyof Response$notifyConfirmedTicketBookPurchase$Status$200;
export interface Params$notifyConfirmedTicketBookPurchase {
    parameter: Parameter$notifyConfirmedTicketBookPurchase;
    requestBody: RequestBody$notifyConfirmedTicketBookPurchase["application/json"];
}
export type ResponseContentType$getReservationFlowTicketBookReservationAvailableCount = keyof Response$getReservationFlowTicketBookReservationAvailableCount$Status$200;
export interface Params$getReservationFlowTicketBookReservationAvailableCount {
    parameter: Parameter$getReservationFlowTicketBookReservationAvailableCount;
}
export type ResponseContentType$getReservationFlowProduct = keyof Response$getReservationFlowProduct$Status$200;
export interface Params$getReservationFlowProduct {
    parameter: Parameter$getReservationFlowProduct;
}
export type RequestContentType$postReservationFlowProductVerify = keyof RequestBody$postReservationFlowProductVerify;
export interface Params$postReservationFlowProductVerify {
    parameter: Parameter$postReservationFlowProductVerify;
    requestBody: RequestBody$postReservationFlowProductVerify["application/json"];
}
export interface Params$postReservationFlowMerchantThrottle {
    parameter: Parameter$postReservationFlowMerchantThrottle;
}
export type RequestContentType$apiDashboardCreateBillingRequest = keyof RequestBody$apiDashboardCreateBillingRequest;
export type ResponseContentType$apiDashboardCreateBillingRequest = keyof Response$apiDashboardCreateBillingRequest$Status$200;
export interface Params$apiDashboardCreateBillingRequest {
    parameter: Parameter$apiDashboardCreateBillingRequest;
    requestBody: RequestBody$apiDashboardCreateBillingRequest["application/json"];
}
export type ResponseContentType$getBlockByOtherMerchantsReservations = keyof Response$getBlockByOtherMerchantsReservations$Status$200;
export interface Params$getBlockByOtherMerchantsReservations {
    parameter: Parameter$getBlockByOtherMerchantsReservations;
}
export type ResponseContentType$getLineMessageUsage = keyof Response$getLineMessageUsage$Status$200;
export type ResponseContentType$getMessageUsage = keyof Response$getMessageUsage$Status$200;
export type RequestContentType$uploadLineMessageImage = keyof RequestBody$uploadLineMessageImage;
export type ResponseContentType$uploadLineMessageImage = keyof Response$uploadLineMessageImage$Status$201;
export interface Params$uploadLineMessageImage {
    parameter: Parameter$uploadLineMessageImage;
    requestBody: RequestBody$uploadLineMessageImage["multipart/form-data"];
}
export type ResponseContentType$getLineMessages = keyof Response$getLineMessages$Status$200;
export interface Params$getLineMessages {
    parameter: Parameter$getLineMessages;
}
export type RequestContentType$createLineMessage = keyof RequestBody$createLineMessage;
export type ResponseContentType$createLineMessage = keyof Response$createLineMessage$Status$200;
export interface Params$createLineMessage {
    parameter: Parameter$createLineMessage;
    requestBody: RequestBody$createLineMessage["application/json"];
}
export type RequestContentType$deliverLineMessage = keyof RequestBody$deliverLineMessage;
export type ResponseContentType$deliverLineMessage = keyof Response$deliverLineMessage$Status$200;
export interface Params$deliverLineMessage {
    parameter: Parameter$deliverLineMessage;
    requestBody: RequestBody$deliverLineMessage["application/json"];
}
export type ResponseContentType$getLineMessage = keyof Response$getLineMessage$Status$200;
export interface Params$getLineMessage {
    parameter: Parameter$getLineMessage;
}
export type ResponseContentType$deleteDraftLineMessage = keyof Response$deleteDraftLineMessage$Status$200;
export interface Params$deleteDraftLineMessage {
    parameter: Parameter$deleteDraftLineMessage;
}
export type RequestContentType$updateDraftLineMessage = keyof RequestBody$updateDraftLineMessage;
export interface Params$updateDraftLineMessage {
    parameter: Parameter$updateDraftLineMessage;
    requestBody: RequestBody$updateDraftLineMessage["application/json"];
}
export type ResponseContentType$getLineMessageRecipientCandidates = keyof Response$getLineMessageRecipientCandidates$Status$200;
export interface Params$getLineMessageRecipientCandidates {
    parameter: Parameter$getLineMessageRecipientCandidates;
}
export type ResponseContentType$getLineMessageRecipients = keyof Response$getLineMessageRecipients$Status$200;
export interface Params$getLineMessageRecipients {
    parameter: Parameter$getLineMessageRecipients;
}
export type RequestContentType$lineMessagingAPIChannelSecretVerification = keyof RequestBody$lineMessagingAPIChannelSecretVerification;
export type ResponseContentType$lineMessagingAPIChannelSecretVerification = keyof Response$lineMessagingAPIChannelSecretVerification$Status$200;
export interface Params$lineMessagingAPIChannelSecretVerification {
    parameter: Parameter$lineMessagingAPIChannelSecretVerification;
    requestBody: RequestBody$lineMessagingAPIChannelSecretVerification["application/json"];
}
export type ResponseContentType$getLineMessageChannelSecret = keyof Response$getLineMessageChannelSecret$Status$200;
export interface Params$deleteLineMessageChannelSecret {
    parameter: Parameter$deleteLineMessageChannelSecret;
}
export type RequestContentType$lineMessagingAPIChannelSecretRegistration = keyof RequestBody$lineMessagingAPIChannelSecretRegistration;
export interface Params$lineMessagingAPIChannelSecretRegistration {
    parameter: Parameter$lineMessagingAPIChannelSecretRegistration;
    requestBody: RequestBody$lineMessagingAPIChannelSecretRegistration["application/json"];
}
export type RequestContentType$createOrUpdateTester = keyof RequestBody$createOrUpdateTester;
export type ResponseContentType$createOrUpdateTester = keyof Response$createOrUpdateTester$Status$200;
export interface Params$createOrUpdateTester {
    requestBody: RequestBody$createOrUpdateTester["application/json"];
}
export type ResponseContentType$getLineMessagingApiAvailability = keyof Response$getLineMessagingApiAvailability$Status$200;
export type ResponseContentType$getLineMessagingApiIntegrationStatus = keyof Response$getLineMessagingApiIntegrationStatus$Status$200;
export type ResponseContentType$getLineMessagingApiChannelInfo = keyof Response$getLineMessagingApiChannelInfo$Status$200;
export type ResponseContentType$apiDashboardListOperableShops = keyof Response$apiDashboardListOperableShops$Status$200;
export interface Params$apiDashboardListOperableShops {
    parameter: Parameter$apiDashboardListOperableShops;
}
export type ResponseContentType$apiDashboardListShops = keyof Response$apiDashboardListShops$Status$200;
export interface Params$apiDashboardListShops {
    parameter: Parameter$apiDashboardListShops;
}
export type ResponseContentType$apiDashboardDashboardAccessibilities = keyof Response$apiDashboardDashboardAccessibilities$Status$200;
export interface Params$apiDashboardDashboardAccessibilities {
    parameter: Parameter$apiDashboardDashboardAccessibilities;
}
export type ResponseContentType$apiDashboardGetShop = keyof Response$apiDashboardGetShop$Status$200;
export interface Params$apiDashboardGetShop {
    parameter: Parameter$apiDashboardGetShop;
}
export interface Params$apiDashboardSelectShop {
    parameter: Parameter$apiDashboardSelectShop;
}
export type ResponseContentType$apiDashboardListEmployees = keyof Response$apiDashboardListEmployees$Status$200;
export interface Params$apiDashboardListEmployees {
    parameter: Parameter$apiDashboardListEmployees;
}
export type ResponseContentType$apiDashboardListBusinessEntities = keyof Response$apiDashboardListBusinessEntities$Status$200;
export type ResponseContentType$apiDashboardGetBusinessEntity = keyof Response$apiDashboardGetBusinessEntity$Status$200;
export interface Params$apiDashboardGetBusinessEntity {
    parameter: Parameter$apiDashboardGetBusinessEntity;
}
export interface Params$apiDashboardSelectBusinessEntity {
    parameter: Parameter$apiDashboardSelectBusinessEntity;
}
export type ResponseContentType$apiDashboardListAssignSchemeResources = keyof Response$apiDashboardListAssignSchemeResources$Status$200;
export type ResponseContentType$apiDashboardCreateGoogleReserveRequest = keyof Response$apiDashboardCreateGoogleReserveRequest$Status$201;
export interface Params$apiDashboardCreateGoogleReserveRequest {
    parameter: Parameter$apiDashboardCreateGoogleReserveRequest;
}
export type ResponseContentType$apiDashboardListKanzashiIntegratedResources = keyof Response$apiDashboardListKanzashiIntegratedResources$Status$200;
export type ResponseContentType$apiDashboardGetPlanUpgrades = keyof Response$apiDashboardGetPlanUpgrades$Status$200;
export interface Params$apiDashboardGetPlanUpgrades {
    parameter: Parameter$apiDashboardGetPlanUpgrades;
}
export type ResponseContentType$apiDashboardListSmartLists = keyof Response$apiDashboardListSmartLists$Status$200;
export type RequestContentType$apiDashboardCreateSmartList = keyof RequestBody$apiDashboardCreateSmartList;
export type ResponseContentType$apiDashboardCreateSmartList = keyof Response$apiDashboardCreateSmartList$Status$200;
export interface Params$apiDashboardCreateSmartList {
    parameter: Parameter$apiDashboardCreateSmartList;
    requestBody: RequestBody$apiDashboardCreateSmartList["application/json"];
}
export interface Params$apiDashboardDeleteSmartList {
    parameter: Parameter$apiDashboardDeleteSmartList;
}
export type RequestContentType$apiDashboardUpdateSmartList = keyof RequestBody$apiDashboardUpdateSmartList;
export type ResponseContentType$apiDashboardUpdateSmartList = keyof Response$apiDashboardUpdateSmartList$Status$200;
export interface Params$apiDashboardUpdateSmartList {
    parameter: Parameter$apiDashboardUpdateSmartList;
    requestBody: RequestBody$apiDashboardUpdateSmartList["application/json"];
}
export type RequestContentType$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest = keyof RequestBody$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest;
export interface Params$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest {
    parameter: Parameter$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest;
    requestBody: RequestBody$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest["application/json"];
}
export type ResponseContentType$apiDashboardMerchantsGetApiKeyCredential = keyof Response$apiDashboardMerchantsGetApiKeyCredential$Status$200;
export interface Params$apiDashboardMerchantsGetApiKeyCredential {
    parameter: Parameter$apiDashboardMerchantsGetApiKeyCredential;
}
export type ResponseContentType$getStaffManagement = keyof Response$getStaffManagement$Status$200;
export type RequestContentType$apiDashboardMerchantsBulkCreateStaff = keyof RequestBody$apiDashboardMerchantsBulkCreateStaff;
export interface Params$apiDashboardMerchantsBulkCreateStaff {
    parameter: Parameter$apiDashboardMerchantsBulkCreateStaff;
    requestBody: RequestBody$apiDashboardMerchantsBulkCreateStaff["application/json"];
}
export type ResponseContentType$apiDashboardMerchantsLegalNoticeShow = keyof Response$apiDashboardMerchantsLegalNoticeShow$Status$200;
export type RequestContentType$apiDashboardMerchantsLegalNoticePatch = keyof RequestBody$apiDashboardMerchantsLegalNoticePatch;
export type ResponseContentType$apiDashboardMerchantsLegalNoticePatch = keyof Response$apiDashboardMerchantsLegalNoticePatch$Status$200;
export interface Params$apiDashboardMerchantsLegalNoticePatch {
    parameter: Parameter$apiDashboardMerchantsLegalNoticePatch;
    requestBody: RequestBody$apiDashboardMerchantsLegalNoticePatch["application/json"];
}
export type ResponseContentType$getSmartListMessageAutomations = keyof Response$getSmartListMessageAutomations$Status$200;
export interface Params$getSmartListMessageAutomations {
    parameter: Parameter$getSmartListMessageAutomations;
}
export type RequestContentType$createSmartListMessageAutomation = keyof RequestBody$createSmartListMessageAutomation;
export type ResponseContentType$createSmartListMessageAutomation = keyof Response$createSmartListMessageAutomation$Status$201;
export interface Params$createSmartListMessageAutomation {
    parameter: Parameter$createSmartListMessageAutomation;
    requestBody: RequestBody$createSmartListMessageAutomation["application/json"];
}
export type ResponseContentType$getSmartListMessageAutomation = keyof Response$getSmartListMessageAutomation$Status$200;
export interface Params$getSmartListMessageAutomation {
    parameter: Parameter$getSmartListMessageAutomation;
}
export interface Params$deleteSmartListMessageAutomation {
    parameter: Parameter$deleteSmartListMessageAutomation;
}
export type RequestContentType$updateSmartListMessageAutomation = keyof RequestBody$updateSmartListMessageAutomation;
export interface Params$updateSmartListMessageAutomation {
    parameter: Parameter$updateSmartListMessageAutomation;
    requestBody: RequestBody$updateSmartListMessageAutomation["application/json"];
}
export type RequestContentType$uploadSmartListMessageAutomationImage = keyof RequestBody$uploadSmartListMessageAutomationImage;
export type ResponseContentType$uploadSmartListMessageAutomationImage = keyof Response$uploadSmartListMessageAutomationImage$Status$201;
export interface Params$uploadSmartListMessageAutomationImage {
    parameter: Parameter$uploadSmartListMessageAutomationImage;
    requestBody: RequestBody$uploadSmartListMessageAutomationImage["multipart/form-data"];
}
export type ResponseContentType$getSmartListMessageAutomationStatus = keyof Response$getSmartListMessageAutomationStatus$Status$200;
export type ResponseContentType$getAvailabilities = keyof Response$getAvailabilities$Status$200;
export interface Params$getAvailabilities {
    parameter: Parameter$getAvailabilities;
}
export type ResponseContentType$getResourceSlideSetting = keyof Response$getResourceSlideSetting$Status$200;
export interface Params$getResourceSlideSetting {
    parameter: Parameter$getResourceSlideSetting;
}
export type RequestContentType$updateResourceSlideSetting = keyof RequestBody$updateResourceSlideSetting;
export type ResponseContentType$updateResourceSlideSetting = keyof Response$updateResourceSlideSetting$Status$200;
export interface Params$updateResourceSlideSetting {
    parameter: Parameter$updateResourceSlideSetting;
    requestBody: RequestBody$updateResourceSlideSetting["application/json"];
}
export type ResponseContentType$apiBusinessEntitySystemUpgrade = keyof Response$apiBusinessEntitySystemUpgrade$Status$200;
export type RequestContentType$postBusinessEntitySystemUpgrade = keyof RequestBody$postBusinessEntitySystemUpgrade;
export interface Params$postBusinessEntitySystemUpgrade {
    parameter: Parameter$postBusinessEntitySystemUpgrade;
    requestBody: RequestBody$postBusinessEntitySystemUpgrade["application/json"];
}
export type ResponseContentType$getSubscription = keyof Response$getSubscription$Status$200;
export interface Params$getSubscription {
    parameter: Parameter$getSubscription;
}
export type RequestContentType$updateSubscription = keyof RequestBody$updateSubscription;
export interface Params$updateSubscription {
    parameter: Parameter$updateSubscription;
    requestBody: RequestBody$updateSubscription["application/json"];
}
export type RequestContentType$patchFranchiseeBusinessProfiles = keyof RequestBody$patchFranchiseeBusinessProfiles;
export type ResponseContentType$patchFranchiseeBusinessProfiles = keyof Response$patchFranchiseeBusinessProfiles$Status$200;
export interface Params$patchFranchiseeBusinessProfiles {
    parameter: Parameter$patchFranchiseeBusinessProfiles;
    requestBody: RequestBody$patchFranchiseeBusinessProfiles["application/json"];
}
export type ResponseContentType$apiDashboardBusinessEntitySystemUpgradeCheck = keyof Response$apiDashboardBusinessEntitySystemUpgradeCheck$Status$200;
export type RequestContentType$createReservationsCSV = keyof RequestBody$createReservationsCSV;
export interface Params$createReservationsCSV {
    parameter: Parameter$createReservationsCSV;
    requestBody: RequestBody$createReservationsCSV["application/json"];
}
export type ResponseContentType$getFeatureToggle = keyof Response$getFeatureToggle$Status$200;
export interface Params$getFeatureToggle {
    parameter: Parameter$getFeatureToggle;
}
export type ResponseContentType$ExpectedTransfers = keyof Response$ExpectedTransfers$Status$200;
export interface Params$ExpectedTransfers {
    parameter: Parameter$ExpectedTransfers;
}
export type ResponseContentType$CompletedTransfers = keyof Response$CompletedTransfers$Status$200;
export interface Params$CompletedTransfers {
    parameter: Parameter$CompletedTransfers;
}
export type ResponseContentType$getStoresIdTemporaryIdentity = keyof Response$getStoresIdTemporaryIdentity$Status$200;
export interface Params$getStoresIdTemporaryIdentity {
    parameter: Parameter$getStoresIdTemporaryIdentity;
}
export interface Params$createStoresIdReserveAccount {
    parameter: Parameter$createStoresIdReserveAccount;
}
export interface Params$webDashboardMerchantsApplyPrimaryEmailUpdateRequest {
    parameter: Parameter$webDashboardMerchantsApplyPrimaryEmailUpdateRequest;
}
export interface Params$webDashboardCustomersPurchaseCsv {
    parameter: Parameter$webDashboardCustomersPurchaseCsv;
}
export interface Params$applyWebviewToken {
    parameter: Parameter$applyWebviewToken;
}
export type HttpMethod = "GET" | "PUT" | "POST" | "DELETE" | "OPTIONS" | "HEAD" | "PATCH" | "TRACE";
export interface ObjectLike {
    [key: string]: any;
}
export interface QueryParameter {
    value: any;
    style?: "form" | "spaceDelimited" | "pipeDelimited" | "deepObject";
    explode: boolean;
}
export interface QueryParameters {
    [key: string]: QueryParameter;
}
export type SuccessResponses = Response$login$Status$200 | Response$getCsrfToken$Status$200 | Response$resendVerificationMail$Status$200 | Response$fetchCurrentUser$Status$200 | Response$fetchMerchantVouchers$Status$200 | Response$getVoucherAssigns$Status$200 | Response$getMerchantReservation$Status$200 | Response$getMerchantReservationOnlineMeeting$Status$200 | Response$getReservationCustomerMemos$Status$200 | Response$bulkCreateReservationCheckin$Status$201 | Response$merchantCustomersSearch$Status$200 | Response$dashboardCustomersSearch$Status$200 | Response$getCustomerSummaryInfo$Status$200 | Response$getCustomerTicketBooks$Status$200 | Response$getCustomerSubscriptions$Status$200 | Response$getCustomerSummarizedReservations$Status$200 | Response$getCustomerCheckinableReservations$Status$200 | Response$createCustomerCheckin$Status$201 | Response$apiDashboardListCustomerPurchases$Status$200 | Response$apiDashboardMergeableCustomers$Status$200 | Response$createCustomerMerging$Status$200 | Response$apiDashboardSuggestDuplicatedCustomers$Status$200 | Response$getEventSchemePaymentMethodSetting$Status$200 | Response$updateEventSchemePaymentMethodSetting$Status$200 | Response$getEventSchemePaymentMethodList$Status$200 | Response$getCourseSchemePaymentMethodSetting$Status$200 | Response$updateCourseSchemePaymentMethodSetting$Status$200 | Response$GetDatetimeSelectionUiType$Status$200 | Response$getPaymentMethodSettingOfCourse$Status$200 | Response$updatePaymentMethodSettingOfCourse$Status$200 | Response$getPaymentMethodListsOfCourse$Status$200 | Response$getMerchantEquipmentList$Status$200 | Response$editMerchantEquipment$Status$200 | Response$getEquipmentReservations$Status$200 | Response$getEquipmentGoogleCalendarSync$Status$200 | Response$updateEquipmentGoogleCalendarSync$Status$200 | Response$getMerchantEquipmentAll$Status$200 | Response$getEquipmentBlocks$Status$200 | Response$getProducts$Status$200 | Response$getReservations$Status$200 | Response$getCalendarStaffNonServiceTimes$Status$200 | Response$getGoogleCalendarsCalendarWithEquipment$Status$200 | Response$createGoogleCalendar$Status$200 | Response$getResourceDetail$Status$200 | Response$getMerchantResourcesCourses$Status$200 | Response$createCourse$Status$200 | Response$fetchCourseDetail$Status$200 | Response$updateCourse$Status$200 | Response$getResourceCustomerFields$Status$200 | Response$updateResourcesCustomerFields$Status$200 | Response$getMerchantOptionsList$Status$200 | Response$createOfflineReservation$Status$200 | Response$createDuplicationRequest$Status$201 | Response$updateResourcesOption$Status$200 | Response$getTimeSlotResources$Status$200 | Response$getCourseResources$Status$200 | Response$getCourseResourceTimeUnit$Status$200 | Response$updateCourseResourceTimeUnit$Status$200 | Response$listCourseOption$Status$200 | Response$getMonthlyAvailabilities$Status$200 | Response$getMerchantRepresentative$Status$200 | Response$getTimeSlots$Status$200 | Response$getReservationsPerTimeSlot$Status$200 | Response$getMerchantResourcesScheduledPriceSettings$Status$200 | Response$getReservablePeriod$Status$200 | Response$patchReservablePeriod$Status$200 | Response$fetchSellerDetail$Status$200 | Response$updateSellerDetail$Status$200 | Response$getLineMiniAppStatus$Status$200 | Response$submitLineMiniAppExamination$Status$200 | Response$getEndUserReservationLimit$Status$200 | Response$updateEndUserReservationLimitation$Status$200 | Response$transferSchedule$Status$200 | Response$payoutSchedule$Status$200 | Response$payoutList$Status$200 | Response$expectedPayoutList$Status$200 | Response$downloadPayout$Status$200 | Response$downloadExpectedPayout$Status$200 | Response$getDashboardCalendarSetting$Status$200 | Response$updateDashboardCalendarSetting$Status$200 | Response$getGoogleAnalyticsFour$Status$200 | Response$updateGoogleAnalyticsFour$Status$200 | Response$getStaffList$Status$200 | Response$createNewStaff$Status$200 | Response$getStaffManagementLimitReached$Status$200 | Response$getStaffDailySchedulesList$Status$200 | Response$getStaffMonthlySchedules$Status$200 | Response$getStaffWorkingHour$Status$200 | Response$getStaffListForStaffDailySchedule$Status$200 | Response$getStaffDailyScheduleHintDisplayHistoryCreatability$Status$200 | Response$getStaffCourseAssignersList$Status$200 | Response$getQrSelfCheckinImage$Status$200 | Response$createEventDefaultStaffAssignment$Status$201 | Response$getEventDefaultStaffAssignments$Status$200 | Response$getAllCourseStaffAssignments$Status$200 | Response$putResourceOnboardingTodo$Status$200 | Response$putResourceRecommendedSettingVisibility$Status$200 | Response$patchResourceArchive$Status$200 | Response$getMerchantSetting$Status$200 | Response$updateMerchantSetting$Status$200 | Response$updateMerchantSiteVisibility$Status$200 | Response$getSiteDetail$Status$200 | Response$updateSiteDetail$Status$200 | Response$uploadImage$Status$200 | Response$getCategories$Status$200 | Response$getTemporaryDates$Status$200 | Response$getTemporaryDate$Status$200 | Response$duplicationStatus$Status$200 | Response$getPublishedResourcesCount$Status$200 | Response$getOnboardingTodo$Status$200 | Response$putOnboardingTodo$Status$200 | Response$getGoogleConnect$Status$200 | Response$getInquiryFormAutoFill$Status$200 | Response$getUpgrades$Status$200 | Response$putUsageTips$Status$200 | Response$getCustomerAttributeDefinitions$Status$200 | Response$createCustomer$Status$200 | Response$triggerCsvExport$Status$200 | Response$customersCsvImportRequest$Status$200 | Response$getTicketBookProducts$Status$200 | Response$getSubscriptionProducts$Status$200 | Response$dashboardCustomerInvitation$Status$200 | Response$createCustomerMemo$Status$201 | Response$getCustomerMemo$Status$200 | Response$updateCustomerMemo$Status$200 | Response$getMerchantDashboardAnalyticsQuery$Status$200 | Response$getMerchantDashboardBusinessInformation$Status$200 | Response$updateMerchantDashboardBusinessInformation$Status$200 | Response$getMerchantDashboardDefaultBusinessInformation$Status$200 | Response$getBillings$Status$200 | Response$getOfflineReservationResourceTimeSlots$Status$200 | Response$getKanzashiIntegrationProgress$Status$200 | Response$updateKanzashiIntegrationProgress$Status$200 | Response$getKanzashiBusinessInformationRequest$Status$200 | Response$getKanzashiHmacForSignIn$Status$200 | Response$getKanzashiAcceptableCountSetting$Status$200 | Response$updateKanzashiAcceptableCountSetting$Status$200 | Response$getKanzashiExcludeStaffMembers$Status$200 | Response$bulkCreateKanzashiSyncableStaffMembers$Status$201 | Response$merchantDashboardSettingGetNotification$Status$200 | Response$merchantDashboardSettingUpdateNotification$Status$200 | Response$merchantBulkMesssageBundleQuota$Status$200 | Response$fetchMerchantsInfoAboutSubscriptionProduct$Status$200 | Response$fetchMerchantsInfoAboutTicketBookProduct$Status$200 | Response$publishSubscriptionProduct$Status$200 | Response$publishTicketBookProduct$Status$200 | Response$getOrganizationDashboardAnalyticsQuery$Status$200 | Response$getOrganizationDashboardMerchants$Status$200 | Response$getOrganizationDashboardResourceSelectors$Status$200 | Response$getOrganizationDashboardProducts$Status$200 | Response$fetchCurrentEndUser$Status$200 | Response$postUserCheckin$Status$200 | Response$fetchUserReservations$Status$200 | Response$createPaymentMethod$Status$201 | Response$setupPaymentMethod$Status$200 | Response$getMerchantDetail$Status$200 | Response$getReservationStats$Status$200 | Response$getBookingPageDetail$Status$200 | Response$getBookingCalendarMeta$Status$200 | Response$getVoucherList$Status$200 | Response$getVoucherDetail$Status$200 | Response$getMerchantProduct$Status$200 | Response$getMerchantProductFirstCharge$Status$200 | Response$getLineMiniAppMeta$Status$200 | Response$getReservationFlowMe$Status$200 | Response$getReservationFlowMerchantOptIn$Status$200 | Response$getReservationFlowMerchantReservationStats$Status$200 | Response$getReservationFlowEventSchemeTimeSlots$Status$200 | Response$getReservationFlowEventSchemeTimeSlot$Status$200 | Response$getReservationFlowEventSchemeResource$Status$200 | Response$getReservationFlowCustomFields$Status$200 | Response$getReservationFlowVersion$Status$200 | Response$getReservationFlowMetaInfo$Status$200 | Response$getReservationFlowEventSchemePaymentMethodList$Status$200 | Response$validateReservationFlowEventSchemeReservationFormData$Status$200 | Response$finalizeReservationFlowEventSchemeReservationWithFormData$Status$200 | Response$holdReservationFlowEventSchemeReservationWithFormData$Status$200 | Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$200 | Response$validateReservationFlowCourseSchemeReservationFormData$Status$200 | Response$getReservationFlowCourseSchemeCourses$Status$200 | Response$getReservationFlowCourseSchemeStaffMembers$Status$200 | Response$finalizeReservationFlowCourseSchemeReservationFormData$Status$200 | Response$holdReservationFlowCourseSchemeReservationFormData$Status$200 | Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$200 | Response$getReservationFlowCourseSchemePaymentMethodList$Status$200 | Response$getReservationFlowCourseSchemeResource$Status$200 | Response$getReservationFlowCourseSchemeAvailabilityBoard$Status$200 | Response$getReservationFlowCourseSchemeAvailabilityCalendarIndex$Status$200 | Response$getReservationFlowCourseSchemeAvailabilityCalendarTimes$Status$200 | Response$showReservationDetailForReservationFlowEventScheme$Status$200 | Response$showReservationDetailForReservationFlowCourseScheme$Status$200 | Response$userTimeSlotWaitingGuestSessions$Status$201 | Response$userReservationTokenVerifications$Status$200 | Response$userTimeSlotWaitingFingerprintVerifications$Status$200 | Response$purchaseReservationFlowSubscription$Status$200 | Response$startReservationFlowSubscriptionPurchase$Status$200 | Response$notifyConfirmedReservationFlowSubscription$Status$200 | Response$getReservationFlowCustomerSubscriptionReservationAvailableCount$Status$200 | Response$startTicketBookPurchase$Status$200 | Response$notifyConfirmedTicketBookPurchase$Status$200 | Response$getReservationFlowTicketBookReservationAvailableCount$Status$200 | Response$getReservationFlowProduct$Status$200 | Response$apiDashboardCreateBillingRequest$Status$200 | Response$getBlockByOtherMerchantsReservations$Status$200 | Response$getLineMessageUsage$Status$200 | Response$getMessageUsage$Status$200 | Response$uploadLineMessageImage$Status$201 | Response$getLineMessages$Status$200 | Response$createLineMessage$Status$200 | Response$deliverLineMessage$Status$200 | Response$getLineMessage$Status$200 | Response$deleteDraftLineMessage$Status$200 | Response$getLineMessageRecipientCandidates$Status$200 | Response$getLineMessageRecipients$Status$200 | Response$lineMessagingAPIChannelSecretVerification$Status$200 | Response$getLineMessageChannelSecret$Status$200 | Response$createOrUpdateTester$Status$200 | Response$getLineMessagingApiAvailability$Status$200 | Response$getLineMessagingApiIntegrationStatus$Status$200 | Response$getLineMessagingApiChannelInfo$Status$200 | Response$apiDashboardListOperableShops$Status$200 | Response$apiDashboardListShops$Status$200 | Response$apiDashboardDashboardAccessibilities$Status$200 | Response$apiDashboardGetShop$Status$200 | Response$apiDashboardListEmployees$Status$200 | Response$apiDashboardListBusinessEntities$Status$200 | Response$apiDashboardGetBusinessEntity$Status$200 | Response$apiDashboardListAssignSchemeResources$Status$200 | Response$apiDashboardCreateGoogleReserveRequest$Status$201 | Response$apiDashboardListKanzashiIntegratedResources$Status$200 | Response$apiDashboardGetPlanUpgrades$Status$200 | Response$apiDashboardListSmartLists$Status$200 | Response$apiDashboardCreateSmartList$Status$200 | Response$apiDashboardUpdateSmartList$Status$200 | Response$apiDashboardMerchantsGetApiKeyCredential$Status$200 | Response$getStaffManagement$Status$200 | Response$apiDashboardMerchantsLegalNoticeShow$Status$200 | Response$apiDashboardMerchantsLegalNoticePatch$Status$200 | Response$getSmartListMessageAutomations$Status$200 | Response$createSmartListMessageAutomation$Status$201 | Response$getSmartListMessageAutomation$Status$200 | Response$uploadSmartListMessageAutomationImage$Status$201 | Response$getSmartListMessageAutomationStatus$Status$200 | Response$getAvailabilities$Status$200 | Response$getResourceSlideSetting$Status$200 | Response$updateResourceSlideSetting$Status$200 | Response$apiBusinessEntitySystemUpgrade$Status$200 | Response$getSubscription$Status$200 | Response$patchFranchiseeBusinessProfiles$Status$200 | Response$apiDashboardBusinessEntitySystemUpgradeCheck$Status$200 | Response$getFeatureToggle$Status$200 | Response$ExpectedTransfers$Status$200 | Response$CompletedTransfers$Status$200 | Response$getStoresIdTemporaryIdentity$Status$200;
export namespace ErrorResponse {
    export type login = Response$login$Status$400 | Response$login$Status$401;
    export type getCsrfToken = void;
    export type resendVerificationMail = void;
    export type fetchCurrentUser = Response$fetchCurrentUser$Status$401;
    export type fetchMerchantVouchers = void;
    export type getVoucherAssigns = void;
    export type updateVoucherAssigns = Response$updateVoucherAssigns$Status$422;
    export type getMerchantReservation = void;
    export type updateReservation = Response$updateReservation$Status$400;
    export type getMerchantReservationOnlineMeeting = void;
    export type getReservationCustomerMemos = void;
    export type bulkCreateReservationCheckin = Response$bulkCreateReservationCheckin$Status$422;
    export type merchantCustomersSearch = void;
    export type dashboardCustomersSearch = Response$dashboardCustomersSearch$Status$400;
    export type dashboardCustomersBulkDelete = Response$dashboardCustomersBulkDelete$Status$400 | Response$dashboardCustomersBulkDelete$Status$409;
    export type getCustomerSummaryInfo = void;
    export type getCustomerTicketBooks = Response$getCustomerTicketBooks$Status$403 | Response$getCustomerTicketBooks$Status$404;
    export type getCustomerSubscriptions = Response$getCustomerSubscriptions$Status$403 | Response$getCustomerSubscriptions$Status$404;
    export type getCustomerSummarizedReservations = Response$getCustomerSummarizedReservations$Status$403 | Response$getCustomerSummarizedReservations$Status$404;
    export type getCustomerCheckinableReservations = void;
    export type createCustomerCheckin = Response$createCustomerCheckin$Status$422;
    export type apiDashboardListCustomerPurchases = void;
    export type apiDashboardMergeableCustomers = Response$apiDashboardMergeableCustomers$Status$400 | Response$apiDashboardMergeableCustomers$Status$403 | Response$apiDashboardMergeableCustomers$Status$404;
    export type createCustomerMerging = Response$createCustomerMerging$Status$400 | Response$createCustomerMerging$Status$403 | Response$createCustomerMerging$Status$404;
    export type apiDashboardSuggestDuplicatedCustomers = void;
    export type getEventSchemePaymentMethodSetting = void;
    export type updateEventSchemePaymentMethodSetting = Response$updateEventSchemePaymentMethodSetting$Status$422;
    export type getEventSchemePaymentMethodList = void;
    export type getCourseSchemePaymentMethodSetting = void;
    export type updateCourseSchemePaymentMethodSetting = Response$updateCourseSchemePaymentMethodSetting$Status$422;
    export type GetDatetimeSelectionUiType = void;
    export type PatchDatetimeSelectionUiType = Response$PatchDatetimeSelectionUiType$Status$422;
    export type getPaymentMethodSettingOfCourse = void;
    export type updatePaymentMethodSettingOfCourse = Response$updatePaymentMethodSettingOfCourse$Status$422;
    export type getPaymentMethodListsOfCourse = void;
    export type getMerchantEquipmentList = void;
    export type editMerchantEquipment = Response$editMerchantEquipment$Status$422;
    export type getEquipmentReservations = Response$getEquipmentReservations$Status$422;
    export type getEquipmentGoogleCalendarSync = void;
    export type updateEquipmentGoogleCalendarSync = Response$updateEquipmentGoogleCalendarSync$Status$400;
    export type getMerchantEquipmentAll = void;
    export type getEquipmentBlocks = void;
    export type getProducts = void;
    export type getReservations = void;
    export type getCalendarStaffNonServiceTimes = Response$getCalendarStaffNonServiceTimes$Status$400 | Response$getCalendarStaffNonServiceTimes$Status$403;
    export type getGoogleCalendarsCalendarWithEquipment = void;
    export type createGoogleCalendar = void;
    export type getResourceDetail = Response$getResourceDetail$Status$403;
    export type getMerchantResourcesCourses = Response$getMerchantResourcesCourses$Status$403;
    export type createCourse = Response$createCourse$Status$422;
    export type fetchCourseDetail = Response$fetchCourseDetail$Status$403;
    export type updateCourse = Response$updateCourse$Status$422;
    export type getResourceCustomerFields = void;
    export type sortResourcesCustomerFields = Response$sortResourcesCustomerFields$Status$422;
    export type updateResourcesCustomerFields = void;
    export type getMerchantOptionsList = void;
    export type createOption = void;
    export type createOfflineReservation = Response$createOfflineReservation$Status$400 | Response$createOfflineReservation$Status$422;
    export type createDuplicationRequest = Response$createDuplicationRequest$Status$422;
    export type deleteResourcesOption = void;
    export type updateResourcesOption = void;
    export type getTimeSlotResources = void;
    export type getCourseResources = void;
    export type getCourseResourceTimeUnit = void;
    export type updateCourseResourceTimeUnit = Response$updateCourseResourceTimeUnit$Status$422;
    export type listCourseOption = void;
    export type getMonthlyAvailabilities = void;
    export type sendAccessLog = void;
    export type getMerchantRepresentative = void;
    export type patchMMerchantRepresentatives = void;
    export type getTimeSlots = void;
    export type getReservationsPerTimeSlot = void;
    export type getMerchantResourcesScheduledPriceSettings = Response$getMerchantResourcesScheduledPriceSettings$Status$403;
    export type postMerchantResourcesScheduledPriceSettings = Response$postMerchantResourcesScheduledPriceSettings$Status$422;
    export type getReservablePeriod = void;
    export type patchReservablePeriod = Response$patchReservablePeriod$Status$400 | Response$patchReservablePeriod$Status$422;
    export type deleteTimeSlot = void;
    export type fetchSellerDetail = Response$fetchSellerDetail$Status$400;
    export type updateSellerDetail = Response$updateSellerDetail$Status$422;
    export type getLineMiniAppStatus = void;
    export type submitLineMiniAppExamination = Response$submitLineMiniAppExamination$Status$422;
    export type getEndUserReservationLimit = void;
    export type updateEndUserReservationLimitation = Response$updateEndUserReservationLimitation$Status$422;
    export type transferSchedule = Response$transferSchedule$Status$401;
    export type payoutSchedule = Response$payoutSchedule$Status$401;
    export type payoutList = Response$payoutList$Status$401;
    export type expectedPayoutList = Response$expectedPayoutList$Status$401;
    export type downloadPayout = Response$downloadPayout$Status$422;
    export type downloadExpectedPayout = Response$downloadExpectedPayout$Status$422;
    export type getDashboardCalendarSetting = void;
    export type updateDashboardCalendarSetting = Response$updateDashboardCalendarSetting$Status$422;
    export type getGoogleAnalyticsFour = Response$getGoogleAnalyticsFour$Status$403;
    export type deleteGoogleAnalyticsFour = Response$deleteGoogleAnalyticsFour$Status$403;
    export type updateGoogleAnalyticsFour = Response$updateGoogleAnalyticsFour$Status$403 | Response$updateGoogleAnalyticsFour$Status$422;
    export type getStaffList = void;
    export type createNewStaff = Response$createNewStaff$Status$422;
    export type getStaffManagementLimitReached = void;
    export type bulkDeleteStaff = Response$bulkDeleteStaff$Status$422;
    export type getStaffDailySchedulesList = Response$getStaffDailySchedulesList$Status$403;
    export type bulkUpdateStaffDailySchedule = Response$bulkUpdateStaffDailySchedule$Status$403 | Response$bulkUpdateStaffDailySchedule$Status$422;
    export type getStaffMonthlySchedules = Response$getStaffMonthlySchedules$Status$403;
    export type getStaffWorkingHour = Response$getStaffWorkingHour$Status$403 | Response$getStaffWorkingHour$Status$404;
    export type getStaffListForStaffDailySchedule = void;
    export type getStaffDailyScheduleHintDisplayHistoryCreatability = void;
    export type createStaffDailyScheduleHintDisplayHistory = Response$createStaffDailyScheduleHintDisplayHistory$Status$400 | Response$createStaffDailyScheduleHintDisplayHistory$Status$422;
    export type getStaffCourseAssignersList = Response$getStaffCourseAssignersList$Status$400;
    export type getQrSelfCheckinImage = void;
    export type createEventDefaultStaffAssignment = Response$createEventDefaultStaffAssignment$Status$422;
    export type deleteEventDefaultStaffAssignment = Response$deleteEventDefaultStaffAssignment$Status$400;
    export type getEventDefaultStaffAssignments = void;
    export type getAllCourseStaffAssignments = Response$getAllCourseStaffAssignments$Status$400 | Response$getAllCourseStaffAssignments$Status$403;
    export type putResourceOnboardingTodo = Response$putResourceOnboardingTodo$Status$400 | Response$putResourceOnboardingTodo$Status$422;
    export type putResourceRecommendedSettingVisibility = Response$putResourceRecommendedSettingVisibility$Status$400 | Response$putResourceRecommendedSettingVisibility$Status$422;
    export type patchResourceArchive = Response$patchResourceArchive$Status$422;
    export type getMerchantSetting = void;
    export type updateMerchantSetting = Response$updateMerchantSetting$Status$422;
    export type updateMerchantSiteVisibility = Response$updateMerchantSiteVisibility$Status$422;
    export type getSiteDetail = void;
    export type updateSiteDetail = Response$updateSiteDetail$Status$400 | Response$updateSiteDetail$Status$422;
    export type putSitePublicId = Response$putSitePublicId$Status$422;
    export type uploadImage = Response$uploadImage$Status$400 | Response$uploadImage$Status$401 | Response$uploadImage$Status$422;
    export type getCategories = void;
    export type getTemporaryDates = void;
    export type createTemporaryDate = Response$createTemporaryDate$Status$422;
    export type getTemporaryDate = void;
    export type deleteTemporaryDate = Response$deleteTemporaryDate$Status$422;
    export type editTemporaryDate = Response$editTemporaryDate$Status$422;
    export type duplicationStatus = Response$duplicationStatus$Status$403;
    export type getPublishedResourcesCount = void;
    export type getOnboardingTodo = void;
    export type putOnboardingTodo = Response$putOnboardingTodo$Status$400 | Response$putOnboardingTodo$Status$422;
    export type getGoogleConnect = void;
    export type getInquiryFormAutoFill = void;
    export type getUpgrades = void;
    export type putUsageTips = void;
    export type getCustomerAttributeDefinitions = void;
    export type createCustomer = Response$createCustomer$Status$422;
    export type triggerCsvExport = Response$triggerCsvExport$Status$422;
    export type customersCsvImportRequest = Response$customersCsvImportRequest$Status$422;
    export type getTicketBookProducts = void;
    export type getSubscriptionProducts = void;
    export type dashboardCustomerInvitation = Response$dashboardCustomerInvitation$Status$422;
    export type createCustomerMemo = Response$createCustomerMemo$Status$422;
    export type getCustomerMemo = void;
    export type deleteCustomerMemos = void;
    export type updateCustomerMemo = Response$updateCustomerMemo$Status$422;
    export type getMerchantDashboardAnalyticsQuery = void;
    export type downloadMerchantDashboardAnalyticsQuerySjisCsv = void;
    export type getMerchantDashboardBusinessInformation = void;
    export type updateMerchantDashboardBusinessInformation = Response$updateMerchantDashboardBusinessInformation$Status$422;
    export type getMerchantDashboardDefaultBusinessInformation = void;
    export type patchMerchantPublicId = Response$patchMerchantPublicId$Status$409 | Response$patchMerchantPublicId$Status$422;
    export type getBillings = void;
    export type getOfflineReservationResourceTimeSlots = Response$getOfflineReservationResourceTimeSlots$Status$404;
    export type getKanzashiIntegrationProgress = void;
    export type updateKanzashiIntegrationProgress = Response$updateKanzashiIntegrationProgress$Status$404 | Response$updateKanzashiIntegrationProgress$Status$422;
    export type getKanzashiBusinessInformationRequest = Response$getKanzashiBusinessInformationRequest$Status$404;
    export type createKanzashiBusinessInformationRequest = Response$createKanzashiBusinessInformationRequest$Status$422;
    export type createKanzashiIntegrationResourceRequest = Response$createKanzashiIntegrationResourceRequest$Status$404 | Response$createKanzashiIntegrationResourceRequest$Status$422;
    export type getKanzashiHmacForSignIn = Response$getKanzashiHmacForSignIn$Status$422;
    export type getKanzashiAcceptableCountSetting = void;
    export type updateKanzashiAcceptableCountSetting = Response$updateKanzashiAcceptableCountSetting$Status$422;
    export type getKanzashiExcludeStaffMembers = void;
    export type bulkCreateKanzashiSyncableStaffMembers = Response$bulkCreateKanzashiSyncableStaffMembers$Status$404 | Response$bulkCreateKanzashiSyncableStaffMembers$Status$422;
    export type bulkDeleteKanzashiSyncableStaffMembers = Response$bulkDeleteKanzashiSyncableStaffMembers$Status$422;
    export type merchantDashboardSettingGetNotification = void;
    export type merchantDashboardSettingUpdateNotification = void;
    export type merchantBulkMesssageBundleQuota = void;
    export type fetchMerchantsInfoAboutSubscriptionProduct = void;
    export type fetchMerchantsInfoAboutTicketBookProduct = void;
    export type publishSubscriptionProduct = Response$publishSubscriptionProduct$Status$422;
    export type publishTicketBookProduct = Response$publishTicketBookProduct$Status$422;
    export type getOrganizationDashboardAnalyticsQuery = void;
    export type downloadOrganizationDashboardAnalyticsQuerySjisCsv = void;
    export type getOrganizationDashboardMerchants = void;
    export type getOrganizationDashboardResourceSelectors = void;
    export type getOrganizationDashboardProducts = void;
    export type fetchCurrentEndUser = Response$fetchCurrentEndUser$Status$401;
    export type postUserCheckin = Response$postUserCheckin$Status$400;
    export type fetchUserReservations = void;
    export type createPaymentMethod = void;
    export type setupPaymentMethod = void;
    export type confirmPaymentMethod = void;
    export type updateUsersMeLocale = void;
    export type getMerchantDetail = Response$getMerchantDetail$Status$403;
    export type getReservationStats = void;
    export type getBookingPageDetail = void;
    export type getBookingCalendarMeta = void;
    export type getVoucherList = void;
    export type getVoucherDetail = void;
    export type getMerchantProduct = void;
    export type getMerchantProductFirstCharge = void;
    export type getLineMiniAppMeta = Response$getLineMiniAppMeta$Status$404;
    export type getReservationFlowMe = void;
    export type verifyReservationFlowResource = void;
    export type getReservationFlowMerchantOptIn = void;
    export type getReservationFlowMerchantReservationStats = void;
    export type getReservationFlowEventSchemeTimeSlots = void;
    export type getReservationFlowEventSchemeTimeSlot = Response$getReservationFlowEventSchemeTimeSlot$Status$404;
    export type getReservationFlowEventSchemeResource = void;
    export type getReservationFlowCustomFields = void;
    export type getReservationFlowVersion = void;
    export type getReservationFlowMetaInfo = void;
    export type getReservationFlowEventSchemePaymentMethodList = void;
    export type validateReservationFlowEventSchemeReservationFormData = Response$validateReservationFlowEventSchemeReservationFormData$Status$400;
    export type finalizeReservationFlowEventSchemeReservationWithFormData = Response$finalizeReservationFlowEventSchemeReservationWithFormData$Status$400;
    export type holdReservationFlowEventSchemeReservationWithFormData = Response$holdReservationFlowEventSchemeReservationWithFormData$Status$400 | Response$holdReservationFlowEventSchemeReservationWithFormData$Status$429 | Response$holdReservationFlowEventSchemeReservationWithFormData$Status$502;
    export type notifyConfirmedPrepaymentForReservationFlowEventScheme = Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$400 | Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$429 | Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$502;
    export type validateReservationFlowCourseSchemeReservationFormData = Response$validateReservationFlowCourseSchemeReservationFormData$Status$400 | Response$validateReservationFlowCourseSchemeReservationFormData$Status$404;
    export type getReservationFlowCourseSchemeCourses = void;
    export type getReservationFlowCourseSchemeStaffMembers = void;
    export type finalizeReservationFlowCourseSchemeReservationFormData = Response$finalizeReservationFlowCourseSchemeReservationFormData$Status$400;
    export type holdReservationFlowCourseSchemeReservationFormData = Response$holdReservationFlowCourseSchemeReservationFormData$Status$400 | Response$holdReservationFlowCourseSchemeReservationFormData$Status$429 | Response$holdReservationFlowCourseSchemeReservationFormData$Status$502;
    export type notifyConfirmedPrepaymentForReservationFlowCourseScheme = Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$400 | Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$429 | Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$502;
    export type getReservationFlowCourseSchemePaymentMethodList = Response$getReservationFlowCourseSchemePaymentMethodList$Status$400 | Response$getReservationFlowCourseSchemePaymentMethodList$Status$404;
    export type getReservationFlowCourseSchemeResource = void;
    export type getReservationFlowCourseSchemeAvailabilityBoard = void;
    export type getReservationFlowCourseSchemeAvailabilityCalendarIndex = void;
    export type getReservationFlowCourseSchemeAvailabilityCalendarTimes = void;
    export type showReservationDetailForReservationFlowEventScheme = Response$showReservationDetailForReservationFlowEventScheme$Status$404;
    export type showReservationDetailForReservationFlowCourseScheme = Response$showReservationDetailForReservationFlowCourseScheme$Status$404;
    export type userReservationGuestSessions = void;
    export type userTimeSlotWaitingGuestSessions = Response$userTimeSlotWaitingGuestSessions$Status$401;
    export type userReservationTokenVerifications = void;
    export type userTimeSlotWaitingFingerprintVerifications = void;
    export type purchaseReservationFlowSubscription = Response$purchaseReservationFlowSubscription$Status$400;
    export type startReservationFlowSubscriptionPurchase = Response$startReservationFlowSubscriptionPurchase$Status$400;
    export type notifyConfirmedReservationFlowSubscription = Response$notifyConfirmedReservationFlowSubscription$Status$400;
    export type getReservationFlowCustomerSubscriptionReservationAvailableCount = void;
    export type startTicketBookPurchase = Response$startTicketBookPurchase$Status$400;
    export type notifyConfirmedTicketBookPurchase = Response$notifyConfirmedTicketBookPurchase$Status$400;
    export type getReservationFlowTicketBookReservationAvailableCount = void;
    export type getReservationFlowProduct = void;
    export type postReservationFlowProductVerify = Response$postReservationFlowProductVerify$Status$401;
    export type postReservationFlowMerchantThrottle = void;
    export type apiDashboardCreateBillingRequest = Response$apiDashboardCreateBillingRequest$Status$400 | Response$apiDashboardCreateBillingRequest$Status$404 | Response$apiDashboardCreateBillingRequest$Status$422;
    export type getBlockByOtherMerchantsReservations = void;
    export type getLineMessageUsage = Response$getLineMessageUsage$Status$400 | Response$getLineMessageUsage$Status$403 | Response$getLineMessageUsage$Status$404;
    export type getMessageUsage = Response$getMessageUsage$Status$400 | Response$getMessageUsage$Status$403 | Response$getMessageUsage$Status$404;
    export type uploadLineMessageImage = Response$uploadLineMessageImage$Status$400 | Response$uploadLineMessageImage$Status$403 | Response$uploadLineMessageImage$Status$422;
    export type getLineMessages = Response$getLineMessages$Status$400 | Response$getLineMessages$Status$403 | Response$getLineMessages$Status$404;
    export type createLineMessage = Response$createLineMessage$Status$400 | Response$createLineMessage$Status$403 | Response$createLineMessage$Status$422;
    export type deliverLineMessage = Response$deliverLineMessage$Status$400 | Response$deliverLineMessage$Status$403 | Response$deliverLineMessage$Status$404 | Response$deliverLineMessage$Status$422;
    export type getLineMessage = Response$getLineMessage$Status$403 | Response$getLineMessage$Status$404;
    export type deleteDraftLineMessage = Response$deleteDraftLineMessage$Status$400 | Response$deleteDraftLineMessage$Status$403 | Response$deleteDraftLineMessage$Status$404 | Response$deleteDraftLineMessage$Status$422;
    export type updateDraftLineMessage = Response$updateDraftLineMessage$Status$400 | Response$updateDraftLineMessage$Status$403 | Response$updateDraftLineMessage$Status$404 | Response$updateDraftLineMessage$Status$422;
    export type getLineMessageRecipientCandidates = Response$getLineMessageRecipientCandidates$Status$400 | Response$getLineMessageRecipientCandidates$Status$403 | Response$getLineMessageRecipientCandidates$Status$404;
    export type getLineMessageRecipients = Response$getLineMessageRecipients$Status$400 | Response$getLineMessageRecipients$Status$403 | Response$getLineMessageRecipients$Status$404;
    export type lineMessagingAPIChannelSecretVerification = Response$lineMessagingAPIChannelSecretVerification$Status$403;
    export type getLineMessageChannelSecret = Response$getLineMessageChannelSecret$Status$403 | Response$getLineMessageChannelSecret$Status$404;
    export type deleteLineMessageChannelSecret = Response$deleteLineMessageChannelSecret$Status$403;
    export type lineMessagingAPIChannelSecretRegistration = Response$lineMessagingAPIChannelSecretRegistration$Status$403 | Response$lineMessagingAPIChannelSecretRegistration$Status$422;
    export type createOrUpdateTester = Response$createOrUpdateTester$Status$400 | Response$createOrUpdateTester$Status$403;
    export type getLineMessagingApiAvailability = Response$getLineMessagingApiAvailability$Status$400 | Response$getLineMessagingApiAvailability$Status$403;
    export type getLineMessagingApiIntegrationStatus = Response$getLineMessagingApiIntegrationStatus$Status$403;
    export type getLineMessagingApiChannelInfo = Response$getLineMessagingApiChannelInfo$Status$400 | Response$getLineMessagingApiChannelInfo$Status$403;
    export type apiDashboardListOperableShops = void;
    export type apiDashboardListShops = void;
    export type apiDashboardDashboardAccessibilities = void;
    export type apiDashboardGetShop = void;
    export type apiDashboardSelectShop = void;
    export type apiDashboardListEmployees = void;
    export type apiDashboardListBusinessEntities = void;
    export type apiDashboardGetBusinessEntity = void;
    export type apiDashboardSelectBusinessEntity = Response$apiDashboardSelectBusinessEntity$Status$400;
    export type apiDashboardListAssignSchemeResources = void;
    export type apiDashboardCreateGoogleReserveRequest = Response$apiDashboardCreateGoogleReserveRequest$Status$422;
    export type apiDashboardListKanzashiIntegratedResources = Response$apiDashboardListKanzashiIntegratedResources$Status$404;
    export type apiDashboardGetPlanUpgrades = Response$apiDashboardGetPlanUpgrades$Status$400 | Response$apiDashboardGetPlanUpgrades$Status$404;
    export type apiDashboardListSmartLists = Response$apiDashboardListSmartLists$Status$403;
    export type apiDashboardCreateSmartList = Response$apiDashboardCreateSmartList$Status$400 | Response$apiDashboardCreateSmartList$Status$403 | Response$apiDashboardCreateSmartList$Status$422;
    export type apiDashboardDeleteSmartList = Response$apiDashboardDeleteSmartList$Status$403 | Response$apiDashboardDeleteSmartList$Status$404 | Response$apiDashboardDeleteSmartList$Status$422;
    export type apiDashboardUpdateSmartList = Response$apiDashboardUpdateSmartList$Status$403 | Response$apiDashboardUpdateSmartList$Status$404 | Response$apiDashboardUpdateSmartList$Status$422;
    export type apiDashboardMerchantsCreatePrimaryEmailUpdateRequest = void;
    export type apiDashboardMerchantsGetApiKeyCredential = void;
    export type getStaffManagement = void;
    export type apiDashboardMerchantsBulkCreateStaff = void;
    export type apiDashboardMerchantsLegalNoticeShow = void;
    export type apiDashboardMerchantsLegalNoticePatch = void;
    export type getSmartListMessageAutomations = Response$getSmartListMessageAutomations$Status$403;
    export type createSmartListMessageAutomation = Response$createSmartListMessageAutomation$Status$403 | Response$createSmartListMessageAutomation$Status$422;
    export type getSmartListMessageAutomation = Response$getSmartListMessageAutomation$Status$403 | Response$getSmartListMessageAutomation$Status$404;
    export type deleteSmartListMessageAutomation = Response$deleteSmartListMessageAutomation$Status$403 | Response$deleteSmartListMessageAutomation$Status$404;
    export type updateSmartListMessageAutomation = Response$updateSmartListMessageAutomation$Status$403 | Response$updateSmartListMessageAutomation$Status$404 | Response$updateSmartListMessageAutomation$Status$422;
    export type uploadSmartListMessageAutomationImage = Response$uploadSmartListMessageAutomationImage$Status$400 | Response$uploadSmartListMessageAutomationImage$Status$403 | Response$uploadSmartListMessageAutomationImage$Status$422;
    export type getSmartListMessageAutomationStatus = Response$getSmartListMessageAutomationStatus$Status$403;
    export type getAvailabilities = Response$getAvailabilities$Status$400 | Response$getAvailabilities$Status$404;
    export type getResourceSlideSetting = Response$getResourceSlideSetting$Status$403 | Response$getResourceSlideSetting$Status$404;
    export type updateResourceSlideSetting = Response$updateResourceSlideSetting$Status$400 | Response$updateResourceSlideSetting$Status$403 | Response$updateResourceSlideSetting$Status$404;
    export type apiBusinessEntitySystemUpgrade = void;
    export type postBusinessEntitySystemUpgrade = void;
    export type getSubscription = Response$getSubscription$Status$400 | Response$getSubscription$Status$403 | Response$getSubscription$Status$404 | Response$getSubscription$Status$422;
    export type updateSubscription = Response$updateSubscription$Status$400 | Response$updateSubscription$Status$403 | Response$updateSubscription$Status$404 | Response$updateSubscription$Status$422;
    export type patchFranchiseeBusinessProfiles = Response$patchFranchiseeBusinessProfiles$Status$400;
    export type apiDashboardBusinessEntitySystemUpgradeCheck = void;
    export type createReservationsCSV = Response$createReservationsCSV$Status$400 | Response$createReservationsCSV$Status$403 | Response$createReservationsCSV$Status$422;
    export type getFeatureToggle = void;
    export type ExpectedTransfers = Response$ExpectedTransfers$Status$401;
    export type CompletedTransfers = Response$CompletedTransfers$Status$401;
    export type getStoresIdTemporaryIdentity = void;
    export type createStoresIdReserveAccount = Response$createStoresIdReserveAccount$Status$400 | Response$createStoresIdReserveAccount$Status$422;
    export type webDashboardMerchantsApplyPrimaryEmailUpdateRequest = void;
    export type webDashboardCustomersPurchaseCsv = void;
    export type applyWebviewToken = void;
}
export interface Encoding {
    readonly contentType?: string;
    headers?: Record<string, any>;
    readonly style?: "form" | "spaceDelimited" | "pipeDelimited" | "deepObject";
    readonly explode?: boolean;
    readonly allowReserved?: boolean;
}
export interface RequestArgs {
    readonly httpMethod: HttpMethod;
    readonly url: string;
    headers: ObjectLike | any;
    requestBody?: ObjectLike | any;
    requestBodyEncoding?: Record<string, Encoding>;
    queryParameters?: QueryParameters | undefined;
}
export interface ApiClient<RequestOption> {
    request: <T = SuccessResponses>(requestArgs: RequestArgs, options?: RequestOption) => Promise<T>;
}
export class Client<RequestOption> {
    private baseUrl: string;
    constructor(private apiClient: ApiClient<RequestOption>, baseUrl: string) { this.baseUrl = baseUrl.replace(/\/$/, ""); }
    /**
     * ログインを実施するエンドポイント
     * operationId: login
     * Request URI: /sessions
     */
    public async login(params: Params$login, option?: RequestOption): Promise<Response$login$Status$200["application/json"]> {
        const url = this.baseUrl + `/sessions`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * CsrfTokenを発行する
     * operationId: getCsrfToken
     * Request URI: /_/csrf
     */
    public async getCsrfToken(option?: RequestOption): Promise<Response$getCsrfToken$Status$200["application/json"]> {
        const url = this.baseUrl + `/_/csrf`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * メールアドレスを認証するためのメールを再送信する
     * operationId: resendVerificationMail
     * Request URI: /users/verification_mail.json
     */
    public async resendVerificationMail(option?: RequestOption): Promise<Response$resendVerificationMail$Status$200["application/json"]> {
        const url = this.baseUrl + `/users/verification_mail.json`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * fetch current user
     * ログイン済ユーザー, target merchant情報, 課金情報, 事前決済事業者情報を取得. スタッフや組織管理者としてログインした場合も存在する
     * operationId: fetchCurrentUser
     * Request URI: /m/me
     */
    public async fetchCurrentUser(option?: RequestOption): Promise<Response$fetchCurrentUser$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/me`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * fetch merchant vouchers
     * operationId: fetchMerchantVouchers
     * Request URI: /m/vouchers
     */
    public async fetchMerchantVouchers(params: Params$fetchMerchantVouchers, option?: RequestOption): Promise<Response$fetchMerchantVouchers$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/vouchers`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * getVoucherAssigns
     * operationId: getVoucherAssigns
     * Request URI: /m/vouchers/{voucher_public_id}/voucher_assigns
     */
    public async getVoucherAssigns(params: Params$getVoucherAssigns, option?: RequestOption): Promise<Response$getVoucherAssigns$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/vouchers/${encodeURIComponent(params.parameter.voucher_public_id)}/voucher_assigns`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update voucher assigns
     * operationId: updateVoucherAssigns
     * Request URI: /m/vouchers/{voucher_public_id}/voucher_assigns
     */
    public async updateVoucherAssigns(params: Params$updateVoucherAssigns, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/vouchers/${encodeURIComponent(params.parameter.voucher_public_id)}/voucher_assigns`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get reservation
     * 確定予約詳細(for merchant, staff)
     * operationId: getMerchantReservation
     * Request URI: /m/reservations/{reservation_public_id}.json
     */
    public async getMerchantReservation(params: Params$getMerchantReservation, option?: RequestOption): Promise<Response$getMerchantReservation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update reservation
     * 確定予約の更新(for merchant, staff). 一部のかんざし経由の予約は更新できない.
     * operationId: updateReservation
     * Request URI: /m/reservations/{reservation_public_id}.json
     */
    public async updateReservation(params: Params$updateReservation, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}.json`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get reservation online meeting
     * operationId: getMerchantReservationOnlineMeeting
     * Request URI: /m/reservations/{reservation_public_id}/online_meeting.json
     */
    public async getMerchantReservationOnlineMeeting(params: Params$getMerchantReservationOnlineMeeting, option?: RequestOption): Promise<Response$getMerchantReservationOnlineMeeting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}/online_meeting.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 予約の顧客メモの一覧を取得
     * operationId: getReservationCustomerMemos
     * Request URI: /m/reservations/{reservation_public_id}/customer_memos
     */
    public async getReservationCustomerMemos(params: Params$getReservationCustomerMemos, option?: RequestOption): Promise<Response$getReservationCustomerMemos$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}/customer_memos`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * bulk create reservation checkin
     * operationId: bulkCreateReservationCheckin
     * Request URI: /m/reservations/bulk_checkin.json
     */
    public async bulkCreateReservationCheckin(params: Params$bulkCreateReservationCheckin, option?: RequestOption): Promise<Response$bulkCreateReservationCheckin$Status$201["application/json"]> {
        const url = this.baseUrl + `/m/reservations/bulk_checkin.json`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            "reservation_public_ids[]": { value: params.parameter["reservation_public_ids[]"], explode: false }
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * search customers
     * 今のところページネーション考慮してないのでtodo
     * operationId: merchantCustomersSearch
     * Request URI: /m/customers/search
     */
    public async merchantCustomersSearch(params: Params$merchantCustomersSearch, option?: RequestOption): Promise<Response$merchantCustomersSearch$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/search`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            name: { value: params.parameter.name, explode: false },
            email: { value: params.parameter.email, explode: false },
            phone_number: { value: params.parameter.phone_number, explode: false },
            ids: { value: params.parameter.ids, explode: false },
            global_select_all: { value: params.parameter.global_select_all, explode: false },
            search_params: { value: params.parameter.search_params, style: "deepObject", explode: true },
            unlimited: { value: params.parameter.unlimited, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 顧客一覧を取得する
     * operationId: dashboardCustomersSearch
     * Request URI: /m/customers/dashboard_search
     */
    public async dashboardCustomersSearch(params: Params$dashboardCustomersSearch, option?: RequestOption): Promise<Response$dashboardCustomersSearch$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/dashboard_search`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            keyword: { value: params.parameter.keyword, explode: false },
            reservation: { value: params.parameter.reservation, explode: false },
            "customer_invitation_status[]": { value: params.parameter["customer_invitation_status[]"], explode: false },
            "has_line_user[]": { value: params.parameter["has_line_user[]"], explode: false },
            ticket_book: { value: params.parameter.ticket_book, explode: false },
            subscription: { value: params.parameter.subscription, explode: false },
            "subscription_public_ids[]": { value: params.parameter["subscription_public_ids[]"], explode: false },
            checked_in_count: { value: params.parameter.checked_in_count, style: "deepObject", explode: false },
            page: { value: params.parameter.page, explode: false },
            sort: { value: params.parameter.sort, style: "deepObject", explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 顧客を一括削除する
     * operationId: dashboardCustomersBulkDelete
     * Request URI: /m/customers/dashboard_bulk
     */
    public async dashboardCustomersBulkDelete(params: Params$dashboardCustomersBulkDelete, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/customers/dashboard_bulk`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            global_select_all: { value: params.parameter.global_select_all, explode: false },
            "customer_public_ids[]": { value: params.parameter["customer_public_ids[]"], explode: false },
            keyword: { value: params.parameter.keyword, explode: false },
            reservation: { value: params.parameter.reservation, explode: false },
            "customer_invitation_status[]": { value: params.parameter["customer_invitation_status[]"], explode: false },
            "has_line_user[]": { value: params.parameter["has_line_user[]"], explode: false },
            ticket_book: { value: params.parameter.ticket_book, explode: false },
            subscription: { value: params.parameter.subscription, explode: false },
            "subscription_public_ids[]": { value: params.parameter["subscription_public_ids[]"], explode: false },
            checked_in_count: { value: params.parameter.checked_in_count, style: "deepObject", explode: false }
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 顧客詳細のサマリを取得
     * operationId: getCustomerSummaryInfo
     * Request URI: /m/customers/{customer_public_id}/summary_info
     */
    public async getCustomerSummaryInfo(params: Params$getCustomerSummaryInfo, option?: RequestOption): Promise<Response$getCustomerSummaryInfo$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/summary_info`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 顧客の回数券一覧を取得
     * operationId: getCustomerTicketBooks
     * Request URI: /m/customers/{customer_public_id}/ticket_books
     */
    public async getCustomerTicketBooks(params: Params$getCustomerTicketBooks, option?: RequestOption): Promise<Response$getCustomerTicketBooks$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/ticket_books`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 顧客の月謝一覧を取得
     * operationId: getCustomerSubscriptions
     * Request URI: /m/customers/{customer_public_id}/subscriptions
     */
    public async getCustomerSubscriptions(params: Params$getCustomerSubscriptions, option?: RequestOption): Promise<Response$getCustomerSubscriptions$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/subscriptions`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 顧客の予約一覧を取得
     * operationId: getCustomerSummarizedReservations
     * Request URI: /m/customers/{customer_public_id}/summarized_reservations
     */
    public async getCustomerSummarizedReservations(params: Params$getCustomerSummarizedReservations, option?: RequestOption): Promise<Response$getCustomerSummarizedReservations$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/summarized_reservations`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 顧客のチェックイン可能な予約を取得
     * operationId: getCustomerCheckinableReservations
     * Request URI: /m/customers/{customer_public_id}/checkinable_reservations
     */
    public async getCustomerCheckinableReservations(params: Params$getCustomerCheckinableReservations, option?: RequestOption): Promise<Response$getCustomerCheckinableReservations$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/checkinable_reservations`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * create customer checkin with customer
     * operationId: createCustomerCheckin
     * Request URI: /m/customers/{customer_public_id}/checkins.json
     */
    public async createCustomerCheckin(params: Params$createCustomerCheckin, option?: RequestOption): Promise<Response$createCustomerCheckin$Status$201["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/checkins.json`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 顧客の購入履歴一覧を返す
     * operationId: apiDashboardListCustomerPurchases
     * Request URI: /api/dashboard/customers/{customer_public_id}/purchases
     */
    public async apiDashboardListCustomerPurchases(params: Params$apiDashboardListCustomerPurchases, option?: RequestOption): Promise<Response$apiDashboardListCustomerPurchases$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/customers/${encodeURIComponent(params.parameter.customer_public_id)}/purchases`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * パスにある customer_public_id を統合先として、source_customer_public_ids[] の顧客が統合可能か判定する
     * operationId: apiDashboardMergeableCustomers
     * Request URI: /api/dashboard/customers/{customer_public_id}/mergeable_customers
     */
    public async apiDashboardMergeableCustomers(params: Params$apiDashboardMergeableCustomers, option?: RequestOption): Promise<Response$apiDashboardMergeableCustomers$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/customers/${encodeURIComponent(params.parameter.customer_public_id)}/mergeable_customers`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            "source_customer_public_ids[]": { value: params.parameter["source_customer_public_ids[]"], explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 顧客の統合を行う
     * operationId: createCustomerMerging
     * Request URI: /api/dashboard/customers/{customer_public_id}/merging
     */
    public async createCustomerMerging(params: Params$createCustomerMerging, option?: RequestOption): Promise<Response$createCustomerMerging$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/customers/${encodeURIComponent(params.parameter.customer_public_id)}/merging`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 重複顧客の候補を返す
     * operationId: apiDashboardSuggestDuplicatedCustomers
     * Request URI: /api/dashboard/customers/{customer_public_id}/suggest_duplicated_customers
     */
    public async apiDashboardSuggestDuplicatedCustomers(params: Params$apiDashboardSuggestDuplicatedCustomers, option?: RequestOption): Promise<Response$apiDashboardSuggestDuplicatedCustomers$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/customers/${encodeURIComponent(params.parameter.customer_public_id)}/suggest_duplicated_customers`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M3のお支払い方法設定を取得. 月謝などの紐付けも返却される
     * operationId: getEventSchemePaymentMethodSetting
     * Request URI: /m/event_scheme/{resource_public_id}/payment_method_setting
     */
    public async getEventSchemePaymentMethodSetting(params: Params$getEventSchemePaymentMethodSetting, option?: RequestOption): Promise<Response$getEventSchemePaymentMethodSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/event_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/payment_method_setting`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M3のお支払い方法設定を更新
     * operationId: updateEventSchemePaymentMethodSetting
     * Request URI: /m/event_scheme/{resource_public_id}/payment_method_setting
     */
    public async updateEventSchemePaymentMethodSetting(params: Params$updateEventSchemePaymentMethodSetting, option?: RequestOption): Promise<Response$updateEventSchemePaymentMethodSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/event_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/payment_method_setting`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M3の顧客・予約日付に関連するお支払い方法を返却
     * operationId: getEventSchemePaymentMethodList
     * Request URI: /m/event_scheme/{resource_public_id}/payment_method_list
     */
    public async getEventSchemePaymentMethodList(params: Params$getEventSchemePaymentMethodList, option?: RequestOption): Promise<Response$getEventSchemePaymentMethodList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/event_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/payment_method_list`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            customer_public_id: { value: params.parameter.customer_public_id, explode: false },
            reservation_at: { value: params.parameter.reservation_at, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M1/M4のお支払い方法設定を取得
     * operationId: getCourseSchemePaymentMethodSetting
     * Request URI: /m/course_scheme/{resource_public_id}/payment_method_setting
     */
    public async getCourseSchemePaymentMethodSetting(params: Params$getCourseSchemePaymentMethodSetting, option?: RequestOption): Promise<Response$getCourseSchemePaymentMethodSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/payment_method_setting`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M1/M4のお支払い方法設定を更新
     * operationId: updateCourseSchemePaymentMethodSetting
     * Request URI: /m/course_scheme/{resource_public_id}/payment_method_setting
     */
    public async updateCourseSchemePaymentMethodSetting(params: Params$updateCourseSchemePaymentMethodSetting, option?: RequestOption): Promise<Response$updateCourseSchemePaymentMethodSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/payment_method_setting`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M1/M4新予約フローの日程選択UIタイプを取得
     * operationId: GetDatetimeSelectionUiType
     * Request URI: /m/course_scheme/{resource_public_id}/datetime_selection_ui_type
     */
    public async GetDatetimeSelectionUiType(params: Params$GetDatetimeSelectionUiType, option?: RequestOption): Promise<Response$GetDatetimeSelectionUiType$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/datetime_selection_ui_type`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M1/M4新予約フローの日程選択UIタイプを更新
     * operationId: PatchDatetimeSelectionUiType
     * Request URI: /m/course_scheme/{resource_public_id}/datetime_selection_ui_type
     */
    public async PatchDatetimeSelectionUiType(params: Params$PatchDatetimeSelectionUiType, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/datetime_selection_ui_type`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * コースごとのお支払い方法設定を取得. 月謝などの紐付けも返却される
     * operationId: getPaymentMethodSettingOfCourse
     * Request URI: /m/course_scheme/{resource_public_id}/courses/{course_public_id}/payment_method_setting_of_course
     */
    public async getPaymentMethodSettingOfCourse(params: Params$getPaymentMethodSettingOfCourse, option?: RequestOption): Promise<Response$getPaymentMethodSettingOfCourse$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/payment_method_setting_of_course`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * コースごとのお支払い方法設定を更新
     * operationId: updatePaymentMethodSettingOfCourse
     * Request URI: /m/course_scheme/{resource_public_id}/courses/{course_public_id}/payment_method_setting_of_course
     */
    public async updatePaymentMethodSettingOfCourse(params: Params$updatePaymentMethodSettingOfCourse, option?: RequestOption): Promise<Response$updatePaymentMethodSettingOfCourse$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/payment_method_setting_of_course`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M1/M4の顧客・予約日付に関連するお支払い方法を返却
     * operationId: getPaymentMethodListsOfCourse
     * Request URI: /m/course_scheme/{resource_public_id}/courses/{course_public_id}/payment_method_list_of_course
     */
    public async getPaymentMethodListsOfCourse(params: Params$getPaymentMethodListsOfCourse, option?: RequestOption): Promise<Response$getPaymentMethodListsOfCourse$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_scheme/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/payment_method_list_of_course`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            customer_public_id: { value: params.parameter.customer_public_id, explode: false },
            reservation_at: { value: params.parameter.reservation_at, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get merchant equipment
     * operationId: getMerchantEquipmentList
     * Request URI: /m/equipment.json
     */
    public async getMerchantEquipmentList(params: Params$getMerchantEquipmentList, option?: RequestOption): Promise<Response$getMerchantEquipmentList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            size: { value: params.parameter.size, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * edit equipment
     * operationId: editMerchantEquipment
     * Request URI: /m/equipment/{equipment_id}.json
     */
    public async editMerchantEquipment(params: Params$editMerchantEquipment, option?: RequestOption): Promise<Response$editMerchantEquipment$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment/${encodeURIComponent(params.parameter.equipment_id)}.json`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get reservations
     * operationId: getEquipmentReservations
     * Request URI: /m/equipment/{equipment_id}/reservations.json
     */
    public async getEquipmentReservations(params: Params$getEquipmentReservations, option?: RequestOption): Promise<Response$getEquipmentReservations$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment/${encodeURIComponent(params.parameter.equipment_id)}/reservations.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start: { value: params.parameter.start, explode: false },
            end: { value: params.parameter.end, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Get the GoogleCalendarSync information of equipment
     * operationId: getEquipmentGoogleCalendarSync
     * Request URI: /m/equipment/{equipment_id}/google_calendar_sync.json
     */
    public async getEquipmentGoogleCalendarSync(params: Params$getEquipmentGoogleCalendarSync, option?: RequestOption): Promise<Response$getEquipmentGoogleCalendarSync$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment/${encodeURIComponent(params.parameter.equipment_id)}/google_calendar_sync.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * Update the GoogleCalendarSync information of equipment
     * operationId: updateEquipmentGoogleCalendarSync
     * Request URI: /m/equipment/{equipment_id}/google_calendar_sync.json
     */
    public async updateEquipmentGoogleCalendarSync(params: Params$updateEquipmentGoogleCalendarSync, option?: RequestOption): Promise<Response$updateEquipmentGoogleCalendarSync$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment/${encodeURIComponent(params.parameter.equipment_id)}/google_calendar_sync.json`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get merchant equipment list without paging
     * operationId: getMerchantEquipmentAll
     * Request URI: /m/equipment/all.json
     */
    public async getMerchantEquipmentAll(params: Params$getMerchantEquipmentAll, option?: RequestOption): Promise<Response$getMerchantEquipmentAll$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment/all.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get equipment blocks
     * operationId: getEquipmentBlocks
     * Request URI: /m/equipment_blocks
     */
    public async getEquipmentBlocks(params: Params$getEquipmentBlocks, option?: RequestOption): Promise<Response$getEquipmentBlocks$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/equipment_blocks`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get products
     * operationId: getProducts
     * Request URI: /m/products.json
     */
    public async getProducts(option?: RequestOption): Promise<Response$getProducts$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/products.json`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get reservations (予約台帳)
     * operationId: getReservations
     * Request URI: /m/calendar/reservations.json
     */
    public async getReservations(params: Params$getReservations, option?: RequestOption): Promise<Response$getReservations$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/calendar/reservations.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start: { value: params.parameter.start, explode: false },
            end: { value: params.parameter.end, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get staff non service times (スタッフ非勤務時間)
     * operationId: getCalendarStaffNonServiceTimes
     * Request URI: /m/calendar/staff_non_service_times
     */
    public async getCalendarStaffNonServiceTimes(params: Params$getCalendarStaffNonServiceTimes, option?: RequestOption): Promise<Response$getCalendarStaffNonServiceTimes$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/calendar/staff_non_service_times`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            target_date: { value: params.parameter.target_date, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get google calendars (Googleカレンダー一覧)
     * operationId: getGoogleCalendarsCalendarWithEquipment
     * Request URI: /m/google_calendar/calendar_with_equipment.json
     */
    public async getGoogleCalendarsCalendarWithEquipment(params: Params$getGoogleCalendarsCalendarWithEquipment, option?: RequestOption): Promise<Response$getGoogleCalendarsCalendarWithEquipment$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/google_calendar/calendar_with_equipment.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            size: { value: params.parameter.size, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * create google calendar
     * operationId: createGoogleCalendar
     * Request URI: /m/google_calendar/calendars.json
     */
    public async createGoogleCalendar(params: Params$createGoogleCalendar, option?: RequestOption): Promise<Response$createGoogleCalendar$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/google_calendar/calendars.json`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get resource detail
     * operationId: getResourceDetail
     * Request URI: /m/resources/{resource_public_id}.json
     */
    public async getResourceDetail(params: Params$getResourceDetail, option?: RequestOption): Promise<Response$getResourceDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get courses of resource
     * resourcesのm1/m4の場合にresourceに対応するcoursesを取得する
     * operationId: getMerchantResourcesCourses
     * Request URI: /m/resources/{resource_public_id}/courses.json
     */
    public async getMerchantResourcesCourses(params: Params$getMerchantResourcesCourses, option?: RequestOption): Promise<Response$getMerchantResourcesCourses$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * create course
     * operationId: createCourse
     * Request URI: /m/resources/{resource_public_id}/courses.json
     */
    public async createCourse(params: Params$createCourse, option?: RequestOption): Promise<Response$createCourse$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses.json`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * fetch course detail
     * operationId: fetchCourseDetail
     * Request URI: /m/resources/{resource_public_id}/courses/{course_public_id}.json
     */
    public async fetchCourseDetail(params: Params$fetchCourseDetail, option?: RequestOption): Promise<Response$fetchCourseDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update course
     * operationId: updateCourse
     * Request URI: /m/resources/{resource_public_id}/courses/{course_public_id}.json
     */
    public async updateCourse(params: Params$updateCourse, option?: RequestOption): Promise<Response$updateCourse$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}.json`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get customer fields for resource
     * operationId: getResourceCustomerFields
     * Request URI: /m/resources/{resource_public_id}/customer_fields.json
     */
    public async getResourceCustomerFields(params: Params$getResourceCustomerFields, option?: RequestOption): Promise<Response$getResourceCustomerFields$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/customer_fields.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * sort customer-fields
     * operationId: sortResourcesCustomerFields
     * Request URI: /m/resources/{resource_public_id}/customer_fields/sort
     */
    public async sortResourcesCustomerFields(params: Params$sortResourcesCustomerFields, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/customer_fields/sort`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 予約者情報カスタマイズの情報を更新する
     * operationId: updateResourcesCustomerFields
     * Request URI: /m/resources/{resource_public_id}/customer_fields/{field_binder_id}
     */
    public async updateResourcesCustomerFields(params: Params$updateResourcesCustomerFields, option?: RequestOption): Promise<Response$updateResourcesCustomerFields$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/customer_fields/${encodeURIComponent(params.parameter.field_binder_id)}`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get merchant options
     * operationId: getMerchantOptionsList
     * Request URI: /m/resources/{resource_public_id}/options.json
     */
    public async getMerchantOptionsList(params: Params$getMerchantOptionsList, option?: RequestOption): Promise<Response$getMerchantOptionsList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/options.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            is_published: { value: params.parameter.is_published, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * create option
     * operationId: createOption
     * Request URI: /m/resources/{resource_public_id}/options.json
     */
    public async createOption<RequestContentType extends RequestContentType$createOption>(params: Params$createOption<RequestContentType>, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/options.json`;
        const headers = {
            "Content-Type": params.headers["Content-Type"],
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * create offline reservation
     * merchant dashboard から（予約台帳から）の予約登録
     * operationId: createOfflineReservation
     * Request URI: /m/resources/{resource_public_id}/offline_reservations
     */
    public async createOfflineReservation(params: Params$createOfflineReservation, option?: RequestOption): Promise<Response$createOfflineReservation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/offline_reservations`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * create duplication request
     * operationId: createDuplicationRequest
     * Request URI: /m/resources/{resource_public_id}/duplication
     */
    public async createDuplicationRequest(params: Params$createDuplicationRequest, option?: RequestOption): Promise<Response$createDuplicationRequest$Status$201["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/duplication`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * delete option
     * operationId: deleteResourcesOption
     * Request URI: /m/resources/{resource_public_id}/options/{option_id}
     */
    public async deleteResourcesOption(params: Params$deleteResourcesOption, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/options/${encodeURIComponent(params.parameter.option_id)}`;
        const headers = {};
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * edit option
     * operationId: updateResourcesOption
     * Request URI: /m/resources/{resource_public_id}/options/{option_id}
     */
    public async updateResourcesOption(params: Params$updateResourcesOption, option?: RequestOption): Promise<Response$updateResourcesOption$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/options/${encodeURIComponent(params.parameter.option_id)}`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * イベントタイプ/スクールタイプの予約ページ一覧を取得
     * operationId: getTimeSlotResources
     * Request URI: /m/time_slot_resources
     */
    public async getTimeSlotResources(params: Params$getTimeSlotResources, option?: RequestOption): Promise<Response$getTimeSlotResources$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/time_slot_resources`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            size: { value: params.parameter.size, explode: false },
            publish_status: { value: params.parameter.publish_status, explode: false },
            name: { value: params.parameter.name, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * メニュータイプの予約ページ一覧を取得
     * operationId: getCourseResources
     * Request URI: /m/course_resources
     */
    public async getCourseResources(params: Params$getCourseResources, option?: RequestOption): Promise<Response$getCourseResources$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_resources`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            size: { value: params.parameter.size, explode: false },
            publish_status: { value: params.parameter.publish_status, explode: false },
            name: { value: params.parameter.name, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get course resource time_unit
     * operationId: getCourseResourceTimeUnit
     * Request URI: /m/course_resources/{resource_public_id}/time_unit
     */
    public async getCourseResourceTimeUnit(params: Params$getCourseResourceTimeUnit, option?: RequestOption): Promise<Response$getCourseResourceTimeUnit$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_resources/${encodeURIComponent(params.parameter.resource_public_id)}/time_unit`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update course resource time_unit
     * operationId: updateCourseResourceTimeUnit
     * Request URI: /m/course_resources/{resource_public_id}/time_unit
     */
    public async updateCourseResourceTimeUnit(params: Params$updateCourseResourceTimeUnit, option?: RequestOption): Promise<Response$updateCourseResourceTimeUnit$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/course_resources/${encodeURIComponent(params.parameter.resource_public_id)}/time_unit`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * コースのオプション一覧の取得
     * operationId: listCourseOption
     * Request URI: /m/courses/{course_public_id}/options.json
     */
    public async listCourseOption(params: Params$listCourseOption, option?: RequestOption): Promise<Response$listCourseOption$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/courses/${encodeURIComponent(params.parameter.course_public_id)}/options.json`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 指定した月のavailabilityを取得する
     * operationId: getMonthlyAvailabilities
     * Request URI: /m/courses/{course_public_id}/availabilities
     */
    public async getMonthlyAvailabilities(params: Params$getMonthlyAvailabilities, option?: RequestOption): Promise<Response$getMonthlyAvailabilities$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/courses/${encodeURIComponent(params.parameter.course_public_id)}/availabilities`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            staff_canonical_id: { value: params.parameter.staff_canonical_id, explode: false },
            option_ids: { value: params.parameter.option_ids, explode: false },
            month: { value: params.parameter.month, explode: false },
            extra_availability: { value: params.parameter.extra_availability, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * operationId: sendAccessLog
     * Request URI: /m/access
     */
    public async sendAccessLog(params: Params$sendAccessLog, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/access`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get merchant_representative
     * operationId: getMerchantRepresentative
     * Request URI: /m/merchant_representative
     */
    public async getMerchantRepresentative(params: Params$getMerchantRepresentative, option?: RequestOption): Promise<Response$getMerchantRepresentative$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/merchant_representative`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * create or update merchant_representative
     * operationId: patchMMerchantRepresentatives
     * Request URI: /m/merchant_representative
     */
    public async patchMMerchantRepresentatives(params: Params$patchMMerchantRepresentatives, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/merchant_representative`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * getTimeSlots
     * operationId: getTimeSlots
     * Request URI: /m/time_slots
     */
    public async getTimeSlots(params: Params$getTimeSlots, option?: RequestOption): Promise<Response$getTimeSlots$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/time_slots`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start_at: { value: params.parameter.start_at, explode: false },
            end_at: { value: params.parameter.end_at, explode: false },
            filter_type: { value: params.parameter.filter_type, explode: false },
            resource_public_ids: { value: params.parameter.resource_public_ids, explode: false },
            with_waiting_list: { value: params.parameter.with_waiting_list, explode: false },
            with_assigned_staff_members: { value: params.parameter.with_assigned_staff_members, explode: false },
            includes_school_scheme_slots: { value: params.parameter.includes_school_scheme_slots, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * getReservationsRelatedToTimeSlots
     * 特定の予約枠に関連する予約を返す
     * operationId: getReservationsPerTimeSlot
     * Request URI: /m/time_slots/{time_slot_id}/reservations.json
     */
    public async getReservationsPerTimeSlot(params: Params$getReservationsPerTimeSlot, option?: RequestOption): Promise<Response$getReservationsPerTimeSlot$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/time_slots/${encodeURIComponent(params.parameter.time_slot_id)}/reservations.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            proto: { value: params.parameter.proto, explode: false },
            page: { value: params.parameter.page, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get scheduled_price_settings
     * operationId: getMerchantResourcesScheduledPriceSettings
     * Request URI: /m/resources/{resource_public_id}/scheduled_price_settings.json
     */
    public async getMerchantResourcesScheduledPriceSettings(params: Params$getMerchantResourcesScheduledPriceSettings, option?: RequestOption): Promise<Response$getMerchantResourcesScheduledPriceSettings$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/scheduled_price_settings.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * bulk update scheduled_price_settings
     * operationId: postMerchantResourcesScheduledPriceSettings
     * Request URI: /m/resources/{resource_public_id}/scheduled_price_settings
     */
    public async postMerchantResourcesScheduledPriceSettings(params: Params$postMerchantResourcesScheduledPriceSettings, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/scheduled_price_settings`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get reservable period
     * operationId: getReservablePeriod
     * Request URI: /m/resources/{resource_public_id}/reservable_period
     */
    public async getReservablePeriod(params: Params$getReservablePeriod, option?: RequestOption): Promise<Response$getReservablePeriod$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/reservable_period`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * patch reservable period
     * operationId: patchReservablePeriod
     * Request URI: /m/resources/{resource_public_id}/reservable_period
     */
    public async patchReservablePeriod(params: Params$patchReservablePeriod, option?: RequestOption): Promise<Response$patchReservablePeriod$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/reservable_period`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Delete time slot
     * operationId: deleteTimeSlot
     * Request URI: /m/slots/{time_slot_id}
     */
    public async deleteTimeSlot(params: Params$deleteTimeSlot, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/slots/${encodeURIComponent(params.parameter.time_slot_id)}`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * fetch seller detail
     * 事前決済事業者情報
     * operationId: fetchSellerDetail
     * Request URI: /m/seller
     */
    public async fetchSellerDetail(params: Params$fetchSellerDetail, option?: RequestOption): Promise<Response$fetchSellerDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/seller`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update seller detail
     * 事前決済事業者情報の更新
     * operationId: updateSellerDetail
     * Request URI: /m/seller
     */
    public async updateSellerDetail(params: Params$updateSellerDetail, option?: RequestOption): Promise<Response$updateSellerDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/seller`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * LINEミニアプリの審査ステータス
     * operationId: getLineMiniAppStatus
     * Request URI: /m/settings/line_mini_app
     */
    public async getLineMiniAppStatus(params: Params$getLineMiniAppStatus, option?: RequestOption): Promise<Response$getLineMiniAppStatus$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/line_mini_app`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * LINEミニアプリの審査申請
     * operationId: submitLineMiniAppExamination
     * Request URI: /m/settings/line_mini_app
     */
    public async submitLineMiniAppExamination(params: Params$submitLineMiniAppExamination, option?: RequestOption): Promise<Response$submitLineMiniAppExamination$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/line_mini_app`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Get a merchant end user reservation limit
     * operationId: getEndUserReservationLimit
     * Request URI: /m/settings/end_user_reservation_limitation
     */
    public async getEndUserReservationLimit(params: Params$getEndUserReservationLimit, option?: RequestOption): Promise<Response$getEndUserReservationLimit$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/end_user_reservation_limitation`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 予約回数制限の更新
     * operationId: updateEndUserReservationLimitation
     * Request URI: /m/settings/end_user_reservation_limitation
     */
    public async updateEndUserReservationLimitation(params: Params$updateEndUserReservationLimitation, option?: RequestOption): Promise<Response$updateEndUserReservationLimitation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/end_user_reservation_limitation`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 入金予定を取得
     * operationId: transferSchedule
     * Request URI: /m/settings/transfer_schedule
     */
    public async transferSchedule(params: Params$transferSchedule, option?: RequestOption): Promise<Response$transferSchedule$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/transfer_schedule`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 入金予定を取得
     * operationId: payoutSchedule
     * Request URI: /m/settings/stripe_payouts/payout_schedule
     */
    public async payoutSchedule(params: Params$payoutSchedule, option?: RequestOption): Promise<Response$payoutSchedule$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/stripe_payouts/payout_schedule`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 入金履歴を取得
     * Stripe決済の入金明細の取得に使用していたAPI。事前決済をStripeからGMO PGに移行するのに伴ってどちらの事前決済でも利用できる汎用化された /dashboard/settings/completed_transfersに移行した
     * operationId: payoutList
     * Request URI: /m/settings/stripe_payouts/payout_list
     */
    public async payoutList(params: Params$payoutList, option?: RequestOption): Promise<Response$payoutList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/stripe_payouts/payout_list`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 入金予定額を取得
     * Stripe決済の入金予定額の取得に使用していたAPI。事前決済をStripeからGMO PGに移行するのに伴ってどちらの事前決済でも利用できる汎用化された /dashboard/settings/expected_transfersに移行した
     * operationId: expectedPayoutList
     * Request URI: /m/settings/stripe_payouts/expected_payout_list
     */
    public async expectedPayoutList(params: Params$expectedPayoutList, option?: RequestOption): Promise<Response$expectedPayoutList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/stripe_payouts/expected_payout_list`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 入金履歴csvを生成するjobを発火する
     * operationId: downloadPayout
     * Request URI: /m/settings/stripe_payouts/{stripe_payout_id}/download
     */
    public async downloadPayout(params: Params$downloadPayout, option?: RequestOption): Promise<Response$downloadPayout$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/stripe_payouts/${encodeURIComponent(params.parameter.stripe_payout_id)}/download`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 入金予定csvを生成するjobを発火する
     * operationId: downloadExpectedPayout
     * Request URI: /m/settings/stripe_payouts/expected_payout_list/download
     */
    public async downloadExpectedPayout(params: Params$downloadExpectedPayout, option?: RequestOption): Promise<Response$downloadExpectedPayout$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/stripe_payouts/expected_payout_list/download`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 新予約カレンダーの設定を取得
     * operationId: getDashboardCalendarSetting
     * Request URI: /m/settings/dashboard_calendar
     */
    public async getDashboardCalendarSetting(option?: RequestOption): Promise<Response$getDashboardCalendarSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/dashboard_calendar`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 新予約カレンダーの設定を更新
     * operationId: updateDashboardCalendarSetting
     * Request URI: /m/settings/dashboard_calendar
     */
    public async updateDashboardCalendarSetting(params: Params$updateDashboardCalendarSetting, option?: RequestOption): Promise<Response$updateDashboardCalendarSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/dashboard_calendar`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get google analytics four tracking id
     * operationId: getGoogleAnalyticsFour
     * Request URI: /m/settings/google_analytics_four
     */
    public async getGoogleAnalyticsFour(params: Params$getGoogleAnalyticsFour, option?: RequestOption): Promise<Response$getGoogleAnalyticsFour$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/google_analytics_four`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * delete google analytics four tracking id
     * operationId: deleteGoogleAnalyticsFour
     * Request URI: /m/settings/google_analytics_four
     */
    public async deleteGoogleAnalyticsFour(params: Params$deleteGoogleAnalyticsFour, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/settings/google_analytics_four`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * update google analytics four tracking id
     * operationId: updateGoogleAnalyticsFour
     * Request URI: /m/settings/google_analytics_four
     */
    public async updateGoogleAnalyticsFour(params: Params$updateGoogleAnalyticsFour, option?: RequestOption): Promise<Response$updateGoogleAnalyticsFour$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/google_analytics_four`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get staff list
     * operationId: getStaffList
     * Request URI: /m/staff.json
     */
    public async getStaffList(params: Params$getStaffList, option?: RequestOption): Promise<Response$getStaffList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            with_deleted: { value: params.parameter.with_deleted, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * create new staff
     * operationId: createNewStaff
     * Request URI: /m/staff.json
     */
    public async createNewStaff(params: Params$createNewStaff, option?: RequestOption): Promise<Response$createNewStaff$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff.json`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            with_deleted: { value: params.parameter.with_deleted, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * staff management limit reached
     * スタッフ数上限に達しているかどうかを返す
     * operationId: getStaffManagementLimitReached
     * Request URI: /m/staff/staff_management_limit_reached.json
     */
    public async getStaffManagementLimitReached(params: Params$getStaffManagementLimitReached, option?: RequestOption): Promise<Response$getStaffManagementLimitReached$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff/staff_management_limit_reached.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * bulk delete staff
     * operationId: bulkDeleteStaff
     * Request URI: /m/staff/bulks
     */
    public async bulkDeleteStaff(params: Params$bulkDeleteStaff, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/staff/bulks`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get merchant and staff daily schedules list
     * operationId: getStaffDailySchedulesList
     * Request URI: /m/staff_daily_schedules
     */
    public async getStaffDailySchedulesList(params: Params$getStaffDailySchedulesList, option?: RequestOption): Promise<Response$getStaffDailySchedulesList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff_daily_schedules`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            year: { value: params.parameter.year, explode: false },
            month: { value: params.parameter.month, explode: false },
            "staff_canonical_id[]": { value: params.parameter["staff_canonical_id[]"], explode: false },
            kanzashi_synced_staff: { value: params.parameter.kanzashi_synced_staff, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * bulk update staff daily schedule of specified staff
     * operationId: bulkUpdateStaffDailySchedule
     * Request URI: /m/staff/{staff_canonical_id}/staff_daily_schedules/bulk_update
     */
    public async bulkUpdateStaffDailySchedule(params: Params$bulkUpdateStaffDailySchedule, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/staff_daily_schedules/bulk_update`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get monthly schedule of specified staff on given year month
     * operationId: getStaffMonthlySchedules
     * Request URI: /m/staff/{staff_canonical_id}/staff_monthly_schedules
     */
    public async getStaffMonthlySchedules(params: Params$getStaffMonthlySchedules, option?: RequestOption): Promise<Response$getStaffMonthlySchedules$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/staff_monthly_schedules`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            year: { value: params.parameter.year, explode: false },
            month: { value: params.parameter.month, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get preset of the staff's working hours per wekday
     * operationId: getStaffWorkingHour
     * Request URI: /m/staff/{staff_canonical_id}/staff_working_hour
     */
    public async getStaffWorkingHour(params: Params$getStaffWorkingHour, option?: RequestOption): Promise<Response$getStaffWorkingHour$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/staff_working_hour`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get staff list for staff daily schedule
     * operationId: getStaffListForStaffDailySchedule
     * Request URI: /m/staff_daily_schedules/staff
     */
    public async getStaffListForStaffDailySchedule(params: Params$getStaffListForStaffDailySchedule, option?: RequestOption): Promise<Response$getStaffListForStaffDailySchedule$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff_daily_schedules/staff`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get creatability of staff daily schedule hint display history
     * operationId: getStaffDailyScheduleHintDisplayHistoryCreatability
     * Request URI: /m/staff/{staff_canonical_id}/staff_daily_schedule_hint_display_histories/creatability
     */
    public async getStaffDailyScheduleHintDisplayHistoryCreatability(params: Params$getStaffDailyScheduleHintDisplayHistoryCreatability, option?: RequestOption): Promise<Response$getStaffDailyScheduleHintDisplayHistoryCreatability$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/staff_daily_schedule_hint_display_histories/creatability`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * create staff daily schedule hint display history
     * operationId: createStaffDailyScheduleHintDisplayHistory
     * Request URI: /m/staff/{staff_canonical_id}/staff_daily_schedule_hint_display_histories
     */
    public async createStaffDailyScheduleHintDisplayHistory(params: Params$createStaffDailyScheduleHintDisplayHistory, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/staff_daily_schedule_hint_display_histories`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * スタッフの担当しているコースの取得
     * operationId: getStaffCourseAssignersList
     * Request URI: /m/staff/{staff_canonical_id}/staff_course_assigners
     */
    public async getStaffCourseAssignersList(params: Params$getStaffCourseAssignersList, option?: RequestOption): Promise<Response$getStaffCourseAssignersList$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/staff_course_assigners`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * QRセルフチェックインのURLが入ったQRコードを生成/返却
     * operationId: getQrSelfCheckinImage
     * Request URI: /m/qr/qr_self_checkin_image
     */
    public async getQrSelfCheckinImage(params: Params$getQrSelfCheckinImage, option?: RequestOption): Promise<Response$getQrSelfCheckinImage$Status$200["image/png"]> {
        const url = this.baseUrl + `/m/qr/qr_self_checkin_image`;
        const headers = {
            Accept: "image/png",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * create default event staff assignment
     * operationId: createEventDefaultStaffAssignment
     * Request URI: /m/resources/{resource_public_id}/staff/{staff_canonical_id}/event_default_staff_assignment
     */
    public async createEventDefaultStaffAssignment(params: Params$createEventDefaultStaffAssignment, option?: RequestOption): Promise<Response$createEventDefaultStaffAssignment$Status$201["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/event_default_staff_assignment`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * delete default event staff assignment
     * operationId: deleteEventDefaultStaffAssignment
     * Request URI: /m/resources/{resource_public_id}/staff/{staff_canonical_id}/event_default_staff_assignment
     */
    public async deleteEventDefaultStaffAssignment(params: Params$deleteEventDefaultStaffAssignment, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/staff/${encodeURIComponent(params.parameter.staff_canonical_id)}/event_default_staff_assignment`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * get all default event staff assignments of event resource
     * operationId: getEventDefaultStaffAssignments
     * Request URI: /m/resources/{resource_public_id}/event_default_staff_assignments
     */
    public async getEventDefaultStaffAssignments(params: Params$getEventDefaultStaffAssignments, option?: RequestOption): Promise<Response$getEventDefaultStaffAssignments$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/event_default_staff_assignments`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get all staff assignments of course resource
     * operationId: getAllCourseStaffAssignments
     * Request URI: /m/resources/{resource_public_id}/all_course_staff_assignments
     */
    public async getAllCourseStaffAssignments(params: Params$getAllCourseStaffAssignments, option?: RequestOption): Promise<Response$getAllCourseStaffAssignments$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/all_course_staff_assignments`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * put resource onboarding todo
     * 予約ページのやることリストの完了状態を更新
     * operationId: putResourceOnboardingTodo
     * Request URI: /m/resources/{resource_public_id}/onboarding_todo
     */
    public async putResourceOnboardingTodo(params: Params$putResourceOnboardingTodo, option?: RequestOption): Promise<Response$putResourceOnboardingTodo$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/onboarding_todo`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * put resource recommended setting visibility
     * 予約ページのおすすめ設定の表示・非表示を更新
     * operationId: putResourceRecommendedSettingVisibility
     * Request URI: /m/resources/{resource_public_id}/recommended_setting
     */
    public async putResourceRecommendedSettingVisibility(params: Params$putResourceRecommendedSettingVisibility, option?: RequestOption): Promise<Response$putResourceRecommendedSettingVisibility$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/recommended_setting`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * patch resource archive
     * 予約ページを削除（statusをarcihvedに更新）
     * operationId: patchResourceArchive
     * Request URI: /m/resources/{resource_public_id}/archive
     */
    public async patchResourceArchive(params: Params$patchResourceArchive, option?: RequestOption): Promise<Response$patchResourceArchive$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/${encodeURIComponent(params.parameter.resource_public_id)}/archive`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers
        }, option);
    }
    /**
     * get current auto checkin setting
     * operationId: getMerchantSetting
     * Request URI: /m/setting
     */
    public async getMerchantSetting(params: Params$getMerchantSetting, option?: RequestOption): Promise<Response$getMerchantSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/setting`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update auto checkin
     * 自動チェックインの設定をトグルするAPI
     * operationId: updateMerchantSetting
     * Request URI: /m/setting
     */
    public async updateMerchantSetting(params: Params$updateMerchantSetting, option?: RequestOption): Promise<Response$updateMerchantSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/setting`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 予約サイトの公開状態を変更する
     * operationId: updateMerchantSiteVisibility
     * Request URI: /m/site_settings/publish
     */
    public async updateMerchantSiteVisibility(params: Params$updateMerchantSiteVisibility, option?: RequestOption): Promise<Response$updateMerchantSiteVisibility$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/site_settings/publish`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get site detail
     * 予約サイト情報
     * operationId: getSiteDetail
     * Request URI: /m/site
     */
    public async getSiteDetail(params: Params$getSiteDetail, option?: RequestOption): Promise<Response$getSiteDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/site`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update site detail
     * operationId: updateSiteDetail
     * Request URI: /m/site
     */
    public async updateSiteDetail(params: Params$updateSiteDetail, option?: RequestOption): Promise<Response$updateSiteDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/site`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * upsert site public id
     * 予約サイトの識別子(SitePublicId)を新規作成または更新します。
     * maja移行後の事業者・店舗を前提とし、スタッフは `403 Forbidden` となります。
     *
     * operationId: putSitePublicId
     * Request URI: /m/site_public_id
     */
    public async putSitePublicId(params: Params$putSitePublicId, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/site_public_id`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * upload image
     * 画像アップロードAPI
     * operationId: uploadImage
     * Request URI: /m/images/upload
     */
    public async uploadImage(params: Params$uploadImage, option?: RequestOption): Promise<Response$uploadImage$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/images/upload`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get categories
     * カテゴリー（業種）一覧を取得する
     * operationId: getCategories
     * Request URI: /m/categories
     */
    public async getCategories(params: Params$getCategories, option?: RequestOption): Promise<Response$getCategories$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/categories`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get temporary dates
     * マーチャントに紐付く特別休業日・特別営業時間を全件取得する
     * operationId: getTemporaryDates
     * Request URI: /m/temporary_dates
     */
    public async getTemporaryDates(params: Params$getTemporaryDates, option?: RequestOption): Promise<Response$getTemporaryDates$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/temporary_dates`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            type: { value: params.parameter.type, explode: false },
            start_date: { value: params.parameter.start_date, explode: false },
            end_date: { value: params.parameter.end_date, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * create temporary date
     * operationId: createTemporaryDate
     * Request URI: /m/temporary_dates
     */
    public async createTemporaryDate(params: Params$createTemporaryDate, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/temporary_dates`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get a temporary date
     * マーチャントに紐付く特別休業日・特別営業時間を一件取得する
     * operationId: getTemporaryDate
     * Request URI: /m/temporary_dates/{temporary_date_id}
     */
    public async getTemporaryDate(params: Params$getTemporaryDate, option?: RequestOption): Promise<Response$getTemporaryDate$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/temporary_dates/${encodeURIComponent(params.parameter.temporary_date_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * delete temporary date
     * operationId: deleteTemporaryDate
     * Request URI: /m/temporary_dates/{temporary_date_id}
     */
    public async deleteTemporaryDate(params: Params$deleteTemporaryDate, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/temporary_dates/${encodeURIComponent(params.parameter.temporary_date_id)}`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * edit temporary date
     * operationId: editTemporaryDate
     * Request URI: /m/temporary_dates/{temporary_date_id}
     */
    public async editTemporaryDate(params: Params$editTemporaryDate, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/temporary_dates/${encodeURIComponent(params.parameter.temporary_date_id)}`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get resource duplication status
     * operationId: duplicationStatus
     * Request URI: /m/resources/duplication_status
     */
    public async duplicationStatus(params: Params$duplicationStatus, option?: RequestOption): Promise<Response$duplicationStatus$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/resources/duplication_status`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            scheme: { value: params.parameter.scheme, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get published resources count
     * 予約ページ公開数上限
     * operationId: getPublishedResourcesCount
     * Request URI: /m/published_resources_count
     */
    public async getPublishedResourcesCount(option?: RequestOption): Promise<Response$getPublishedResourcesCount$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/published_resources_count`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get onboarding todo
     * オンボーディング時のやることリストの完了状態取得
     * operationId: getOnboardingTodo
     * Request URI: /m/onboarding_todo
     */
    public async getOnboardingTodo(option?: RequestOption): Promise<Response$getOnboardingTodo$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/onboarding_todo`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * put onboarding todo
     * オンボーディング時のやることリストの完了状態を更新
     * operationId: putOnboardingTodo
     * Request URI: /m/onboarding_todo
     */
    public async putOnboardingTodo(params: Params$putOnboardingTodo, option?: RequestOption): Promise<Response$putOnboardingTodo$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/onboarding_todo`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Googleアカウントとの接続状況を返す
     * operationId: getGoogleConnect
     * Request URI: /m/google_connect
     */
    public async getGoogleConnect(option?: RequestOption): Promise<Response$getGoogleConnect$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/google_connect`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * Get a merchant data for inquiry form auto filling
     * operationId: getInquiryFormAutoFill
     * Request URI: /m/inquiry_form_auto_fill
     */
    public async getInquiryFormAutoFill(option?: RequestOption): Promise<Response$getInquiryFormAutoFill$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/inquiry_form_auto_fill`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get subscription upgrade usable
     * セルフUGの可否を取得する
     * operationId: getUpgrades
     * Request URI: /m/upgrade
     */
    public async getUpgrades(option?: RequestOption): Promise<Response$getUpgrades$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/upgrade`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * put usage tips
     * モーダルを今後表示しない
     * operationId: putUsageTips
     * Request URI: /m/usage_tips/:usage_tips_type
     */
    public async putUsageTips(params: Params$putUsageTips, option?: RequestOption): Promise<Response$putUsageTips$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/usage_tips/:usage_tips_type`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "PUT",
            url,
            headers
        }, option);
    }
    /**
     * 顧客の属性を取得
     * operationId: getCustomerAttributeDefinitions
     * Request URI: /m/customers/attribute_definitions
     */
    public async getCustomerAttributeDefinitions(option?: RequestOption): Promise<Response$getCustomerAttributeDefinitions$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/attribute_definitions`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 顧客を追加
     * operationId: createCustomer
     * Request URI: /m/customers
     */
    public async createCustomer(params: Params$createCustomer, option?: RequestOption): Promise<Response$createCustomer$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 現在の顧客リスト検索結果のcsv出力トリガー
     * operationId: triggerCsvExport
     * Request URI: /m/customers/csv_exports
     */
    public async triggerCsvExport(params: Params$triggerCsvExport, option?: RequestOption): Promise<Response$triggerCsvExport$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/csv_exports`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 顧客の一括登録
     * operationId: customersCsvImportRequest
     * Request URI: /m/customers/csv_imports
     */
    public async customersCsvImportRequest(params: Params$customersCsvImportRequest, option?: RequestOption): Promise<Response$customersCsvImportRequest$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/csv_imports`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 回数券一覧を取得
     * operationId: getTicketBookProducts
     * Request URI: /m/customers/ticket_book_products
     */
    public async getTicketBookProducts(option?: RequestOption): Promise<Response$getTicketBookProducts$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/ticket_book_products`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 月謝一覧を取得
     * operationId: getSubscriptionProducts
     * Request URI: /m/customers/subscription_products
     */
    public async getSubscriptionProducts(option?: RequestOption): Promise<Response$getSubscriptionProducts$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/subscription_products`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 選択した顧客に予約者アカウントの招待メールを一括送信
     * operationId: dashboardCustomerInvitation
     * Request URI: /m/customers/dashboard_invitations
     */
    public async dashboardCustomerInvitation(params: Params$dashboardCustomerInvitation, option?: RequestOption): Promise<Response$dashboardCustomerInvitation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/dashboard_invitations`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 顧客メモを作成
     * operationId: createCustomerMemo
     * Request URI: /m/customers/{customer_public_id}/customer_memos
     */
    public async createCustomerMemo(params: Params$createCustomerMemo, option?: RequestOption): Promise<Response$createCustomerMemo$Status$201["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/customer_memos`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 顧客メモの情報を取得
     * operationId: getCustomerMemo
     * Request URI: /m/customers/{customer_public_id}/customer_memos/{customer_memo_id}
     */
    public async getCustomerMemo(params: Params$getCustomerMemo, option?: RequestOption): Promise<Response$getCustomerMemo$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/customer_memos/${encodeURIComponent(params.parameter.customer_memo_id)}`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 顧客メモを削除
     * operationId: deleteCustomerMemos
     * Request URI: /m/customers/{customer_public_id}/customer_memos/{customer_memo_id}
     */
    public async deleteCustomerMemos(params: Params$deleteCustomerMemos, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/customer_memos/${encodeURIComponent(params.parameter.customer_memo_id)}`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * 顧客メモの情報を更新
     * operationId: updateCustomerMemo
     * Request URI: /m/customers/{customer_public_id}/customer_memos/{customer_memo_id}
     */
    public async updateCustomerMemo(params: Params$updateCustomerMemo, option?: RequestOption): Promise<Response$updateCustomerMemo$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/customers/${encodeURIComponent(params.parameter.customer_public_id)}/customer_memos/${encodeURIComponent(params.parameter.customer_memo_id)}`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Get analytics query
     * operationId: getMerchantDashboardAnalyticsQuery
     * Request URI: /m/analytics_queries/{id}
     */
    public async getMerchantDashboardAnalyticsQuery(params: Params$getMerchantDashboardAnalyticsQuery, option?: RequestOption): Promise<Response$getMerchantDashboardAnalyticsQuery$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/analytics_queries/${encodeURIComponent(params.parameter.id)}`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start_on: { value: params.parameter.start_on, explode: false },
            end_on: { value: params.parameter.end_on, explode: false },
            "resource_public_ids[]": { value: params.parameter["resource_public_ids[]"], explode: false },
            "ticket_book_public_ids[]": { value: params.parameter["ticket_book_public_ids[]"], explode: false },
            "subscription_public_ids[]": { value: params.parameter["subscription_public_ids[]"], explode: false },
            "payment_methods[]": { value: params.parameter["payment_methods[]"], explode: false },
            "payment_statuses[]": { value: params.parameter["payment_statuses[]"], explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Download analytics query SJIS CSV
     * operationId: downloadMerchantDashboardAnalyticsQuerySjisCsv
     * Request URI: /m/analytics_queries/{id}/download_sjis_csv
     */
    public async downloadMerchantDashboardAnalyticsQuerySjisCsv(params: Params$downloadMerchantDashboardAnalyticsQuerySjisCsv, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/analytics_queries/${encodeURIComponent(params.parameter.id)}/download_sjis_csv`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start_on: { value: params.parameter.start_on, explode: false },
            end_on: { value: params.parameter.end_on, explode: false },
            "resource_public_ids[]": { value: params.parameter["resource_public_ids[]"], explode: false },
            "ticket_book_public_ids[]": { value: params.parameter["ticket_book_public_ids[]"], explode: false },
            "subscription_public_ids[]": { value: params.parameter["subscription_public_ids[]"], explode: false },
            "payment_methods[]": { value: params.parameter["payment_methods[]"], explode: false },
            "payment_statuses[]": { value: params.parameter["payment_statuses[]"], explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Get business information
     * operationId: getMerchantDashboardBusinessInformation
     * Request URI: /m/business_information
     */
    public async getMerchantDashboardBusinessInformation(option?: RequestOption): Promise<Response$getMerchantDashboardBusinessInformation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/business_information`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * Update business information
     * operationId: updateMerchantDashboardBusinessInformation
     * Request URI: /m/business_information
     */
    public async updateMerchantDashboardBusinessInformation(params: Params$updateMerchantDashboardBusinessInformation, option?: RequestOption): Promise<Response$updateMerchantDashboardBusinessInformation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/business_information`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Get default business information
     * operationId: getMerchantDashboardDefaultBusinessInformation
     * Request URI: /m/business_information/default
     */
    public async getMerchantDashboardDefaultBusinessInformation(params: Params$getMerchantDashboardDefaultBusinessInformation, option?: RequestOption): Promise<Response$getMerchantDashboardDefaultBusinessInformation$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/business_information/default`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update merchant public id
     * operationId: patchMerchantPublicId
     * Request URI: /m/merchant_public_id
     */
    public async patchMerchantPublicId(params: Params$patchMerchantPublicId, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/merchant_public_id`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get billings
     * operationId: getBillings
     * Request URI: /m/billings
     */
    public async getBillings(params: Params$getBillings, option?: RequestOption): Promise<Response$getBillings$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/billings`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            target_date: { value: params.parameter.target_date, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get offline reservations resource time slots
     * 予約台帳の仕様に沿ったTimeSlotを返す（日程の閲覧権限のないスタッフにも返す。非公開予約の日程も返す）
     * operationId: getOfflineReservationResourceTimeSlots
     * Request URI: /m/offline_reservations/resources/{resource_public_id}/time_slots
     */
    public async getOfflineReservationResourceTimeSlots(params: Params$getOfflineReservationResourceTimeSlots, option?: RequestOption): Promise<Response$getOfflineReservationResourceTimeSlots$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/offline_reservations/resources/${encodeURIComponent(params.parameter.resource_public_id)}/time_slots`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            date: { value: params.parameter.date, explode: false },
            nearest_available_time_slots_required: { value: params.parameter.nearest_available_time_slots_required, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * かんざし連携初回フローのステータスを取得
     * operationId: getKanzashiIntegrationProgress
     * Request URI: /m/kanzashi_integration/kanzashi_integration_progress
     */
    public async getKanzashiIntegrationProgress(option?: RequestOption): Promise<Response$getKanzashiIntegrationProgress$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi_integration/kanzashi_integration_progress`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * かんざし連携初回フローのステータスを更新
     * operationId: updateKanzashiIntegrationProgress
     * Request URI: /m/kanzashi_integration/kanzashi_integration_progress
     */
    public async updateKanzashiIntegrationProgress(params: Params$updateKanzashiIntegrationProgress, option?: RequestOption): Promise<Response$updateKanzashiIntegrationProgress$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi_integration/kanzashi_integration_progress`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * かんざし連携事業者情報取得API
     * operationId: getKanzashiBusinessInformationRequest
     * Request URI: /m/kanzashi_integration/business_information_request
     */
    public async getKanzashiBusinessInformationRequest(option?: RequestOption): Promise<Response$getKanzashiBusinessInformationRequest$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi_integration/business_information_request`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * かんざし連携申し込み情報送信API
     * operationId: createKanzashiBusinessInformationRequest
     * Request URI: /m/kanzashi_integration/business_information_request
     */
    public async createKanzashiBusinessInformationRequest(params: Params$createKanzashiBusinessInformationRequest, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/kanzashi_integration/business_information_request`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * かんざし連携で連携する予約ページを登録するAPI
     * operationId: createKanzashiIntegrationResourceRequest
     * Request URI: /m/kanzashi_integration/integration_resource_request
     */
    public async createKanzashiIntegrationResourceRequest(params: Params$createKanzashiIntegrationResourceRequest, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/kanzashi_integration/integration_resource_request`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * かんざし連携 画面呼び出し用のHMACを生成して返却するAPI
     * operationId: getKanzashiHmacForSignIn
     * Request URI: /m/kanzashi/hmac_for_sign_in
     */
    public async getKanzashiHmacForSignIn(option?: RequestOption): Promise<Response$getKanzashiHmacForSignIn$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi/hmac_for_sign_in`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * かんざし連携 同時受付可能数の設定を取得する
     * operationId: getKanzashiAcceptableCountSetting
     * Request URI: /m/kanzashi/acceptable_count_setting
     */
    public async getKanzashiAcceptableCountSetting(option?: RequestOption): Promise<Response$getKanzashiAcceptableCountSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi/acceptable_count_setting`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * かんざし連携 同時受付可能数の設定を更新する
     * operationId: updateKanzashiAcceptableCountSetting
     * Request URI: /m/kanzashi/acceptable_count_setting
     */
    public async updateKanzashiAcceptableCountSetting(params: Params$updateKanzashiAcceptableCountSetting, option?: RequestOption): Promise<Response$updateKanzashiAcceptableCountSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi/acceptable_count_setting`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * かんざし連携 スタッフの連携除外設定を取得する
     * operationId: getKanzashiExcludeStaffMembers
     * Request URI: /m/kanzashi/syncable_staff_members
     */
    public async getKanzashiExcludeStaffMembers(option?: RequestOption): Promise<Response$getKanzashiExcludeStaffMembers$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi/syncable_staff_members`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * かんざし連携 スタッフの連携設定を登録する
     * operationId: bulkCreateKanzashiSyncableStaffMembers
     * Request URI: /m/kanzashi/syncable_staff_members/bulk
     */
    public async bulkCreateKanzashiSyncableStaffMembers(params: Params$bulkCreateKanzashiSyncableStaffMembers, option?: RequestOption): Promise<Response$bulkCreateKanzashiSyncableStaffMembers$Status$201["application/json"]> {
        const url = this.baseUrl + `/m/kanzashi/syncable_staff_members/bulk`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * かんざし連携 スタッフの連携設定を削除する
     * operationId: bulkDeleteKanzashiSyncableStaffMembers
     * Request URI: /m/kanzashi/syncable_staff_members/bulk
     */
    public async bulkDeleteKanzashiSyncableStaffMembers(params: Params$bulkDeleteKanzashiSyncableStaffMembers, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/m/kanzashi/syncable_staff_members/bulk`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 現在のマーチャントの通知設定を返す
     * operationId: merchantDashboardSettingGetNotification
     * Request URI: /m/settings/notifications
     */
    public async merchantDashboardSettingGetNotification(option?: RequestOption): Promise<Response$merchantDashboardSettingGetNotification$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/notifications`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 現在のマーチャントの通知設定を更新する
     * operationId: merchantDashboardSettingUpdateNotification
     * Request URI: /m/settings/notifications
     */
    public async merchantDashboardSettingUpdateNotification(params: Params$merchantDashboardSettingUpdateNotification, option?: RequestOption): Promise<Response$merchantDashboardSettingUpdateNotification$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/settings/notifications`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Bulk message quota
     * 当月のマーチャントの SMS / Email の残数とクォータを返す
     * operationId: merchantBulkMesssageBundleQuota
     * Request URI: /m/bulk_message_bundles/quota
     */
    public async merchantBulkMesssageBundleQuota(params: Params$merchantBulkMesssageBundleQuota, option?: RequestOption): Promise<Response$merchantBulkMesssageBundleQuota$Status$200["application/json"]> {
        const url = this.baseUrl + `/m/bulk_message_bundles/quota`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * fetch organization's merchants
     * operationId: fetchMerchantsInfoAboutSubscriptionProduct
     * Request URI: /o/subscription_products/{subscription_product_id}/merchants
     */
    public async fetchMerchantsInfoAboutSubscriptionProduct(params: Params$fetchMerchantsInfoAboutSubscriptionProduct, option?: RequestOption): Promise<Response$fetchMerchantsInfoAboutSubscriptionProduct$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/subscription_products/${encodeURIComponent(params.parameter.subscription_product_id)}/merchants`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * fetch organization's merchants
     * operationId: fetchMerchantsInfoAboutTicketBookProduct
     * Request URI: /o/ticket_book_products/{ticket_book_product_id}/merchants
     */
    public async fetchMerchantsInfoAboutTicketBookProduct(params: Params$fetchMerchantsInfoAboutTicketBookProduct, option?: RequestOption): Promise<Response$fetchMerchantsInfoAboutTicketBookProduct$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/ticket_book_products/${encodeURIComponent(params.parameter.ticket_book_product_id)}/merchants`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * publish subscription product
     * operationId: publishSubscriptionProduct
     * Request URI: /o/subscription_products/{subscription_product_id}/publish
     */
    public async publishSubscriptionProduct(params: Params$publishSubscriptionProduct, option?: RequestOption): Promise<Response$publishSubscriptionProduct$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/subscription_products/${encodeURIComponent(params.parameter.subscription_product_id)}/publish`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * publish ticket book product
     * operationId: publishTicketBookProduct
     * Request URI: /o/ticket_book_products/{ticket_book_product_id}/publish
     */
    public async publishTicketBookProduct(params: Params$publishTicketBookProduct, option?: RequestOption): Promise<Response$publishTicketBookProduct$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/ticket_book_products/${encodeURIComponent(params.parameter.ticket_book_product_id)}/publish`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Get analytics query
     * operationId: getOrganizationDashboardAnalyticsQuery
     * Request URI: /o/analytics_queries/{id}
     */
    public async getOrganizationDashboardAnalyticsQuery(params: Params$getOrganizationDashboardAnalyticsQuery, option?: RequestOption): Promise<Response$getOrganizationDashboardAnalyticsQuery$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/analytics_queries/${encodeURIComponent(params.parameter.id)}`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start_on: { value: params.parameter.start_on, explode: false },
            end_on: { value: params.parameter.end_on, explode: false },
            "target_merchant_public_ids[]": { value: params.parameter["target_merchant_public_ids[]"], explode: false },
            "resource_public_ids[]": { value: params.parameter["resource_public_ids[]"], explode: false },
            "ticket_book_public_ids[]": { value: params.parameter["ticket_book_public_ids[]"], explode: false },
            "subscription_public_ids[]": { value: params.parameter["subscription_public_ids[]"], explode: false },
            "payment_methods[]": { value: params.parameter["payment_methods[]"], explode: false },
            "payment_statuses[]": { value: params.parameter["payment_statuses[]"], explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Download analytics query SJIS CSV
     * operationId: downloadOrganizationDashboardAnalyticsQuerySjisCsv
     * Request URI: /o/analytics_queries/{id}/download_sjis_csv
     */
    public async downloadOrganizationDashboardAnalyticsQuerySjisCsv(params: Params$downloadOrganizationDashboardAnalyticsQuerySjisCsv, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/o/analytics_queries/${encodeURIComponent(params.parameter.id)}/download_sjis_csv`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            start_on: { value: params.parameter.start_on, explode: false },
            end_on: { value: params.parameter.end_on, explode: false },
            "target_merchant_public_ids[]": { value: params.parameter["target_merchant_public_ids[]"], explode: false },
            "resource_public_ids[]": { value: params.parameter["resource_public_ids[]"], explode: false },
            "ticket_book_public_ids[]": { value: params.parameter["ticket_book_public_ids[]"], explode: false },
            "subscription_public_ids[]": { value: params.parameter["subscription_public_ids[]"], explode: false },
            "payment_methods[]": { value: params.parameter["payment_methods[]"], explode: false },
            "payment_statuses[]": { value: params.parameter["payment_statuses[]"], explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Get organization's merchants
     * operationId: getOrganizationDashboardMerchants
     * Request URI: /o/merchants
     */
    public async getOrganizationDashboardMerchants(params: Params$getOrganizationDashboardMerchants, option?: RequestOption): Promise<Response$getOrganizationDashboardMerchants$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/merchants`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            enabled_feature: { value: params.parameter.enabled_feature, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Get a list of resource selectors
     * operationId: getOrganizationDashboardResourceSelectors
     * Request URI: /o/resource_selectors
     */
    public async getOrganizationDashboardResourceSelectors(params: Params$getOrganizationDashboardResourceSelectors, option?: RequestOption): Promise<Response$getOrganizationDashboardResourceSelectors$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/resource_selectors`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            include_unpublished: { value: params.parameter.include_unpublished, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Get a list of  products
     * operationId: getOrganizationDashboardProducts
     * Request URI: /o/products
     */
    public async getOrganizationDashboardProducts(params: Params$getOrganizationDashboardProducts, option?: RequestOption): Promise<Response$getOrganizationDashboardProducts$Status$200["application/json"]> {
        const url = this.baseUrl + `/o/products`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * fetch current end user (エンドユーザー情報を取得します。マーチャントではない)
     * operationId: fetchCurrentEndUser
     * Request URI: /u/me
     */
    public async fetchCurrentEndUser(option?: RequestOption): Promise<Response$fetchCurrentEndUser$Status$200["application/json"]> {
        const url = this.baseUrl + `/u/me`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * enduserとして予約にセルフチェックインする
     * operationId: postUserCheckin
     * Request URI: /u/reservations/{reservation_public_id}/checkin.json
     */
    public async postUserCheckin(params: Params$postUserCheckin, option?: RequestOption): Promise<Response$postUserCheckin$Status$200["application/json"]> {
        const url = this.baseUrl + `/u/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}/checkin.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * fetch user reservations
     * operationId: fetchUserReservations
     * Request URI: /u/reservations.json
     */
    public async fetchUserReservations(params: Params$fetchUserReservations, option?: RequestOption): Promise<Response$fetchUserReservations$Status$200["application/json"]> {
        const url = this.baseUrl + `/u/reservations.json`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            merchant_public_id: { value: params.parameter.merchant_public_id, explode: false },
            start_at: { value: params.parameter.start_at, explode: false },
            end_at: { value: params.parameter.end_at, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * クレジットカードの登録。GmoPgの場合は、3DS認証の実施のために確定はnotify_confirmedで行われる
     * operationId: createPaymentMethod
     * Request URI: /u/settings/payment_methods
     */
    public async createPaymentMethod(params: Params$createPaymentMethod, option?: RequestOption): Promise<Response$createPaymentMethod$Status$201["application/json"]> {
        const url = this.baseUrl + `/u/settings/payment_methods`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * Setup payment method
     * operationId: setupPaymentMethod
     * Request URI: /u/settings/payment_methods/setup
     */
    public async setupPaymentMethod(params: Params$setupPaymentMethod, option?: RequestOption): Promise<Response$setupPaymentMethod$Status$200["application/json"]> {
        const url = this.baseUrl + `/u/settings/payment_methods/setup`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * GmoPgでのカード登録時に、3DS認証が完了した後に登録を確定させる
     * operationId: confirmPaymentMethod
     * Request URI: /u/settings/payment_methods/confirm
     */
    public async confirmPaymentMethod(params: Params$confirmPaymentMethod, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/u/settings/payment_methods/confirm`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * localeの更新
     * operationId: updateUsersMeLocale
     * Request URI: /api/v2/users/me/locale
     */
    public async updateUsersMeLocale(params: Params$updateUsersMeLocale, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/v2/users/me/locale`;
        const headers = {
            "Content-Type": "application/json"
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get merchant detail
     * operationId: getMerchantDetail
     * Request URI: /api/v2/merchants/{merchant_public_id}
     */
    public async getMerchantDetail(params: Params$getMerchantDetail, option?: RequestOption): Promise<Response$getMerchantDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 特定のマーチャントに対する予約状況を返す。今は初回予約かどうかを判断するために使う
     * operationId: getReservationStats
     * Request URI: /api/v2/reservation_stats
     */
    public async getReservationStats(params: Params$getReservationStats, option?: RequestOption): Promise<Response$getReservationStats$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/reservation_stats`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            email: { value: params.parameter.email, explode: false },
            merchant_public_id: { value: params.parameter.merchant_public_id, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get booking_page detail
     * operationId: getBookingPageDetail
     * Request URI: /api/v2/merchants/{merchant_public_id}/booking_pages/{resource_public_id}
     */
    public async getBookingPageDetail(params: Params$getBookingPageDetail, option?: RequestOption): Promise<Response$getBookingPageDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/booking_pages/${encodeURIComponent(params.parameter.resource_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get booking calendar meta
     * operationId: getBookingCalendarMeta
     * Request URI: /api/v2/merchants/{merchant_public_id}/booking_calendar_meta
     */
    public async getBookingCalendarMeta(params: Params$getBookingCalendarMeta, option?: RequestOption): Promise<Response$getBookingCalendarMeta$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/booking_calendar_meta`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get voucher list
     * operationId: getVoucherList
     * Request URI: /api/v2/merchants/{merchant_public_id}/vouchers
     */
    public async getVoucherList(params: Params$getVoucherList, option?: RequestOption): Promise<Response$getVoucherList$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/vouchers`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get a voucher
     * operationId: getVoucherDetail
     * Request URI: /api/v2/merchants/{merchant_public_id}/vouchers/{voucher_public_id}
     */
    public async getVoucherDetail(params: Params$getVoucherDetail, option?: RequestOption): Promise<Response$getVoucherDetail$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/vouchers/${encodeURIComponent(params.parameter.voucher_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get merchant product
     * 対象の月謝・回数券情報を返します
     * operationId: getMerchantProduct
     * Request URI: /api/v2/merchants/{merchant_public_id}/products/{product_public_id}
     */
    public async getMerchantProduct(params: Params$getMerchantProduct, option?: RequestOption): Promise<Response$getMerchantProduct$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/products/${encodeURIComponent(params.parameter.product_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get merchant product first charge
     * 月謝の初回決済に関する情報を返します
     * operationId: getMerchantProductFirstCharge
     * Request URI: /api/v2/merchants/{merchant_public_id}/products/{product_public_id}/first_charge
     */
    public async getMerchantProductFirstCharge(params: Params$getMerchantProductFirstCharge, option?: RequestOption): Promise<Response$getMerchantProductFirstCharge$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/products/${encodeURIComponent(params.parameter.product_public_id)}/first_charge`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * LINEミニアプリのメタ情報を返す
     * operationId: getLineMiniAppMeta
     * Request URI: /api/v2/merchants/{merchant_public_id}/line_mini_app/meta
     */
    public async getLineMiniAppMeta(params: Params$getLineMiniAppMeta, option?: RequestOption): Promise<Response$getLineMiniAppMeta$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/v2/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/line_mini_app/meta`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * ログインユーザーの情報を返す（予約フロー内で使用）
     * operationId: getReservationFlowMe
     * Request URI: /api/reservation_flow/me
     */
    public async getReservationFlowMe(option?: RequestOption): Promise<Response$getReservationFlowMe$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/me`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 認証付き予約ページを認証する
     * operationId: verifyReservationFlowResource
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/resources/{resource_public_id}/verify
     */
    public async verifyReservationFlowResource(params: Params$verifyReservationFlowResource, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/resources/${encodeURIComponent(params.parameter.resource_public_id)}/verify`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 新機能のオプトイン情報を返す
     * operationId: getReservationFlowMerchantOptIn
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/opt_in
     */
    public async getReservationFlowMerchantOptIn(params: Params$getReservationFlowMerchantOptIn, option?: RequestOption): Promise<Response$getReservationFlowMerchantOptIn$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/opt_in`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 特定のマーチャントの中で初回予約かどうかを判定するAPI
     * operationId: getReservationFlowMerchantReservationStats
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/reservation_stats
     */
    public async getReservationFlowMerchantReservationStats(params: Params$getReservationFlowMerchantReservationStats, option?: RequestOption): Promise<Response$getReservationFlowMerchantReservationStats$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/reservation_stats`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            email: { value: params.parameter.email, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M3の予約ページのTimeSlotsを返す
     * operationId: getReservationFlowEventSchemeTimeSlots
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}/time_slots
     */
    public async getReservationFlowEventSchemeTimeSlots(params: Params$getReservationFlowEventSchemeTimeSlots, option?: RequestOption): Promise<Response$getReservationFlowEventSchemeTimeSlots$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/time_slots`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            year: { value: params.parameter.year, explode: false },
            month: { value: params.parameter.month, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M3の予約ページのTimeSlotを返す
     * operationId: getReservationFlowEventSchemeTimeSlot
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}/time_slots/{time_slot_id}
     */
    public async getReservationFlowEventSchemeTimeSlot(params: Params$getReservationFlowEventSchemeTimeSlot, option?: RequestOption): Promise<Response$getReservationFlowEventSchemeTimeSlot$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/time_slots/${encodeURIComponent(params.parameter.time_slot_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M3の予約ページの情報を返す
     * operationId: getReservationFlowEventSchemeResource
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}
     */
    public async getReservationFlowEventSchemeResource(params: Params$getReservationFlowEventSchemeResource, option?: RequestOption): Promise<Response$getReservationFlowEventSchemeResource$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M3の予約ページでのお客様情報、アンケートの項目を返す
     * operationId: getReservationFlowCustomFields
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/resources/{resource_public_id}/custom_fields
     */
    public async getReservationFlowCustomFields(params: Params$getReservationFlowCustomFields, option?: RequestOption): Promise<Response$getReservationFlowCustomFields$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/resources/${encodeURIComponent(params.parameter.resource_public_id)}/custom_fields`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * resource毎に適切な予約フローバージョンを取得する
     * operationId: getReservationFlowVersion
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/resources/{resource_public_id}/reservation_flow_version
     */
    public async getReservationFlowVersion(params: Params$getReservationFlowVersion, option?: RequestOption): Promise<Response$getReservationFlowVersion$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/resources/${encodeURIComponent(params.parameter.resource_public_id)}/reservation_flow_version`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 予約フローでのmetaタグに必要な内容を返す
     * operationId: getReservationFlowMetaInfo
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/resources/{resource_public_id}/meta_info
     */
    public async getReservationFlowMetaInfo(params: Params$getReservationFlowMetaInfo, option?: RequestOption): Promise<Response$getReservationFlowMetaInfo$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/resources/${encodeURIComponent(params.parameter.resource_public_id)}/meta_info`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M3の予約ページでのお支払い方法の情報を返す
     * operationId: getReservationFlowEventSchemePaymentMethodList
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}/payment_method_list
     */
    public async getReservationFlowEventSchemePaymentMethodList(params: Params$getReservationFlowEventSchemePaymentMethodList, option?: RequestOption): Promise<Response$getReservationFlowEventSchemePaymentMethodList$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/payment_method_list`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            email: { value: params.parameter.email, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M3の予約ページで入力した情報をバリデーションする
     * operationId: validateReservationFlowEventSchemeReservationFormData
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/reservations/validate
     */
    public async validateReservationFlowEventSchemeReservationFormData(params: Params$validateReservationFlowEventSchemeReservationFormData, option?: RequestOption): Promise<Response$validateReservationFlowEventSchemeReservationFormData$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/reservations/validate`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M3の予約ページで入力した情報を用いて予約確定する
     * operationId: finalizeReservationFlowEventSchemeReservationWithFormData
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/reservations/finalize
     */
    public async finalizeReservationFlowEventSchemeReservationWithFormData(params: Params$finalizeReservationFlowEventSchemeReservationWithFormData, option?: RequestOption): Promise<Response$finalizeReservationFlowEventSchemeReservationWithFormData$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/reservations/finalize`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M3の予約ページで入力した情報を用いて予約を確保する。事前決済する予約フローで使用する
     * operationId: holdReservationFlowEventSchemeReservationWithFormData
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/reservations/hold
     */
    public async holdReservationFlowEventSchemeReservationWithFormData(params: Params$holdReservationFlowEventSchemeReservationWithFormData, option?: RequestOption): Promise<Response$holdReservationFlowEventSchemeReservationWithFormData$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/reservations/hold`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 予約の確保後、決済を承認したことを通知する
     * operationId: notifyConfirmedPrepaymentForReservationFlowEventScheme
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/event_scheme/reservations/{reservation_public_id}/notify_confirmed
     */
    public async notifyConfirmedPrepaymentForReservationFlowEventScheme(params: Params$notifyConfirmedPrepaymentForReservationFlowEventScheme, option?: RequestOption): Promise<Response$notifyConfirmedPrepaymentForReservationFlowEventScheme$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/event_scheme/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}/notify_confirmed`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M1・M4の予約ページで入力した情報をバリデーションする
     * operationId: validateReservationFlowCourseSchemeReservationFormData
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/reservations/validate
     */
    public async validateReservationFlowCourseSchemeReservationFormData(params: Params$validateReservationFlowCourseSchemeReservationFormData, option?: RequestOption): Promise<Response$validateReservationFlowCourseSchemeReservationFormData$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/reservations/validate`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M1・M4の予約ページでのメニュー一覧を返す
     * operationId: getReservationFlowCourseSchemeCourses
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/courses
     */
    public async getReservationFlowCourseSchemeCourses(params: Params$getReservationFlowCourseSchemeCourses, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemeCourses$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M1・M4の予約ページでのスタッフ一覧を返す
     * operationId: getReservationFlowCourseSchemeStaffMembers
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/staff_members
     */
    public async getReservationFlowCourseSchemeStaffMembers(params: Params$getReservationFlowCourseSchemeStaffMembers, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemeStaffMembers$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/staff_members`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M1・M4の予約ページで入力した情報を用いて予約確定する
     * operationId: finalizeReservationFlowCourseSchemeReservationFormData
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/reservations/finalize
     */
    public async finalizeReservationFlowCourseSchemeReservationFormData(params: Params$finalizeReservationFlowCourseSchemeReservationFormData, option?: RequestOption): Promise<Response$finalizeReservationFlowCourseSchemeReservationFormData$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/reservations/finalize`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M1・M4の予約ページで入力した情報を用いて予約を確保する。即時決済する予約フローで使用する
     * operationId: holdReservationFlowCourseSchemeReservationFormData
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/reservations/hold
     */
    public async holdReservationFlowCourseSchemeReservationFormData(params: Params$holdReservationFlowCourseSchemeReservationFormData, option?: RequestOption): Promise<Response$holdReservationFlowCourseSchemeReservationFormData$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/reservations/hold`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 予約の確保後、決済を承認したことを通知する
     * operationId: notifyConfirmedPrepaymentForReservationFlowCourseScheme
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/reservations/{reservation_public_id}/notify_confirmed
     */
    public async notifyConfirmedPrepaymentForReservationFlowCourseScheme(params: Params$notifyConfirmedPrepaymentForReservationFlowCourseScheme, option?: RequestOption): Promise<Response$notifyConfirmedPrepaymentForReservationFlowCourseScheme$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}/notify_confirmed`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * M1・M4の予約ページでのお支払い方法の情報を返す
     * operationId: getReservationFlowCourseSchemePaymentMethodList
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/courses/{course_public_id}/payment_method_list
     */
    public async getReservationFlowCourseSchemePaymentMethodList(params: Params$getReservationFlowCourseSchemePaymentMethodList, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemePaymentMethodList$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/payment_method_list`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            email: { value: params.parameter.email, explode: false },
            option_ids: { value: params.parameter.option_ids, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M1・M4の予約ページの情報を返す
     * operationId: getReservationFlowCourseSchemeResource
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}
     */
    public async getReservationFlowCourseSchemeResource(params: Params$getReservationFlowCourseSchemeResource, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemeResource$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * M1・M4の予約ページのまるばつカレンダー表示情報を返す
     * operationId: getReservationFlowCourseSchemeAvailabilityBoard
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/courses/{course_public_id}/availability/board_dates
     */
    public async getReservationFlowCourseSchemeAvailabilityBoard(params: Params$getReservationFlowCourseSchemeAvailabilityBoard, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemeAvailabilityBoard$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/availability/board_dates`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            selected_date: { value: params.parameter.selected_date, explode: false },
            staff_id: { value: params.parameter.staff_id, explode: false },
            option_ids: { value: params.parameter.option_ids, explode: false },
            without_staff_appointment: { value: params.parameter.without_staff_appointment, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M1・M4の予約ページの月カレンダーの月情報を返す
     * operationId: getReservationFlowCourseSchemeAvailabilityCalendarIndex
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/courses/{course_public_id}/availability/calendar_dates
     */
    public async getReservationFlowCourseSchemeAvailabilityCalendarIndex(params: Params$getReservationFlowCourseSchemeAvailabilityCalendarIndex, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemeAvailabilityCalendarIndex$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/availability/calendar_dates`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            selected_date: { value: params.parameter.selected_date, explode: false },
            staff_id: { value: params.parameter.staff_id, explode: false },
            option_ids: { value: params.parameter.option_ids, explode: false },
            without_staff_appointment: { value: params.parameter.without_staff_appointment, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * M1・M4の予約ページの月カレンダーの時間枠情報を返す
     * operationId: getReservationFlowCourseSchemeAvailabilityCalendarTimes
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/courses/{course_public_id}/availability/calendar_dates/{selected_date}/times
     */
    public async getReservationFlowCourseSchemeAvailabilityCalendarTimes(params: Params$getReservationFlowCourseSchemeAvailabilityCalendarTimes, option?: RequestOption): Promise<Response$getReservationFlowCourseSchemeAvailabilityCalendarTimes$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/course_scheme/resources/${encodeURIComponent(params.parameter.resource_public_id)}/courses/${encodeURIComponent(params.parameter.course_public_id)}/availability/calendar_dates/${encodeURIComponent(params.parameter.selected_date)}/times`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            staff_id: { value: params.parameter.staff_id, explode: false },
            option_ids: { value: params.parameter.option_ids, explode: false },
            without_staff_appointment: { value: params.parameter.without_staff_appointment, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 予約の完了後、表示用の詳細情報を取得する
     * operationId: showReservationDetailForReservationFlowEventScheme
     * Request URI: /api/reservation_flow/event_scheme/reservations/{reservation_public_id}
     */
    public async showReservationDetailForReservationFlowEventScheme(params: Params$showReservationDetailForReservationFlowEventScheme, option?: RequestOption): Promise<Response$showReservationDetailForReservationFlowEventScheme$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/event_scheme/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 予約の完了後、詳細情報を取得する
     * operationId: showReservationDetailForReservationFlowCourseScheme
     * Request URI: /api/reservation_flow/course_scheme/reservations/{reservation_public_id}
     */
    public async showReservationDetailForReservationFlowCourseScheme(params: Params$showReservationDetailForReservationFlowCourseScheme, option?: RequestOption): Promise<Response$showReservationDetailForReservationFlowCourseScheme$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/course_scheme/reservations/${encodeURIComponent(params.parameter.reservation_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * ゲスト予約の認証を行う
     * operationId: userReservationGuestSessions
     * Request URI: /users/reservation_guest_sessions
     */
    public async userReservationGuestSessions(params: Params$userReservationGuestSessions, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/users/reservation_guest_sessions`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * ゲストがキャンセル待ちページを参照するための認証に用いる
     * operationId: userTimeSlotWaitingGuestSessions
     * Request URI: /users/time_slot_waiting_guest_sessions
     */
    public async userTimeSlotWaitingGuestSessions(params: Params$userTimeSlotWaitingGuestSessions, option?: RequestOption): Promise<Response$userTimeSlotWaitingGuestSessions$Status$201["application/json"]> {
        const url = this.baseUrl + `/users/time_slot_waiting_guest_sessions`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * reservation token が有効かどうかを判定する
     * operationId: userReservationTokenVerifications
     * Request URI: /users/reservation_token_verifications/{reservation_token}
     */
    public async userReservationTokenVerifications(params: Params$userReservationTokenVerifications, option?: RequestOption): Promise<Response$userReservationTokenVerifications$Status$200["application/json"]> {
        const url = this.baseUrl + `/users/reservation_token_verifications/${encodeURIComponent(params.parameter.reservation_token)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * time_slot_waiting fingerprint が有効かどうかを判定する
     * operationId: userTimeSlotWaitingFingerprintVerifications
     * Request URI: /users/time_slot_waiting_fingerprint_verifications/{fingerprint}
     */
    public async userTimeSlotWaitingFingerprintVerifications(params: Params$userTimeSlotWaitingFingerprintVerifications, option?: RequestOption): Promise<Response$userTimeSlotWaitingFingerprintVerifications$Status$200["application/json"]> {
        const url = this.baseUrl + `/users/time_slot_waiting_fingerprint_verifications/${encodeURIComponent(params.parameter.fingerprint)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 月謝を購入する
     * operationId: purchaseReservationFlowSubscription
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/customer_subscriptions
     */
    public async purchaseReservationFlowSubscription(params: Params$purchaseReservationFlowSubscription, option?: RequestOption): Promise<Response$purchaseReservationFlowSubscription$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/customer_subscriptions`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 月謝の購入フローを開始する
     * operationId: startReservationFlowSubscriptionPurchase
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/customer_subscriptions/purchase/start
     */
    public async startReservationFlowSubscriptionPurchase(params: Params$startReservationFlowSubscriptionPurchase, option?: RequestOption): Promise<Response$startReservationFlowSubscriptionPurchase$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/customer_subscriptions/purchase/start`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 月謝の購入を確定したことを通知する
     * operationId: notifyConfirmedReservationFlowSubscription
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/customer_subscriptions/purchase/notify_confirmed
     */
    public async notifyConfirmedReservationFlowSubscription(params: Params$notifyConfirmedReservationFlowSubscription, option?: RequestOption): Promise<Response$notifyConfirmedReservationFlowSubscription$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/customer_subscriptions/purchase/notify_confirmed`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 月謝の予約可能な回数を返す
     * operationId: getReservationFlowCustomerSubscriptionReservationAvailableCount
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/customer_subscriptions/{customer_subscription_public_id}/available_reservation_count
     */
    public async getReservationFlowCustomerSubscriptionReservationAvailableCount(params: Params$getReservationFlowCustomerSubscriptionReservationAvailableCount, option?: RequestOption): Promise<Response$getReservationFlowCustomerSubscriptionReservationAvailableCount$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/customer_subscriptions/${encodeURIComponent(params.parameter.customer_subscription_public_id)}/available_reservation_count`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            checkin: { value: params.parameter.checkin, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 回数券の購入フローを開始する
     * operationId: startTicketBookPurchase
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/ticket_books/purchase/start
     */
    public async startTicketBookPurchase(params: Params$startTicketBookPurchase, option?: RequestOption): Promise<Response$startTicketBookPurchase$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/ticket_books/purchase/start`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 回数券の購入を確定したことを通知する
     * operationId: notifyConfirmedTicketBookPurchase
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/ticket_books/purchase/notify_confirmed
     */
    public async notifyConfirmedTicketBookPurchase(params: Params$notifyConfirmedTicketBookPurchase, option?: RequestOption): Promise<Response$notifyConfirmedTicketBookPurchase$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/ticket_books/purchase/notify_confirmed`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 回数券の予約可能な回数を返す
     * operationId: getReservationFlowTicketBookReservationAvailableCount
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/ticket_books/{ticket_book_public_id}/available_reservation_count
     */
    public async getReservationFlowTicketBookReservationAvailableCount(params: Params$getReservationFlowTicketBookReservationAvailableCount, option?: RequestOption): Promise<Response$getReservationFlowTicketBookReservationAvailableCount$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/ticket_books/${encodeURIComponent(params.parameter.ticket_book_public_id)}/available_reservation_count`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            checkin: { value: params.parameter.checkin, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 月謝回数券の詳細情報を取得する
     * operationId: getReservationFlowProduct
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/products/{product_public_id}
     */
    public async getReservationFlowProduct(params: Params$getReservationFlowProduct, option?: RequestOption): Promise<Response$getReservationFlowProduct$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/products/${encodeURIComponent(params.parameter.product_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * パスワード付き月謝回数券の認証
     * operationId: postReservationFlowProductVerify
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/products/{product_public_id}/verify
     */
    public async postReservationFlowProductVerify(params: Params$postReservationFlowProductVerify, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/products/${encodeURIComponent(params.parameter.product_public_id)}/verify`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 予約フローの同時アクセス数が最大値に達しているか判定する
     * operationId: postReservationFlowMerchantThrottle
     * Request URI: /api/reservation_flow/merchants/{merchant_public_id}/throttle
     */
    public async postReservationFlowMerchantThrottle(params: Params$postReservationFlowMerchantThrottle, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/reservation_flow/merchants/${encodeURIComponent(params.parameter.merchant_public_id)}/throttle`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * 請求書払いのプラン申し込み
     * operationId: apiDashboardCreateBillingRequest
     * Request URI: /api/dashboard/billing_requests
     */
    public async apiDashboardCreateBillingRequest(params: Params$apiDashboardCreateBillingRequest, option?: RequestOption): Promise<Response$apiDashboardCreateBillingRequest$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/billing_requests`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 他店舗に入った予約によるブロックを取得する
     * operationId: getBlockByOtherMerchantsReservations
     * Request URI: /api/dashboard/block_by_other_merchants_reservations
     */
    public async getBlockByOtherMerchantsReservations(params: Params$getBlockByOtherMerchantsReservations, option?: RequestOption): Promise<Response$getBlockByOtherMerchantsReservations$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/block_by_other_merchants_reservations`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            start_at: { value: params.parameter.start_at, explode: false },
            end_at: { value: params.parameter.end_at, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get line message usage
     * operationId: getLineMessageUsage
     * Request URI: /api/dashboard/line/messaging_api/line_message_usage
     */
    public async getLineMessageUsage(option?: RequestOption): Promise<Response$getLineMessageUsage$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_message_usage`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get message usage
     * operationId: getMessageUsage
     * Request URI: /api/dashboard/line/messaging_api/message_usage
     */
    public async getMessageUsage(option?: RequestOption): Promise<Response$getMessageUsage$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/message_usage`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * upload line_message_image
     * operationId: uploadLineMessageImage
     * Request URI: /api/dashboard/line/messaging_api/line_message_images
     */
    public async uploadLineMessageImage(params: Params$uploadLineMessageImage, option?: RequestOption): Promise<Response$uploadLineMessageImage$Status$201["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_message_images`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get line messages
     * operationId: getLineMessages
     * Request URI: /api/dashboard/line/messaging_api/line_messages
     */
    public async getLineMessages(params: Params$getLineMessages, option?: RequestOption): Promise<Response$getLineMessages$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            status: { value: params.parameter.status, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * create line_message
     * line_messageを作成する
     * operationId: createLineMessage
     * Request URI: /api/dashboard/line/messaging_api/line_messages
     */
    public async createLineMessage(params: Params$createLineMessage, option?: RequestOption): Promise<Response$createLineMessage$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * deliver line message
     * operationId: deliverLineMessage
     * Request URI: /api/dashboard/line/messaging_api/line_messages/{line_message_id}/deliver
     */
    public async deliverLineMessage(params: Params$deliverLineMessage, option?: RequestOption): Promise<Response$deliverLineMessage$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages/${encodeURIComponent(params.parameter.line_message_id)}/deliver`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get LineMessage
     * operationId: getLineMessage
     * Request URI: /api/dashboard/line/messaging_api/line_messages/{line_message_id}
     */
    public async getLineMessage(params: Params$getLineMessage, option?: RequestOption): Promise<Response$getLineMessage$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages/${encodeURIComponent(params.parameter.line_message_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * delete draft line message
     * line messageの下書きを削除する
     *
     * operationId: deleteDraftLineMessage
     * Request URI: /api/dashboard/line/messaging_api/line_messages/{line_message_id}
     */
    public async deleteDraftLineMessage(params: Params$deleteDraftLineMessage, option?: RequestOption): Promise<Response$deleteDraftLineMessage$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages/${encodeURIComponent(params.parameter.line_message_id)}`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * draft line message
     * line messageの下書きを更新する
     *
     * operationId: updateDraftLineMessage
     * Request URI: /api/dashboard/line/messaging_api/line_messages/{line_message_id}/draft
     */
    public async updateDraftLineMessage(params: Params$updateDraftLineMessage, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages/${encodeURIComponent(params.parameter.line_message_id)}/draft`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * LINEメッセージの新規配信時に送信先候補を取得するために利用
     * operationId: getLineMessageRecipientCandidates
     * Request URI: /api/dashboard/line/messaging_api/line_messages/{line_message_id}/recipient_candidates
     */
    public async getLineMessageRecipientCandidates(params: Params$getLineMessageRecipientCandidates, option?: RequestOption): Promise<Response$getLineMessageRecipientCandidates$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages/${encodeURIComponent(params.parameter.line_message_id)}/recipient_candidates`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * LINEメッセージの送信先を取得するために利用
     * operationId: getLineMessageRecipients
     * Request URI: /api/dashboard/line/messaging_api/line_messages/{line_message_id}/recipients
     */
    public async getLineMessageRecipients(params: Params$getLineMessageRecipients, option?: RequestOption): Promise<Response$getLineMessageRecipients$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/line_messages/${encodeURIComponent(params.parameter.line_message_id)}/recipients`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * Request LINE Messaging API Channel Secret Verification
     * LINE Messaging APIのチャンネルシークレットの検証を行う
     *
     * operationId: lineMessagingAPIChannelSecretVerification
     * Request URI: /api/dashboard/line/messaging_api/secret_verification
     */
    public async lineMessagingAPIChannelSecretVerification(params: Params$lineMessagingAPIChannelSecretVerification, option?: RequestOption): Promise<Response$lineMessagingAPIChannelSecretVerification$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/secret_verification`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 現在登録されているチャネルシークレットを取得する
     * operationId: getLineMessageChannelSecret
     * Request URI: /api/dashboard/line/messaging_api/secret
     */
    public async getLineMessageChannelSecret(option?: RequestOption): Promise<Response$getLineMessageChannelSecret$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/secret`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 現在登録されているチャネルシークレットを削除する
     * operationId: deleteLineMessageChannelSecret
     * Request URI: /api/dashboard/line/messaging_api/secret
     */
    public async deleteLineMessageChannelSecret(params: Params$deleteLineMessageChannelSecret, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/secret`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * Request LINE Messaging API Channel Secret Registration
     * LINE Messaging APIのチャンネルシークレットの登録・更新を行う
     *
     * operationId: lineMessagingAPIChannelSecretRegistration
     * Request URI: /api/dashboard/line/messaging_api/secret_registration
     */
    public async lineMessagingAPIChannelSecretRegistration(params: Params$lineMessagingAPIChannelSecretRegistration, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/secret_registration`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * LINE Messaging API Testerの登録・更新
     * operationId: createOrUpdateTester
     * Request URI: /api/dashboard/line/messaging_api/tester_registration
     */
    public async createOrUpdateTester(params: Params$createOrUpdateTester, option?: RequestOption): Promise<Response$createOrUpdateTester$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/tester_registration`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get line messaging api availability
     * LINE Messaging API を利用可能かどうかを取得する
     * operationId: getLineMessagingApiAvailability
     * Request URI: /api/dashboard/line/messaging_api/availability
     */
    public async getLineMessagingApiAvailability(option?: RequestOption): Promise<Response$getLineMessagingApiAvailability$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/availability`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * LINEメッセージ連携の状態を返す
     * operationId: getLineMessagingApiIntegrationStatus
     * Request URI: /api/dashboard/line/messaging_api/integration_status
     */
    public async getLineMessagingApiIntegrationStatus(option?: RequestOption): Promise<Response$getLineMessagingApiIntegrationStatus$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/integration_status`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * LINE Messaging APIのチャンネル情報を返す
     * operationId: getLineMessagingApiChannelInfo
     * Request URI: /api/dashboard/line/messaging_api/channel_info
     */
    public async getLineMessagingApiChannelInfo(option?: RequestOption): Promise<Response$getLineMessagingApiChannelInfo$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/line/messaging_api/channel_info`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 現在ログイン中のアカウントで操作可能な店舗と、そのアカウントと店舗の関連に紐づく情報のリストを返す
     * operationId: apiDashboardListOperableShops
     * Request URI: /api/dashboard/operable_shops
     */
    public async apiDashboardListOperableShops(params: Params$apiDashboardListOperableShops, option?: RequestOption): Promise<Response$apiDashboardListOperableShops$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/operable_shops`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            size: { value: params.parameter.size, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 自身がなんらかの権限を持つ店舗のリストを返す
     * operationId: apiDashboardListShops
     * Request URI: /api/dashboard/shops
     */
    public async apiDashboardListShops(params: Params$apiDashboardListShops, option?: RequestOption): Promise<Response$apiDashboardListShops$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/shops`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            page: { value: params.parameter.page, explode: false },
            size: { value: params.parameter.size, explode: false },
            started: { value: params.parameter.started, explode: false },
            business_entity_platform_id: { value: params.parameter.business_entity_platform_id, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * ログインユーザーがアクセス可能なダッシュボードを返す
     * operationId: apiDashboardDashboardAccessibilities
     * Request URI: /api/dashboard/dashboard_accessibilities
     */
    public async apiDashboardDashboardAccessibilities(params: Params$apiDashboardDashboardAccessibilities, option?: RequestOption): Promise<Response$apiDashboardDashboardAccessibilities$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/dashboard_accessibilities`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            business_entity_platform_id: { value: params.parameter.business_entity_platform_id, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 自身がなんらかの権限を持つ店舗の情報を返す
     * operationId: apiDashboardGetShop
     * Request URI: /api/dashboard/shops/{shop_platform_id}
     */
    public async apiDashboardGetShop(params: Params$apiDashboardGetShop, option?: RequestOption): Promise<Response$apiDashboardGetShop$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/shops/${encodeURIComponent(params.parameter.shop_platform_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 現在のセッションで選択している店舗を変更する
     * operationId: apiDashboardSelectShop
     * Request URI: /api/dashboard/shops/{shop_platform_id}/select
     */
    public async apiDashboardSelectShop(params: Params$apiDashboardSelectShop, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/shops/${encodeURIComponent(params.parameter.shop_platform_id)}/select`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * 対象の店舗に最低限の権限を持つ(reserve.base)従業員一覧を返す
     * operationId: apiDashboardListEmployees
     * Request URI: /api/dashboard/employees
     */
    public async apiDashboardListEmployees(params: Params$apiDashboardListEmployees, option?: RequestOption): Promise<Response$apiDashboardListEmployees$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/employees`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            first: { value: params.parameter.first, explode: false },
            after: { value: params.parameter.after, explode: false },
            staff_registered: { value: params.parameter.staff_registered, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 自身がなんらかの権限を持つ事業者のリストを返す
     * operationId: apiDashboardListBusinessEntities
     * Request URI: /api/dashboard/business_entities
     */
    public async apiDashboardListBusinessEntities(option?: RequestOption): Promise<Response$apiDashboardListBusinessEntities$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/business_entities`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 自身がなんらかの権限を持つ事業者の情報を返す
     * operationId: apiDashboardGetBusinessEntity
     * Request URI: /api/dashboard/business_entities/{business_entity_platform_id}
     */
    public async apiDashboardGetBusinessEntity(params: Params$apiDashboardGetBusinessEntity, option?: RequestOption): Promise<Response$apiDashboardGetBusinessEntity$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/business_entities/${encodeURIComponent(params.parameter.business_entity_platform_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 権限を持つ事業者をログイン対象とし、session[:business_entity_id]に事業者IDをセットする
     * operationId: apiDashboardSelectBusinessEntity
     * Request URI: /api/dashboard/business_entities/{business_entity_platform_id}/select
     */
    public async apiDashboardSelectBusinessEntity(params: Params$apiDashboardSelectBusinessEntity, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/business_entities/${encodeURIComponent(params.parameter.business_entity_platform_id)}/select`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * 現在ログイン中のマーチャントのassign_schemeの予約ページ一覧を返す
     * operationId: apiDashboardListAssignSchemeResources
     * Request URI: /api/dashboard/assign_scheme_resources
     */
    public async apiDashboardListAssignSchemeResources(option?: RequestOption): Promise<Response$apiDashboardListAssignSchemeResources$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/assign_scheme_resources`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * Google予約の利用申し込み
     * operationId: apiDashboardCreateGoogleReserveRequest
     * Request URI: /api/dashboard/google_reserve_request
     */
    public async apiDashboardCreateGoogleReserveRequest(params: Params$apiDashboardCreateGoogleReserveRequest, option?: RequestOption): Promise<Response$apiDashboardCreateGoogleReserveRequest$Status$201["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/google_reserve_request`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * 現在ログイン中のマーチャントのkanzashi連携対象の予約ページ情報を返す
     * operationId: apiDashboardListKanzashiIntegratedResources
     * Request URI: /api/dashboard/kanzashi/kanzashi_integrated_resource
     */
    public async apiDashboardListKanzashiIntegratedResources(option?: RequestOption): Promise<Response$apiDashboardListKanzashiIntegratedResources$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/kanzashi/kanzashi_integrated_resource`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * プランの請求情報を返す
     * operationId: apiDashboardGetPlanUpgrades
     * Request URI: /api/dashboard/plan_subscriptions/{plan_name}
     */
    public async apiDashboardGetPlanUpgrades(params: Params$apiDashboardGetPlanUpgrades, option?: RequestOption): Promise<Response$apiDashboardGetPlanUpgrades$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/plan_subscriptions/${encodeURIComponent(params.parameter.plan_name)}`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            campaign_code: { value: params.parameter.campaign_code, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 現在ログイン中のマーチャントのスマートリスト一覧を取得する
     * operationId: apiDashboardListSmartLists
     * Request URI: /api/dashboard/smart_lists
     */
    public async apiDashboardListSmartLists(option?: RequestOption): Promise<Response$apiDashboardListSmartLists$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_lists`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * スマートリストを作成する
     * operationId: apiDashboardCreateSmartList
     * Request URI: /api/dashboard/smart_lists
     */
    public async apiDashboardCreateSmartList(params: Params$apiDashboardCreateSmartList, option?: RequestOption): Promise<Response$apiDashboardCreateSmartList$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_lists`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * スマートリストを削除する
     * operationId: apiDashboardDeleteSmartList
     * Request URI: /api/dashboard/smart_lists/{smart_list_id}
     */
    public async apiDashboardDeleteSmartList(params: Params$apiDashboardDeleteSmartList, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/smart_lists/${encodeURIComponent(params.parameter.smart_list_id)}`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * スマートリストを更新する
     * operationId: apiDashboardUpdateSmartList
     * Request URI: /api/dashboard/smart_lists/{smart_list_id}
     */
    public async apiDashboardUpdateSmartList(params: Params$apiDashboardUpdateSmartList, option?: RequestOption): Promise<Response$apiDashboardUpdateSmartList$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_lists/${encodeURIComponent(params.parameter.smart_list_id)}`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * マーチャントのメールアドレスの変更申請を作成する
     * operationId: apiDashboardMerchantsCreatePrimaryEmailUpdateRequest
     * Request URI: /api/dashboard/merchants/primary_email_update_request
     */
    public async apiDashboardMerchantsCreatePrimaryEmailUpdateRequest(params: Params$apiDashboardMerchantsCreatePrimaryEmailUpdateRequest, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/merchants/primary_email_update_request`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * マーチャントのAPIキークレデンシャルを取得する
     * operationId: apiDashboardMerchantsGetApiKeyCredential
     * Request URI: /api/dashboard/merchants/api_key_credential
     */
    public async apiDashboardMerchantsGetApiKeyCredential(params: Params$apiDashboardMerchantsGetApiKeyCredential, option?: RequestOption): Promise<Response$apiDashboardMerchantsGetApiKeyCredential$Status$200["text/plain"]> {
        const url = this.baseUrl + `/api/dashboard/merchants/api_key_credential`;
        const headers = {
            Accept: "text/plain",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * staff management
     * スタッフ管理の情報を取得する
     * operationId: getStaffManagement
     * Request URI: /api/dashboard/merchants/staff_management.json
     */
    public async getStaffManagement(option?: RequestOption): Promise<Response$getStaffManagement$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/merchants/staff_management.json`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * プラットフォームの従業員をbulkでスタッフとして登録する
     * operationId: apiDashboardMerchantsBulkCreateStaff
     * Request URI: /api/dashboard/merchants/staff/bulk_create
     */
    public async apiDashboardMerchantsBulkCreateStaff(params: Params$apiDashboardMerchantsBulkCreateStaff, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/merchants/staff/bulk_create`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 加盟店の特商法内容を取得する
     * operationId: apiDashboardMerchantsLegalNoticeShow
     * Request URI: /api/dashboard/merchants/legal_notice
     */
    public async apiDashboardMerchantsLegalNoticeShow(option?: RequestOption): Promise<Response$apiDashboardMerchantsLegalNoticeShow$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/merchants/legal_notice`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 加盟店の特商法内容を更新する
     * operationId: apiDashboardMerchantsLegalNoticePatch
     * Request URI: /api/dashboard/merchants/legal_notice
     */
    public async apiDashboardMerchantsLegalNoticePatch(params: Params$apiDashboardMerchantsLegalNoticePatch, option?: RequestOption): Promise<Response$apiDashboardMerchantsLegalNoticePatch$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/merchants/legal_notice`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get smart list message automations
     * operationId: getSmartListMessageAutomations
     * Request URI: /api/dashboard/smart_list_message_automations
     */
    public async getSmartListMessageAutomations(params: Params$getSmartListMessageAutomations, option?: RequestOption): Promise<Response$getSmartListMessageAutomations$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automations`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            type: { value: params.parameter.type, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * create smart list message automation
     * operationId: createSmartListMessageAutomation
     * Request URI: /api/dashboard/smart_list_message_automations
     */
    public async createSmartListMessageAutomation(params: Params$createSmartListMessageAutomation, option?: RequestOption): Promise<Response$createSmartListMessageAutomation$Status$201["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automations`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * get smart list message automation
     * operationId: getSmartListMessageAutomation
     * Request URI: /api/dashboard/smart_list_message_automations/{smart_list_message_automation_id}
     */
    public async getSmartListMessageAutomation(params: Params$getSmartListMessageAutomation, option?: RequestOption): Promise<Response$getSmartListMessageAutomation$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automations/${encodeURIComponent(params.parameter.smart_list_message_automation_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * delete smart list message automation
     * operationId: deleteSmartListMessageAutomation
     * Request URI: /api/dashboard/smart_list_message_automations/{smart_list_message_automation_id}
     */
    public async deleteSmartListMessageAutomation(params: Params$deleteSmartListMessageAutomation, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automations/${encodeURIComponent(params.parameter.smart_list_message_automation_id)}`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "DELETE",
            url,
            headers
        }, option);
    }
    /**
     * update smart list message automation
     * operationId: updateSmartListMessageAutomation
     * Request URI: /api/dashboard/smart_list_message_automations/{smart_list_message_automation_id}
     */
    public async updateSmartListMessageAutomation(params: Params$updateSmartListMessageAutomation, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automations/${encodeURIComponent(params.parameter.smart_list_message_automation_id)}`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * upload smart list message automation images
     * operationId: uploadSmartListMessageAutomationImage
     * Request URI: /api/dashboard/smart_list_message_automation_images
     */
    public async uploadSmartListMessageAutomationImage(params: Params$uploadSmartListMessageAutomationImage, option?: RequestOption): Promise<Response$uploadSmartListMessageAutomationImage$Status$201["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automation_images`;
        const headers = {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        const queryParameters: QueryParameters = {
            type: { value: params.parameter.type, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get smart list message automation status
     * operationId: getSmartListMessageAutomationStatus
     * Request URI: /api/dashboard/smart_list_message_automation_status
     */
    public async getSmartListMessageAutomationStatus(option?: RequestOption): Promise<Response$getSmartListMessageAutomationStatus$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/smart_list_message_automation_status`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * get availabilities
     * operationId: getAvailabilities
     * Request URI: /api/dashboard/resources/{resource_public_id}/availabilities
     */
    public async getAvailabilities(params: Params$getAvailabilities, option?: RequestOption): Promise<Response$getAvailabilities$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/resources/${encodeURIComponent(params.parameter.resource_public_id)}/availabilities`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            date: { value: params.parameter.date, explode: false },
            course_id: { value: params.parameter.course_id, explode: false },
            "option_ids[]": { value: params.parameter["option_ids[]"], explode: false },
            reservation_id: { value: params.parameter.reservation_id, explode: false },
            staff_id: { value: params.parameter.staff_id, explode: false },
            via: { value: params.parameter.via, explode: false },
            state: { value: params.parameter.state, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * get slide setting
     * operationId: getResourceSlideSetting
     * Request URI: /api/dashboard/resources/{resource_public_id}/slide_setting
     */
    public async getResourceSlideSetting(params: Params$getResourceSlideSetting, option?: RequestOption): Promise<Response$getResourceSlideSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/resources/${encodeURIComponent(params.parameter.resource_public_id)}/slide_setting`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * update slide time unit
     * operationId: updateResourceSlideSetting
     * Request URI: /api/dashboard/resources/{resource_public_id}/slide_setting
     */
    public async updateResourceSlideSetting(params: Params$updateResourceSlideSetting, option?: RequestOption): Promise<Response$updateResourceSlideSetting$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/resources/${encodeURIComponent(params.parameter.resource_public_id)}/slide_setting`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 事業者がすでに存在する場合のMaja 1:1連携で、連携に必要な情報を返す
     * operationId: apiBusinessEntitySystemUpgrade
     * Request URI: /api/dashboard/business_entity_system_upgrade
     */
    public async apiBusinessEntitySystemUpgrade(option?: RequestOption): Promise<Response$apiBusinessEntitySystemUpgrade$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/business_entity_system_upgrade`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 指定されたmerchantとmaja shopを連携する
     * operationId: postBusinessEntitySystemUpgrade
     * Request URI: /api/dashboard/business_entity_system_upgrade
     */
    public async postBusinessEntitySystemUpgrade(params: Params$postBusinessEntitySystemUpgrade, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/business_entity_system_upgrade`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * 月謝を取得する
     * 月謝を取得する
     * operationId: getSubscription
     * Request URI: /api/dashboard/subscriptions/{product_public_id}
     */
    public async getSubscription(params: Params$getSubscription, option?: RequestOption): Promise<Response$getSubscription$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/subscriptions/${encodeURIComponent(params.parameter.product_public_id)}`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 月謝を更新する
     * 月謝を更新する
     * operationId: updateSubscription
     * Request URI: /api/dashboard/subscriptions/{product_public_id}
     */
    public async updateSubscription(params: Params$updateSubscription, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/subscriptions/${encodeURIComponent(params.parameter.product_public_id)}`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * upsert franchisee_business_profiles
     * operationId: patchFranchiseeBusinessProfiles
     * Request URI: /api/dashboard/franchisee_business_profile
     */
    public async patchFranchiseeBusinessProfiles(params: Params$patchFranchiseeBusinessProfiles, option?: RequestOption): Promise<Response$patchFranchiseeBusinessProfiles$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/franchisee_business_profile`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "PATCH",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * maja移行対象のマーチャントかチェックする
     * operationId: apiDashboardBusinessEntitySystemUpgradeCheck
     * Request URI: /api/dashboard/business_entity_system_upgrade_check
     */
    public async apiDashboardBusinessEntitySystemUpgradeCheck(option?: RequestOption): Promise<Response$apiDashboardBusinessEntitySystemUpgradeCheck$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/business_entity_system_upgrade_check`;
        const headers = {
            Accept: "application/json"
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * create reservations csv
     * operationId: createReservationsCSV
     * Request URI: /api/dashboard/reservations/csv_export
     */
    public async createReservationsCSV(params: Params$createReservationsCSV, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/api/dashboard/reservations/csv_export`;
        const headers = {
            "Content-Type": "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers,
            requestBody: params.requestBody
        }, option);
    }
    /**
     * stoggle による feature toggle の状態を取得する
     * stoggle による feature toggle の状態を取得する
     * operationId: getFeatureToggle
     * Request URI: /api/dashboard/feature_toggles
     */
    public async getFeatureToggle(params: Params$getFeatureToggle, option?: RequestOption): Promise<Response$getFeatureToggle$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/feature_toggles`;
        const headers = {
            Accept: "application/json"
        };
        const queryParameters: QueryParameters = {
            feature_name: { value: params.parameter.feature_name, explode: false },
            target: { value: params.parameter.target, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 入金予定額を取得
     * 過去は入金予定額の取得には /m/settings/stripe_payouts/expected_payout_list を使用しており、パス通りStripe専用だったが、事前決済をStripeからGMO PGに移行するのに伴ってどちらの事前決済でも利用できる汎用化されたAPIを新設した
     * operationId: ExpectedTransfers
     * Request URI: /api/dashboard/settings/expected_transfers
     */
    public async ExpectedTransfers(params: Params$ExpectedTransfers, option?: RequestOption): Promise<Response$ExpectedTransfers$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/settings/expected_transfers`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * 入金明細を取得
     * 過去は入金明細の取得には /m/settings/stripe_payouts/payout_list を使用しており、パス通りStripe専用だったが、事前決済をStripeからGMO PGに移行するのに伴ってどちらの事前決済でも利用できる汎用化されたAPIを新設した
     * operationId: CompletedTransfers
     * Request URI: /api/dashboard/settings/completed_transfers
     */
    public async CompletedTransfers(params: Params$CompletedTransfers, option?: RequestOption): Promise<Response$CompletedTransfers$Status$200["application/json"]> {
        const url = this.baseUrl + `/api/dashboard/settings/completed_transfers`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * Get stores id temporary identity
     * operationId: getStoresIdTemporaryIdentity
     * Request URI: /stores_id/temporary_identity
     */
    public async getStoresIdTemporaryIdentity(params: Params$getStoresIdTemporaryIdentity, option?: RequestOption): Promise<Response$getStoresIdTemporaryIdentity$Status$200["application/json"]> {
        const url = this.baseUrl + `/stores_id/temporary_identity`;
        const headers = {
            Accept: "application/json",
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers
        }, option);
    }
    /**
     * Create a reserve account with information temporarily saved on the session
     * operationId: createStoresIdReserveAccount
     * Request URI: /stores_id/reserve_account
     */
    public async createStoresIdReserveAccount(params: Params$createStoresIdReserveAccount, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/stores_id/reserve_account`;
        const headers = {
            "X-Csrf-Token": params.parameter["X-Csrf-Token"]
        };
        return this.apiClient.request({
            httpMethod: "POST",
            url,
            headers
        }, option);
    }
    /**
     * マーチャントのメールアドレスの変更申請をマーチャントに反映する
     * operationId: webDashboardMerchantsApplyPrimaryEmailUpdateRequest
     * Request URI: /web/dashboard/merchants/primary_email_update_request/apply
     */
    public async webDashboardMerchantsApplyPrimaryEmailUpdateRequest(params: Params$webDashboardMerchantsApplyPrimaryEmailUpdateRequest, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/web/dashboard/merchants/primary_email_update_request/apply`;
        const headers = {};
        const queryParameters: QueryParameters = {
            token: { value: params.parameter.token, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 顧客の購入履歴のCSVを出力する
     * operationId: webDashboardCustomersPurchaseCsv
     * Request URI: /web/dashboard/customers/{customer_public_id}/purchase_csv
     */
    public async webDashboardCustomersPurchaseCsv(params: Params$webDashboardCustomersPurchaseCsv, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/web/dashboard/customers/${encodeURIComponent(params.parameter.customer_public_id)}/purchase_csv`;
        const headers = {};
        const queryParameters: QueryParameters = {
            encoding: { value: params.parameter.encoding, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
    /**
     * 指定されたtokenを元に、短期間のセッションを発行する
     * operationId: applyWebviewToken
     * Request URI: /web/webview_tokens/apply
     */
    public async applyWebviewToken(params: Params$applyWebviewToken, option?: RequestOption): Promise<void> {
        const url = this.baseUrl + `/web/webview_tokens/apply`;
        const headers = {
            "X-Webview-Token": params.parameter["X-Webview-Token"]
        };
        const queryParameters: QueryParameters = {
            to: { value: params.parameter.to, explode: false }
        };
        return this.apiClient.request({
            httpMethod: "GET",
            url,
            headers,
            queryParameters: queryParameters
        }, option);
    }
}
